
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("7nnPp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $55ed2a2e9aa38bb0$var$_react = $55ed2a2e9aa38bb0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $55ed2a2e9aa38bb0$var$_error = $55ed2a2e9aa38bb0$var$_interopRequireDefault((parcelRequire("hMVoD")));
function $55ed2a2e9aa38bb0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $55ed2a2e9aa38bb0$var$ErrorIcon = (props)=>/*#__PURE__*/ $55ed2a2e9aa38bb0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M13.416 4.417a2 2 0 0 0-2.832 0l-6.168 6.167a2 2 0 0 0 0 2.833l6.168 6.167a2 2 0 0 0 2.832 0l6.168-6.167a2 2 0 0 0 0-2.833z"/><path fill="inherit" d="M12 14a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $55ed2a2e9aa38bb0$var$_error.default
    }));
$55ed2a2e9aa38bb0$var$ErrorIcon.displayName = 'ErrorIcon';
var $55ed2a2e9aa38bb0$var$_default = module.exports.default = $55ed2a2e9aa38bb0$var$ErrorIcon;

});
parcelRegister("c7fbr", function(module, exports) {

$parcel$export(module.exports, "IconFacade", () => $523f3deb115b4b70$export$3cfb73f70dfca966);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $5LWLA = parcelRequire("5LWLA");
const $523f3deb115b4b70$var$sizeSpacingMap = {
    utility: {
        small: 'compact',
        medium: 'spacious'
    },
    core: {
        small: 'none',
        medium: 'spacious'
    }
};
const $523f3deb115b4b70$export$3cfb73f70dfca966 = /*#__PURE__*/ (0, $5uXOq.memo)(function IconFacade({ dangerouslySetGlyph: dangerouslySetGlyph, ...props }) {
    const NewIcon = props.newIcon;
    // By default, the icon size will be medium for core icons and small for utility icons
    const size = props.size ?? 'medium';
    const useNewIcon = !props.isFacadeDisabled && // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    (0, $VSDnB.fg)('platform-visual-refresh-icons-legacy-facade');
    if (useNewIcon && NewIcon && (size === 'small' || size === 'medium')) {
        if (props.iconType === 'utility') {
            const Icon = NewIcon;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props,
                spacing: (0, $VSDnB.fg)('platform-visual-refresh-icons-facade-button-fix') ? $523f3deb115b4b70$var$sizeSpacingMap['utility'][size] : 'none',
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            });
        } else {
            const Icon = NewIcon;
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props,
                spacing: $523f3deb115b4b70$var$sizeSpacingMap['core'][size],
                color: props.primaryColor || 'currentColor',
                type: props.iconType
            });
        }
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5LWLA.Icon), {
        dangerouslySetGlyph: dangerouslySetGlyph,
        ...props
    });
});

});
parcelRegister("5LWLA", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $a14b10e55a016d23$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $a14b10e55a016d23$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $bxFwL = parcelRequire("bxFwL");

var $cxNi9 = parcelRequire("cxNi9");
function $a14b10e55a016d23$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a14b10e55a016d23$var$iconStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    display: 'inline-block',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> svg': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        ...(0, $bxFwL.commonSVGStyles),
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    }
});
/**
 * For windows high contrast mode
 */ const $a14b10e55a016d23$var$baseHcmStyles = {
    name: "tdbe8",
    styles: "@media screen and (forced-colors: active){> svg{filter:grayscale(1);--icon-primary-color:CanvasText;--icon-secondary-color:Canvas;}}"
};
const $a14b10e55a016d23$var$primaryEqualsSecondaryHcmStyles = {
    name: "1pgb0eo",
    styles: "@media screen and (forced-colors: active){> svg{--icon-primary-color:Canvas;}}"
};
const $a14b10e55a016d23$var$secondaryTransparentHcmStyles = {
    name: "s2qd3p",
    styles: "@media screen and (forced-colors: active){> svg{--icon-secondary-color:transparent;}}"
};
const $a14b10e55a016d23$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.memo)(function Icon(props) {
    const { glyph: Glyph, dangerouslySetGlyph: dangerouslySetGlyph, primaryColor: primaryColor = 'currentColor', secondaryColor: secondaryColor, size: size, testId: testId, label: label, width: width, height: height, UNSAFE_margin: UNSAFE_margin } = props;
    const glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? /*#__PURE__*/ (0, $f8Sb3.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    const dimensions = (0, $bxFwL.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        "data-vc": `icon-${testId}`,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            '--icon-secondary-color': secondaryColor || (0, $cxNi9.getBackground)(),
            margin: UNSAFE_margin
        },
        ...glyphProps,
        css: [
            $a14b10e55a016d23$var$iconStyles,
            $a14b10e55a016d23$var$baseHcmStyles,
            primaryColor === secondaryColor && $a14b10e55a016d23$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $a14b10e55a016d23$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $f8Sb3.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                '> svg': dimensions
            })
        ]
    });
});
var $a14b10e55a016d23$export$2e2bcd8739ae039 = $a14b10e55a016d23$export$f04a61298a47a40f;

});
parcelRegister("bxFwL", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", () => $8260f01b9cef63d2$export$16374db1c3e6dfba);
$parcel$export(module.exports, "sizeStyleMap", () => $8260f01b9cef63d2$export$ef0ad74202575b64);
$parcel$export(module.exports, "getIconSize", () => $8260f01b9cef63d2$export$3eb7d6130acfda37);

var $5owSH = parcelRequire("5owSH");

var $f8Sb3 = parcelRequire("f8Sb3");
const $8260f01b9cef63d2$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $8260f01b9cef63d2$var$smallStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $5owSH.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $8260f01b9cef63d2$var$mediumStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $5owSH.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $8260f01b9cef63d2$var$largeStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $5owSH.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $8260f01b9cef63d2$var$xlargeStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $5owSH.dimensions).xlarge);
const $8260f01b9cef63d2$export$ef0ad74202575b64 = {
    small: $8260f01b9cef63d2$var$smallStyles,
    medium: $8260f01b9cef63d2$var$mediumStyles,
    large: $8260f01b9cef63d2$var$largeStyles,
    xlarge: $8260f01b9cef63d2$var$xlargeStyles
};
const $8260f01b9cef63d2$export$3eb7d6130acfda37 = ({ width: width, height: height, size: size })=>{
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $5owSH.dimensions)[size];
    return undefined;
};

});
parcelRegister("5owSH", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7ad0abb26ad673d7$export$c647cb0ee6e282fe);
$parcel$export(module.exports, "dimensions", () => $7ad0abb26ad673d7$export$62ad7b0c781000e9);
const $7ad0abb26ad673d7$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $7ad0abb26ad673d7$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $7ad0abb26ad673d7$export$62ad7b0c781000e9 = {
    small: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge
    }
};

});


parcelRegister("cxNi9", function(module, exports) {

$parcel$export(module.exports, "getBackground", () => $0d2a80dba5ed6a44$export$18cb9425622d4e06);
const $0d2a80dba5ed6a44$export$18cb9425622d4e06 = ()=>"var(--ds-surface, #FFFFFF)";

});



parcelRegister("hMVoD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::257fef37d04db299e24e95484ff9b12f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf33711b0175a169$var$_react = $cf33711b0175a169$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cf33711b0175a169$var$_baseNew = $cf33711b0175a169$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $cf33711b0175a169$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf33711b0175a169$var$ErrorIcon = (props)=>/*#__PURE__*/ $cf33711b0175a169$var$_react.default.createElement($cf33711b0175a169$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.586.604a2 2 0 0 1 2.828 0l5.982 5.982a2 2 0 0 1 0 2.828l-5.982 5.983a2 2 0 0 1-2.828 0L.604 9.414a2 2 0 0 1 0-2.828zM7.25 9V3.75h1.5V9zM8 12.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$cf33711b0175a169$var$ErrorIcon.displayName = 'ErrorIcon';
var $cf33711b0175a169$var$_default = module.exports.default = $cf33711b0175a169$var$ErrorIcon;

});
parcelRegister("fEaCe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("591Ce")).default);
$parcel$export(module.exports, "Icon", () => (parcelRequire("591Ce")).Icon);

var $591Ce = parcelRequire("591Ce");

});
parcelRegister("591Ce", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $8147d93e440a69f1$export$f04a61298a47a40f);
$parcel$export(module.exports, "default", () => $8147d93e440a69f1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");
function $8147d93e440a69f1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8147d93e440a69f1$var$commonSVGStyles = {
    name: "10ihzwq",
    styles: "overflow:hidden;pointer-events:none;stop{stop-color:currentColor;}"
};
const $8147d93e440a69f1$var$svgStyles = {
    name: "x6fk93",
    styles: "color:currentColor;vertical-align:bottom"
};
const $8147d93e440a69f1$var$iconStyles = {
    name: "mrp99y",
    styles: "display:inline-block;box-sizing:border-box;flex-shrink:0;line-height:1;padding-inline-end:var(--ds--button--new-icon-padding-end, 0);padding-inline-start:var(--ds--button--new-icon-padding-start, 0)"
};
const $8147d93e440a69f1$var$utilityIconStyles = {
    name: "1j4yvsm",
    styles: "line-height:var(--ds-space-150, 12px)"
};
const $8147d93e440a69f1$var$scaleStyles = {
    name: "1a1gyup",
    styles: "width:inherit;height:inherit"
};
/**
 * For windows high contrast mode
 */ const $8147d93e440a69f1$var$baseHcmStyles = {
    name: "9vywkz",
    styles: "@media screen and (forced-colors: active){color:CanvasText;filter:grayscale(1);}"
};
const $8147d93e440a69f1$var$scaleSize = {
    name: "1a1gyup",
    styles: "width:inherit;height:inherit"
};
const $8147d93e440a69f1$var$sizeMap = {
    core: {
        none: {
            name: "1rrhp72",
            styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
        },
        spacious: {
            name: "ljflj6",
            styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
        }
    },
    utility: {
        none: {
            name: "1w03az9",
            styles: "width:var(--ds-space-150, 12px);height:var(--ds-space-150, 12px)"
        },
        compact: {
            name: "1rrhp72",
            styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
        },
        spacious: {
            name: "ljflj6",
            styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
        }
    }
};
const $8147d93e440a69f1$var$baseSizeMap = {
    core: 16,
    utility: 12
};
const $8147d93e440a69f1$var$paddingMap = {
    core: {
        none: 0,
        spacious: 4
    },
    utility: {
        none: 0,
        compact: 2,
        spacious: 6
    }
};
const $8147d93e440a69f1$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.memo)(function Icon(props) {
    const { color: color = 'currentColor', testId: testId, label: label, LEGACY_primaryColor: LEGACY_primaryColor, LEGACY_secondaryColor: LEGACY_secondaryColor, LEGACY_size: LEGACY_size, LEGACY_fallbackIcon: FallbackIcon, dangerouslySetGlyph: // Used to set icon dimensions/behaviour in codegen
    // Used to set icon glyphs in codegen
    dangerouslySetGlyph, shouldScale: // Used with iconTile to scale icon up and down
    shouldScale, LEGACY_margin: LEGACY_margin } = props;
    const dangerouslySetInnerHTML = dangerouslySetGlyph ? {
        __html: dangerouslySetGlyph
    } : undefined;
    // Fall back to old icon
    if (FallbackIcon && !(0, $VSDnB.fg)('platform-visual-refresh-icons')) // parse out unnecessary props
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(FallbackIcon, {
        primaryColor: LEGACY_primaryColor ?? color,
        secondaryColor: LEGACY_secondaryColor,
        size: LEGACY_size,
        label: label,
        testId: testId,
        // @ts-ignore-next-line
        UNSAFE_margin: LEGACY_margin
    });
    const baseSize = $8147d93e440a69f1$var$baseSizeMap[props.type ?? 'core'];
    let viewBoxPadding;
    if (props.type === 'utility') viewBoxPadding = $8147d93e440a69f1$var$paddingMap[props.type][props.spacing ?? 'none'];
    else viewBoxPadding = $8147d93e440a69f1$var$paddingMap['core'][props.spacing ?? 'none'];
    const viewBoxSize = baseSize + 2 * viewBoxPadding;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            color: color
        },
        css: [
            $8147d93e440a69f1$var$iconStyles,
            $8147d93e440a69f1$var$baseHcmStyles,
            shouldScale && $8147d93e440a69f1$var$scaleStyles,
            props.type === 'utility' && $8147d93e440a69f1$var$utilityIconStyles
        ]
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("svg", {
        fill: "none",
        // Adjusting the viewBox allows the icon padding to scale with the contents of the SVG, which
        // we want for Icon Tile
        viewBox: `${0 - viewBoxPadding} ${0 - viewBoxPadding} ${viewBoxSize} ${viewBoxSize}`,
        role: "presentation",
        css: [
            $8147d93e440a69f1$var$commonSVGStyles,
            $8147d93e440a69f1$var$svgStyles,
            shouldScale ? $8147d93e440a69f1$var$scaleSize : props.type === 'utility' ? $8147d93e440a69f1$var$sizeMap[props.type][props.spacing ?? 'none'] : $8147d93e440a69f1$var$sizeMap['core'][props.spacing ?? 'none']
        ],
        dangerouslySetInnerHTML: dangerouslySetInnerHTML
    }));
});
var $8147d93e440a69f1$export$2e2bcd8739ae039 = $8147d93e440a69f1$export$f04a61298a47a40f;

});




parcelRegister("btivG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $85a0c2d39fdb2976$var$_react = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $85a0c2d39fdb2976$var$_success = $85a0c2d39fdb2976$var$_interopRequireDefault((parcelRequire("b0JGA")));
function $85a0c2d39fdb2976$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $85a0c2d39fdb2976$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $85a0c2d39fdb2976$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $85a0c2d39fdb2976$var$_success.default
    }));
$85a0c2d39fdb2976$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $85a0c2d39fdb2976$var$_default = module.exports.default = $85a0c2d39fdb2976$var$CheckCircleIcon;

});
parcelRegister("b0JGA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8a54e77ebc6c63c295a0cd7c7e0eeda>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8043220a46fa3485$var$_react = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8043220a46fa3485$var$_baseNew = $8043220a46fa3485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8043220a46fa3485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8043220a46fa3485$var$SuccessIcon = (props)=>/*#__PURE__*/ $8043220a46fa3485$var$_react.default.createElement($8043220a46fa3485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$8043220a46fa3485$var$SuccessIcon.displayName = 'SuccessIcon';
var $8043220a46fa3485$var$_default = module.exports.default = $8043220a46fa3485$var$SuccessIcon;

});


parcelRegister("lLLkM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fd92b4548073045a$var$_react = $fd92b4548073045a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $fd92b4548073045a$var$_close = $fd92b4548073045a$var$_interopRequireDefault((parcelRequire("i28qQ")));
function $fd92b4548073045a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fd92b4548073045a$var$CrossIcon = (props)=>/*#__PURE__*/ $fd92b4548073045a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M12 10.586 6.707 5.293a1 1 0 0 0-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 0 0 1.414 1.414L12 13.414l5.293 5.293a1 1 0 0 0 1.414-1.414L13.414 12l5.293-5.293a1 1 0 1 0-1.414-1.414z"/></svg>`
    }, props, {
        newIcon: $fd92b4548073045a$var$_close.default
    }));
$fd92b4548073045a$var$CrossIcon.displayName = 'CrossIcon';
var $fd92b4548073045a$var$_default = module.exports.default = $fd92b4548073045a$var$CrossIcon;

});
parcelRegister("i28qQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::13d0fc846b6bef3d8e704c9e8e0a2026>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d20ef456bc05a310$var$_react = $d20ef456bc05a310$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d20ef456bc05a310$var$_baseNew = $d20ef456bc05a310$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d20ef456bc05a310$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Close".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d20ef456bc05a310$var$CloseIcon = (props)=>/*#__PURE__*/ $d20ef456bc05a310$var$_react.default.createElement($d20ef456bc05a310$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m9.06 8 4.97-4.97-1.06-1.06L8 6.94 3.03 1.97 1.97 3.03 6.94 8l-4.97 4.97 1.06 1.06L8 9.06l4.97 4.97 1.06-1.06z" clip-rule="evenodd"/>`
    }, props));
$d20ef456bc05a310$var$CloseIcon.displayName = 'CloseIcon';
var $d20ef456bc05a310$var$_default = module.exports.default = $d20ef456bc05a310$var$CloseIcon;

});


parcelRegister("k4n86", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9c61f77d0c6da71$var$_react = $e9c61f77d0c6da71$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e9c61f77d0c6da71$var$_chevronDown = $e9c61f77d0c6da71$var$_interopRequireDefault((parcelRequire("hORKG")));
function $e9c61f77d0c6da71$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e9c61f77d0c6da71$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $e9c61f77d0c6da71$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.744 8.744a1.053 1.053 0 0 0 0 1.49l4.547 4.557a1 1 0 0 0 1.416 0l4.55-4.558a1.051 1.051 0 1 0-1.488-1.488l-3.77 3.776-3.768-3.776a1.05 1.05 0 0 0-1.487 0"/></svg>`
    }, props, {
        newIcon: $e9c61f77d0c6da71$var$_chevronDown.default,
        iconType: "utility"
    }));
$e9c61f77d0c6da71$var$HipchatChevronDownIcon.displayName = 'HipchatChevronDownIcon';
var $e9c61f77d0c6da71$var$_default = module.exports.default = $e9c61f77d0c6da71$var$HipchatChevronDownIcon;

});
parcelRegister("hORKG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1a026656028c05157ac730015f665601>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf90cd313329a66d$var$_react = $cf90cd313329a66d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cf90cd313329a66d$var$_baseNew = $cf90cd313329a66d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $cf90cd313329a66d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf90cd313329a66d$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $cf90cd313329a66d$var$_react.default.createElement($cf90cd313329a66d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.03 3.97 6 7.94l3.97-3.97 1.06 1.06-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$cf90cd313329a66d$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $cf90cd313329a66d$var$_default = module.exports.default = $cf90cd313329a66d$var$ChevronDownIcon;

});


parcelRegister("cLqLT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $94aea40d90fc9779$var$_react = $94aea40d90fc9779$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $94aea40d90fc9779$var$_chevronUp = $94aea40d90fc9779$var$_interopRequireDefault((parcelRequire("jj3Gi")));
function $94aea40d90fc9779$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $94aea40d90fc9779$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $94aea40d90fc9779$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.294 8.708-4.549 4.559a1.051 1.051 0 1 0 1.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 0 0 1.486.001h.001a1.054 1.054 0 0 0 .001-1.489L12.71 8.708a1 1 0 0 0-1.415-.001"/></svg>`
    }, props, {
        newIcon: $94aea40d90fc9779$var$_chevronUp.default,
        iconType: "utility"
    }));
$94aea40d90fc9779$var$HipchatChevronUpIcon.displayName = 'HipchatChevronUpIcon';
var $94aea40d90fc9779$var$_default = module.exports.default = $94aea40d90fc9779$var$HipchatChevronUpIcon;

});
parcelRegister("jj3Gi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::afcaa915720f5b4d9e69ee6ef0943c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0e2a5b40171778c$var$_react = $e0e2a5b40171778c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e0e2a5b40171778c$var$_baseNew = $e0e2a5b40171778c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e0e2a5b40171778c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronUp".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e0e2a5b40171778c$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $e0e2a5b40171778c$var$_react.default.createElement($e0e2a5b40171778c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 4.06 2.03 8.03.97 6.97l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5-1.06 1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$e0e2a5b40171778c$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $e0e2a5b40171778c$var$_default = module.exports.default = $e0e2a5b40171778c$var$ChevronUpIcon;

});


parcelRegister("2hXfb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1aab1fe42ea32263$var$_react = $1aab1fe42ea32263$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $1aab1fe42ea32263$var$_information = $1aab1fe42ea32263$var$_interopRequireDefault((parcelRequire("2Yv61")));
function $1aab1fe42ea32263$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1aab1fe42ea32263$var$InfoIcon = (props)=>/*#__PURE__*/ $1aab1fe42ea32263$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $1aab1fe42ea32263$var$_information.default
    }));
$1aab1fe42ea32263$var$InfoIcon.displayName = 'InfoIcon';
var $1aab1fe42ea32263$var$_default = module.exports.default = $1aab1fe42ea32263$var$InfoIcon;

});
parcelRegister("2Yv61", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11503d00887c85dd37060e980bd5f02d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $22a94e6465a5d701$var$_react = $22a94e6465a5d701$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $22a94e6465a5d701$var$_baseNew = $22a94e6465a5d701$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $22a94e6465a5d701$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $22a94e6465a5d701$var$InformationIcon = (props)=>/*#__PURE__*/ $22a94e6465a5d701$var$_react.default.createElement($22a94e6465a5d701$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$22a94e6465a5d701$var$InformationIcon.displayName = 'InformationIcon';
var $22a94e6465a5d701$var$_default = module.exports.default = $22a94e6465a5d701$var$InformationIcon;

});


parcelRegister("gtreQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfe47bbe11245bb9$var$_react = $bfe47bbe11245bb9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfe47bbe11245bb9$var$_warning = $bfe47bbe11245bb9$var$_interopRequireDefault((parcelRequire("34Rrn")));
function $bfe47bbe11245bb9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfe47bbe11245bb9$var$WarningIcon = (props)=>/*#__PURE__*/ $bfe47bbe11245bb9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M12.938 4.967c-.518-.978-1.36-.974-1.876 0L3.938 18.425c-.518.978-.045 1.771 1.057 1.771h14.01c1.102 0 1.573-.797 1.057-1.771z"/><path fill="inherit" d="M12 15a1 1 0 0 1-1-1V9a1 1 0 0 1 2 0v5a1 1 0 0 1-1 1m0 3a1 1 0 0 1 0-2 1 1 0 0 1 0 2"/></g></svg>`
    }, props, {
        newIcon: $bfe47bbe11245bb9$var$_warning.default
    }));
$bfe47bbe11245bb9$var$WarningIcon.displayName = 'WarningIcon';
var $bfe47bbe11245bb9$var$_default = module.exports.default = $bfe47bbe11245bb9$var$WarningIcon;

});
parcelRegister("34Rrn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1447c2d9394cec1fac504fd0d225fa23>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23db3304004ad7e6$var$_react = $23db3304004ad7e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $23db3304004ad7e6$var$_baseNew = $23db3304004ad7e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $23db3304004ad7e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23db3304004ad7e6$var$WarningIcon = (props)=>/*#__PURE__*/ $23db3304004ad7e6$var$_react.default.createElement($23db3304004ad7e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$23db3304004ad7e6$var$WarningIcon.displayName = 'WarningIcon';
var $23db3304004ad7e6$var$_default = module.exports.default = $23db3304004ad7e6$var$WarningIcon;

});


parcelRegister("9os0M", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("fVnbM")).default);
$parcel$export(module.exports, "LoadingButton", () => (parcelRequire("2rqOp")).default);
$parcel$export(module.exports, "CustomThemeButton", () => (parcelRequire("9yOBd")).default);
$parcel$export(module.exports, "Theme", () => (parcelRequire("dkK4L")).default);
$parcel$export(module.exports, "ButtonGroup", () => (parcelRequire("ldJSL")).default);
// Ideally this file is not used directly. But rather, you go through the entry points

var $fVnbM = parcelRequire("fVnbM");

var $2rqOp = parcelRequire("2rqOp");

var $9yOBd = parcelRequire("9yOBd");
var $dkK4L = parcelRequire("dkK4L");

var $ldJSL = parcelRequire("ldJSL");

});
parcelRegister("fVnbM", function(module, exports) {

$parcel$export(module.exports, "default", () => $57440b4f81551906$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $1NPPK = parcelRequire("1NPPK");

var $2cblg = parcelRequire("2cblg");

var $4k7Ke = parcelRequire("4k7Ke");

var $gfji5 = parcelRequire("gfji5");
const $57440b4f81551906$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $57440b4f81551906$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $eGmKJ.default), onMouseUp: providedOnMouseUp = (0, $eGmKJ.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $1NPPK.useGlobalTheme)();
    const isOnlySingleIcon = (0, $gfji5.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $5uXOq.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($57440b4f81551906$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $5uXOq.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($57440b4f81551906$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $5uXOq.useMemo)(()=>(0, $4k7Ke.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2cblg.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        //  manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$57440b4f81551906$var$Button.displayName = 'Button';
var $57440b4f81551906$export$2e2bcd8739ae039 = $57440b4f81551906$var$Button;

});
parcelRegister("eGmKJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd0b5d88f05ea91$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ function $ffd0b5d88f05ea91$export$2e2bcd8739ae039() {}

});

parcelRegister("1NPPK", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", () => $6b2557037fdaf279$export$7692396083754928);
$parcel$export(module.exports, "default", () => $6b2557037fdaf279$export$2e2bcd8739ae039);

var $82itC = parcelRequire("82itC");
// Create default global light theme
const { Provider: $6b2557037fdaf279$var$Provider, Consumer: $6b2557037fdaf279$var$Consumer, useTheme: $6b2557037fdaf279$export$7692396083754928 } = (0, $82itC.createTheme)(()=>({
        mode: 'light'
    }));
const $6b2557037fdaf279$var$Theme = {
    Provider: $6b2557037fdaf279$var$Provider,
    Consumer: $6b2557037fdaf279$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6b2557037fdaf279$export$2e2bcd8739ae039 = $6b2557037fdaf279$var$Theme;

});
parcelRegister("82itC", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => $c01bd1238d5aa76b$export$25d302a5b900a763);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $c01bd1238d5aa76b$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
	 * Internally, Theme uses React Context, with internal providers and consumers.
	 * The React Context passes only a function that gets props, and turns them into tokens. This
	 * function gets mixed as more Providers with their own themes are added. This mixed function
	 * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
	 * the theme.
	 */ const ThemeContext = /*#__PURE__*/ (0, $5uXOq.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $5uXOq.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: children(tokens)
        });
    }
    /**
	 * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
	 * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
	 * - The getTokens function isn't called immediately - instead the props are passed
	 *    through a mix of parent theming functions
	 * Children of this provider will receive this mixed theme
	 */ function Provider(props) {
        const themeFn = (0, $5uXOq.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $5uXOq.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, $2OMIu.jsx)(ThemeContext.Provider, {
            value: mixedFn,
            children: props.children
        });
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("2cblg", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b68240e25f19cc$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
                                                                        * @jsxRuntime classic
                                                                        * @jsx jsx
                                                                        */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $SliG5 = parcelRequire("SliG5");

var $jhVLw = parcelRequire("jhVLw");

var $6wxJn = parcelRequire("6wxJn");


var $auy9l = parcelRequire("auy9l");

var $4k7Ke = parcelRequire("4k7Ke");

var $gy8GH = parcelRequire("gy8GH");
function $34b68240e25f19cc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $34b68240e25f19cc$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform-visual-refresh-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $34b68240e25f19cc$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $34b68240e25f19cc$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $34b68240e25f19cc$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $gy8GH.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $34b68240e25f19cc$var$getChildren = (children, childrenStyles)=>{
    if ((0, $gy8GH.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $34b68240e25f19cc$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $eGmKJ.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $eGmKJ.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $5uXOq.useRef)();
    const setRef = (0, $5uXOq.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $SliG5.default)(ourRef, autoFocus);
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $f8Sb3.css)((0, $4k7Ke.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? `var(--ds-icon-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})` : `var(--ds-icon-warning-inverse, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})`} !important`
        }
    };
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $jhVLw.default), null, /*#__PURE__*/ (0, $f8Sb3.jsx)(Component, {
        ...rest,
        ref: setRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $34b68240e25f19cc$var$noPointerEventsOnChildrenCss
        ],
        // using undefined so that the property doesn't exist when false
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Adding a tab index so element is always focusable, even when not a <button> or <a>
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $auy9l.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4k7Ke.getIconStyle)({
                spacing: spacing
            }),
            $34b68240e25f19cc$var$getSpacingFix(children, $34b68240e25f19cc$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $34b68240e25f19cc$var$getChildren(children, [
        fadeStyles,
        (0, $4k7Ke.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $4k7Ke.getIconStyle)({
                spacing: spacing
            }),
            $34b68240e25f19cc$var$getSpacingFix(children, $34b68240e25f19cc$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $f8Sb3.jsx)("span", {
        css: [
            (0, $4k7Ke.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$34b68240e25f19cc$export$2e2bcd8739ae039 = $34b68240e25f19cc$var$ButtonBase;

});
parcelRegister("6QvkM", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $0b30adcafe65a281$export$a4687b0234b40e28);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $lwCsy = parcelRequire("lwCsy");
function $0b30adcafe65a281$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $lwCsy.useTrackedRef)(analyticsData);
    const fnRef = (0, $lwCsy.useTrackedRef)(fn);
    const handler = (0, $5uXOq.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("2NMNM", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $febe245c05f9d9d8$export$5bf35293e545f20c);

var $3YMLK = parcelRequire("3YMLK");

var $1SrMX = parcelRequire("1SrMX");

var $7UMkI = parcelRequire("7UMkI");
function $febe245c05f9d9d8$export$5bf35293e545f20c() {
    const analyticsContext = (0, $7UMkI.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $3YMLK.useCallbackOne)((payload)=>{
        return new (0, $1SrMX.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("1SrMX", function(module, exports) {

$parcel$export(module.exports, "isUIAnalyticsEvent", () => $d9e93e80efa77cc3$export$35f8383928ba8d7);
$parcel$export(module.exports, "default", () => $d9e93e80efa77cc3$export$2e2bcd8739ae039);
/// <reference types="node" />

var $hDX9C = parcelRequire("hDX9C");
const $d9e93e80efa77cc3$export$35f8383928ba8d7 = (obj)=>obj instanceof $d9e93e80efa77cc3$export$2e2bcd8739ae039 || !!obj?._isUIAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'UIAnalyticsEvent';
class $d9e93e80efa77cc3$export$2e2bcd8739ae039 extends (0, $hDX9C.default) {
    constructor(props){
        super(props), this._isUIAnalyticsEvent = true, this.clone = ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
		 * A hacky "deep clone" of the object. This is limited in that it wont
		 * support functions, regexs, Maps, Sets, etc, but none of those need to
		 * be represented in our payload.
		 */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $d9e93e80efa77cc3$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        }, this.fire = (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        };
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("hDX9C", function(module, exports) {

$parcel$export(module.exports, "default", () => $d99135e7c07c0d21$export$2e2bcd8739ae039);
const $d99135e7c07c0d21$export$ad4be5c2ec28cecf = (obj)=>obj instanceof $d99135e7c07c0d21$export$2e2bcd8739ae039 || !!obj?._isAnalyticsEvent || // Backwards compatibility with older analytics-next packages
    obj?.constructor?.name === 'AnalyticsEvent';
class $d99135e7c07c0d21$export$2e2bcd8739ae039 {
    constructor(props){
        this._isAnalyticsEvent = true;
        this.clone = ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $d99135e7c07c0d21$export$2e2bcd8739ae039({
                payload: payload
            });
        };
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("7UMkI", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $c48c0512338bd9dd$export$d1f587f82ad51c4);

var $5uXOq = parcelRequire("5uXOq");

var $fy0vt = parcelRequire("fy0vt");
const $c48c0512338bd9dd$export$d1f587f82ad51c4 = ()=>{
    return (0, $5uXOq.useContext)((0, $fy0vt.default));
};

});
parcelRegister("fy0vt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b51a6c9c41c41fef$export$2e2bcd8739ae039);

var $3eEea = parcelRequire("3eEea");
var $b51a6c9c41c41fef$export$2e2bcd8739ae039 = (0, $3eEea.default);

});
parcelRegister("3eEea", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b1e245577cd18c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $25b1e245577cd18c$var$AnalyticsNextContext = (0, $5uXOq.createContext)({
    getAtlaskitAnalyticsContext: ()=>[],
    getAtlaskitAnalyticsEventHandlers: ()=>[]
});
var $25b1e245577cd18c$export$2e2bcd8739ae039 = $25b1e245577cd18c$var$AnalyticsNextContext;

});




parcelRegister("lwCsy", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", () => $657515217ec307c7$export$1d27a74659855e44);

var $5uXOq = parcelRequire("5uXOq");
const $657515217ec307c7$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("SliG5", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a1f000ff0ad969$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $31a1f000ff0ad969$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("jhVLw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c570b2b0fa4371$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
const $e4c570b2b0fa4371$var$BORDER_WIDTH = 2;
const $e4c570b2b0fa4371$var$baseFocusOutsideStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    outline: `${$e4c570b2b0fa4371$var$BORDER_WIDTH}px solid ${"var(--ds-border-focused, #2684FF)"}`,
    outlineOffset: $e4c570b2b0fa4371$var$BORDER_WIDTH
});
const $e4c570b2b0fa4371$var$baseInsetStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$e4c570b2b0fa4371$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
const $e4c570b2b0fa4371$var$focusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $e4c570b2b0fa4371$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $e4c570b2b0fa4371$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $e4c570b2b0fa4371$var$insetFocusRingStyles = /*#__PURE__*/ (0, $f8Sb3.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus': $e4c570b2b0fa4371$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    '&:focus-visible': $e4c570b2b0fa4371$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ const $e4c570b2b0fa4371$var$FocusRing = /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children, isInset: isInset, focus: focus })=>{
    const controlledStyles = isInset ? $e4c570b2b0fa4371$var$baseInsetStyles : $e4c570b2b0fa4371$var$baseFocusOutsideStyles;
    const uncontrolledStyles = isInset ? $e4c570b2b0fa4371$var$insetFocusRingStyles : $e4c570b2b0fa4371$var$focusRingStyles;
    const focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $f8Sb3.ClassNames), null, ({ css: css, cx: cx })=>(0, $5uXOq.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, $5uXOq.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children));
});
$e4c570b2b0fa4371$var$FocusRing.displayName = 'FocusRing';
var $e4c570b2b0fa4371$export$2e2bcd8739ae039 = $e4c570b2b0fa4371$var$FocusRing;

});

var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';

parcelRegister("auy9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $6470e3d1ca5204d6$export$2e2bcd8739ae039);
function $6470e3d1ca5204d6$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $6470e3d1ca5204d6$var$tabKeyCode = 9;
function $6470e3d1ca5204d6$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $6470e3d1ca5204d6$var$tabKeyCode) return;
    $6470e3d1ca5204d6$var$abort(event);
}
const $6470e3d1ca5204d6$var$block = {
    onMouseDownCapture: $6470e3d1ca5204d6$var$abort,
    onMouseUpCapture: $6470e3d1ca5204d6$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $6470e3d1ca5204d6$var$onKey,
    onKeyUpCapture: $6470e3d1ca5204d6$var$onKey,
    onTouchStartCapture: $6470e3d1ca5204d6$var$abort,
    onTouchEndCapture: $6470e3d1ca5204d6$var$abort,
    onPointerDownCapture: $6470e3d1ca5204d6$var$abort,
    onPointerUpCapture: $6470e3d1ca5204d6$var$abort,
    onClickCapture: $6470e3d1ca5204d6$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $6470e3d1ca5204d6$var$abort
};
const $6470e3d1ca5204d6$var$doNotBlock = {};
function $6470e3d1ca5204d6$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $6470e3d1ca5204d6$var$doNotBlock : $6470e3d1ca5204d6$var$block;
}

});

parcelRegister("4k7Ke", function(module, exports) {

$parcel$export(module.exports, "getCss", () => $4840c5e9efda4bee$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $4840c5e9efda4bee$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $4840c5e9efda4bee$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $4840c5e9efda4bee$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $4840c5e9efda4bee$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $VSDnB = parcelRequire("VSDnB");

var $k5uoT = parcelRequire("k5uoT");

var $w5qqj = parcelRequire("w5qqj");
const $4840c5e9efda4bee$var$gridSize = (0, $k5uoT.gridSize)();
const $4840c5e9efda4bee$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $4840c5e9efda4bee$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $4840c5e9efda4bee$var$lineHeights = {
    default: $4840c5e9efda4bee$var$heights.default,
    compact: $4840c5e9efda4bee$var$heights.compact,
    none: 'inherit'
};
const $4840c5e9efda4bee$var$padding = {
    // 10px gutter
    default: `0 ${$4840c5e9efda4bee$var$gridSize + $4840c5e9efda4bee$var$gridSize / 4}px`,
    compact: `0 ${$4840c5e9efda4bee$var$gridSize + $4840c5e9efda4bee$var$gridSize / 4}px`,
    none: '0'
};
const $4840c5e9efda4bee$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$4840c5e9efda4bee$var$gridSize / 4}px`,
    default: `0 ${$4840c5e9efda4bee$var$gridSize / 4}px`,
    none: '0'
};
const $4840c5e9efda4bee$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $4840c5e9efda4bee$var$innerMargin = {
    content: `0 ${$4840c5e9efda4bee$var$gridSize / 4}px`,
    icon: `0 ${$4840c5e9efda4bee$var$gridSize / 4}px`
};
const $4840c5e9efda4bee$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $4840c5e9efda4bee$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&:not([disabled])::after': {
        ...$4840c5e9efda4bee$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $4840c5e9efda4bee$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #0C66E4)"
    }
};
const $4840c5e9efda4bee$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
const $4840c5e9efda4bee$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $4840c5e9efda4bee$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
const $4840c5e9efda4bee$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #F5CD47)"
    }
};
const $4840c5e9efda4bee$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $4840c5e9efda4bee$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': {
        ...$4840c5e9efda4bee$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    }
};
const $4840c5e9efda4bee$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $4840c5e9efda4bee$var$getColor({ group: group, key: key, mode: mode }) {
    const rule = group[key] || group.default;
    return rule[mode];
}
function $4840c5e9efda4bee$var$getColors({ appearance: appearance, key: key, mode: mode }) {
    return {
        background: $4840c5e9efda4bee$var$getColor({
            group: (0, $w5qqj.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: `${$4840c5e9efda4bee$var$getColor({
            group: (0, $w5qqj.default).color[appearance],
            key: key,
            mode: mode
        })} !important`
    };
}
function $4840c5e9efda4bee$export$955358618f994a11({ appearance: appearance, spacing: spacing, mode: mode, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseColors = $4840c5e9efda4bee$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        // dynamic styles
        ...!(0, $VSDnB.fg)('platform-component-visual-refresh') && baseColors,
        cursor: 'pointer',
        height: $4840c5e9efda4bee$var$heights[spacing],
        lineHeight: $4840c5e9efda4bee$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $4840c5e9efda4bee$var$singleIconPadding[spacing] : $4840c5e9efda4bee$var$padding[spacing],
        verticalAlign: $4840c5e9efda4bee$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        ...!(0, $VSDnB.fg)('platform-component-visual-refresh') && {
            // Disabling visited styles (just using the base colors)
            '&:visited': {
                ...baseColors
            },
            '&:hover': {
                ...$4840c5e9efda4bee$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'hover',
                    mode: mode
                }),
                textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
                // background, box-shadow
                transitionDuration: '0s, 0.15s'
            },
            // giving active styles preference by listing them after focus
            '&:active': {
                ...$4840c5e9efda4bee$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // preventDefault prevents regular active styles from applying in Firefox
            '&[data-firefox-is-active="true"]': {
                ...$4840c5e9efda4bee$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // Giving disabled styles preference over active by listing them after.
            // Not using '&:disabled' because :disabled is not a valid state for all element types
            // so we are targeting the attribute
            // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
            '&[disabled]': {
                // always using 'disabled' even when selected
                ...$4840c5e9efda4bee$var$getColors({
                    appearance: appearance,
                    key: 'disabled',
                    mode: mode
                }),
                cursor: 'not-allowed',
                textDecoration: 'none'
            },
            ...$4840c5e9efda4bee$var$hasOverlayStyles,
            // disabling hover and active color changes when there is an overlay, but the button is not disabled
            '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
                ...$4840c5e9efda4bee$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'default',
                    mode: mode
                })
            }
        },
        // dynamic colours for visual refresh:
        ...(0, $VSDnB.fg)('platform-component-visual-refresh') && (isSelected ? $4840c5e9efda4bee$var$selectedStyles : {
            ...appearance === 'default' && $4840c5e9efda4bee$var$defaultStyles,
            ...appearance === 'primary' && $4840c5e9efda4bee$var$primaryStyles,
            ...appearance === 'link' && $4840c5e9efda4bee$var$linkStyles,
            ...appearance === 'subtle' && $4840c5e9efda4bee$var$subtleStyles,
            ...appearance === 'subtle-link' && $4840c5e9efda4bee$var$subtleLinkStyles,
            ...appearance === 'warning' && $4840c5e9efda4bee$var$warningStyles,
            ...appearance === 'danger' && $4840c5e9efda4bee$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #091E424F)",
                backgroundColor: $4840c5e9efda4bee$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $4840c5e9efda4bee$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $4840c5e9efda4bee$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                }
            },
            ...$4840c5e9efda4bee$var$hasOverlayStyles
        }),
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $4840c5e9efda4bee$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $4840c5e9efda4bee$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $4840c5e9efda4bee$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $4840c5e9efda4bee$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $4840c5e9efda4bee$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $f8Sb3.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $4840c5e9efda4bee$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("k5uoT", function(module, exports) {

$parcel$export(module.exports, "borderRadius", () => $6c2716974e5efc17$export$7a57f79000377ca2);
$parcel$export(module.exports, "gridSize", () => $6c2716974e5efc17$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "noFocusRing", () => $6c2716974e5efc17$export$c0dd343266bc3261);
$parcel$export(module.exports, "layers", () => $6c2716974e5efc17$export$7be255094ccdc533);
$parcel$export(module.exports, "skeletonShimmer", () => $6c2716974e5efc17$export$e497e856b4f89fcd);

var $cYuZM = parcelRequire("cYuZM");

const $6c2716974e5efc17$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $6c2716974e5efc17$export$c93026a968943f95 = 'light';
const $6c2716974e5efc17$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $6c2716974e5efc17$export$7a57f79000377ca2 = ()=>3;
const $6c2716974e5efc17$export$6d8204c2cb2e06b8 = ()=>8;
const $6c2716974e5efc17$export$8e24544ddba725ee = (color = `var(--ds-border-focused, ${0, $829f609a65d26a98$export$215b7063051591f1})`, outlineWidth = $6c2716974e5efc17$export$6d8204c2cb2e06b8() / 4)=>{
    (0, $cYuZM.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $6c2716974e5efc17$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $6c2716974e5efc17$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $6c2716974e5efc17$export$a1b3edb637fb4f35 = ()=>{
    (0, $cYuZM.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $6c2716974e5efc17$export$ba1d834b86d72a09 = $6c2716974e5efc17$export$a1b3edb637fb4f35;
const $6c2716974e5efc17$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: `var(--ds-skeleton, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: `var(--ds-skeleton, ${0, $829f609a65d26a98$export$8d43898f60b96a82})`
            },
            to: {
                backgroundColor: `var(--ds-skeleton-subtle, ${0, $829f609a65d26a98$export$920c0d5c49070351})`
            }
        }
    });

});
parcelRegister("cYuZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $af4c95d8c0908f61$export$2e2bcd8739ae039);
$parcel$export(module.exports, "propDeprecationWarning", () => $af4c95d8c0908f61$export$eb1decd851a5ae56);

var $5Win9 = parcelRequire("5Win9");

var $6cAn5 = parcelRequire("6cAn5");
function $af4c95d8c0908f61$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $5Win9.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}
function $af4c95d8c0908f61$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $6cAn5;
}

});
parcelRegister("5Win9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b5465f1bbe422c1$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $5b5465f1bbe422c1$var$printed = {};
function $5b5465f1bbe422c1$export$2e2bcd8739ae039(message) {
    if ($5b5465f1bbe422c1$var$printed[message]) return;
    $5b5465f1bbe422c1$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});



parcelRegister("w5qqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $573052f9c172d7e6$export$2e2bcd8739ae039);

// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
const $573052f9c172d7e6$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
const $573052f9c172d7e6$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: `var(--ds-background-neutral, ${$829f609a65d26a98$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-neutral, ${$829f609a65d26a98$export$d281fbfe3cff2df6})`
            },
            hover: {
                light: `var(--ds-background-neutral-hovered, ${$829f609a65d26a98$export$920c0d5c49070351})`,
                dark: `var(--ds-background-neutral-hovered, ${$829f609a65d26a98$export$3902c91d8b98a753})`
            },
            active: {
                light: `var(--ds-background-neutral-pressed, ${$573052f9c172d7e6$var$fadedB75})`,
                dark: `var(--ds-background-neutral-pressed, ${$829f609a65d26a98$export$8c13c2ee36917869})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$829f609a65d26a98$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-disabled, ${$829f609a65d26a98$export$d281fbfe3cff2df6})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$3d4f271a500072a})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$3d4f271a500072a})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-background-brand-bold, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
                dark: `var(--ds-background-brand-bold, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`
            },
            hover: {
                light: `var(--ds-background-brand-bold-hovered, ${$829f609a65d26a98$export$e62e8919cca44969})`,
                dark: `var(--ds-background-brand-bold-hovered, ${$829f609a65d26a98$export$8c13c2ee36917869})`
            },
            active: {
                light: `var(--ds-background-brand-bold-pressed, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
                dark: `var(--ds-background-brand-bold-pressed, ${$829f609a65d26a98$export$215b7063051591f1})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$829f609a65d26a98$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-disabled, ${$829f609a65d26a98$export$d281fbfe3cff2df6})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$3d4f271a500072a})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$3d4f271a500072a})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-background-warning-bold, ${$829f609a65d26a98$export$c6930421db9fa514})`,
                dark: `var(--ds-background-warning-bold, ${$829f609a65d26a98$export$c6930421db9fa514})`
            },
            hover: {
                light: `var(--ds-background-warning-bold-hovered, ${$829f609a65d26a98$export$5aae31392d72caaa})`,
                dark: `var(--ds-background-warning-bold-hovered, ${$829f609a65d26a98$export$5aae31392d72caaa})`
            },
            active: {
                light: `var(--ds-background-warning-bold-pressed, ${$829f609a65d26a98$export$59619663aa6500fb})`,
                dark: `var(--ds-background-warning-bold-pressed, ${$829f609a65d26a98$export$59619663aa6500fb})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$829f609a65d26a98$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-disabled, ${$829f609a65d26a98$export$d281fbfe3cff2df6})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$59619663aa6500fb})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$59619663aa6500fb})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$59619663aa6500fb})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$59619663aa6500fb})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-background-danger-bold, ${$829f609a65d26a98$export$2010d0fb4295b346})`,
                dark: `var(--ds-background-danger-bold, ${$829f609a65d26a98$export$2010d0fb4295b346})`
            },
            hover: {
                light: `var(--ds-background-danger-bold-hovered, ${$829f609a65d26a98$export$4a7404f376229999})`,
                dark: `var(--ds-background-danger-bold-hovered, ${$829f609a65d26a98$export$4a7404f376229999})`
            },
            active: {
                light: `var(--ds-background-danger-bold-pressed, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
                dark: `var(--ds-background-danger-bold-pressed, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$829f609a65d26a98$export$8d43898f60b96a82})`,
                dark: `var(--ds-background-disabled, ${$829f609a65d26a98$export$d281fbfe3cff2df6})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$2837b5a1a71d5c02})`
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$920c0d5c49070351})`,
                dark: `var(--ds-background-neutral-subtle-hovered, ${$829f609a65d26a98$export$3902c91d8b98a753})`
            },
            active: {
                light: `var(--ds-background-neutral-subtle-pressed, ${$573052f9c172d7e6$var$fadedB75})`,
                dark: `var(--ds-background-neutral-subtle-pressed, ${$829f609a65d26a98$export$8c13c2ee36917869})`
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$3d4f271a500072a})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$3d4f271a500072a})`
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`,
                dark: `var(--ds-background-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`
            }
        }
    },
    color: {
        default: {
            default: {
                light: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
                dark: `var(--ds-text, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            },
            active: {
                light: `var(--ds-text, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
                dark: `var(--ds-text, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$829f609a65d26a98$export$633847cf062b69e0})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                dark: `var(--ds-text-inverse, ${$829f609a65d26a98$export$633847cf062b69e0})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$829f609a65d26a98$export$633847cf062b69e0})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-text-warning-inverse, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
                dark: `var(--ds-text-warning-inverse, ${$829f609a65d26a98$export$7d61b15e0da132af})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$829f609a65d26a98$export$633847cf062b69e0})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$7d61b15e0da132af})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$7d61b15e0da132af})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$7d61b15e0da132af})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                dark: `var(--ds-text-inverse, ${$829f609a65d26a98$export$29a4f05edc054374})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$829f609a65d26a98$export$633847cf062b69e0})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$29a4f05edc054374})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$29a4f05edc054374})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$29a4f05edc054374})`
            }
        },
        link: {
            default: {
                light: `var(--ds-link, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
                dark: `var(--ds-link, ${$829f609a65d26a98$export$ecfc1dff386a3e7a})`
            },
            hover: {
                light: `var(--ds-link, ${$829f609a65d26a98$export$e62e8919cca44969})`,
                dark: `var(--ds-link, ${$829f609a65d26a98$export$8c13c2ee36917869})`
            },
            active: {
                light: `var(--ds-link-pressed, ${$829f609a65d26a98$export$a6ee3d71bc067634})`,
                dark: `var(--ds-link-pressed, ${$829f609a65d26a98$export$215b7063051591f1})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$829f609a65d26a98$export$ee82aa2ea6a1558})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$ad0bacf983b7ddaa})`
            }
        },
        subtle: {
            default: {
                light: `var(--ds-text, ${$829f609a65d26a98$export$c39c0fe0f26207ae})`,
                dark: `var(--ds-text, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            },
            active: {
                light: `var(--ds-text, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`,
                dark: `var(--ds-text, ${$829f609a65d26a98$export$b3de0ae08da2ce64})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$829f609a65d26a98$export$ee82aa2ea6a1558})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            }
        },
        'subtle-link': {
            default: {
                light: `var(--ds-text-subtle, ${$829f609a65d26a98$export$f563ee71e9ee74cd})`,
                dark: `var(--ds-text-subtle, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            },
            hover: {
                light: `var(--ds-text-subtle, ${$829f609a65d26a98$export$7c87d337fb91a97d})`,
                dark: `var(--ds-text-subtle, ${$829f609a65d26a98$export$226de0355ed012f8})`
            },
            active: {
                light: `var(--ds-text, ${$829f609a65d26a98$export$eece5f492e429f08})`,
                dark: `var(--ds-text, ${$829f609a65d26a98$export$97e81faa16a182c7})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$829f609a65d26a98$export$5f71e19f3a7ad9de})`,
                dark: `var(--ds-text-disabled, ${$829f609a65d26a98$export$ee82aa2ea6a1558})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$829f609a65d26a98$export$9fdfb749e33cdf97})`,
                dark: `var(--ds-text-selected, ${$829f609a65d26a98$export$abcf8c38338b4aa5})`
            }
        }
    }
};
var $573052f9c172d7e6$export$2e2bcd8739ae039 = $573052f9c172d7e6$var$values;

});


parcelRegister("gy8GH", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $da31b06a9feea5c6$export$20bbd2efb0d734c4);

var $5uXOq = parcelRequire("5uXOq");

var $jldZL = parcelRequire("jldZL");
const $da31b06a9feea5c6$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $5uXOq.isValidElement)(children) && children.type === (0, $jldZL.default);
};

});
parcelRegister("jldZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49b2bc52e034fc9$export$2e2bcd8739ae039);
/* visually-hidden.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $e49b2bc52e034fc9$var$visuallyHiddenStyles = null;
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ const $e49b2bc52e034fc9$var$VisuallyHidden = ({ children: children, testId: testId, role: role, id: id })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        id: id,
        "data-testid": testId,
        role: role,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _uiztglyw _o5721q9c"
        ]),
        children: children
    });
};
var $e49b2bc52e034fc9$export$2e2bcd8739ae039 = $e49b2bc52e034fc9$var$VisuallyHidden;

});



parcelRegister("gfji5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1c0106d05db36f$export$2e2bcd8739ae039);

var $gy8GH = parcelRequire("gy8GH");
function $5b1c0106d05db36f$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $gy8GH.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});


parcelRegister("2rqOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dcb92a9a4ba4469$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $doU3u = parcelRequire("doU3u");
/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $0dcb92a9a4ba4469$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fVnbM.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $doU3u.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$0dcb92a9a4ba4469$var$LoadingButton.displayName = 'LoadingButton';
var $0dcb92a9a4ba4469$export$2e2bcd8739ae039 = $0dcb92a9a4ba4469$var$LoadingButton;

});
parcelRegister("doU3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0bd8908c23e5c95$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");
function $d0bd8908c23e5c95$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $d0bd8908c23e5c95$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
        size: size,
        label: ", Loading",
        appearance: $d0bd8908c23e5c95$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});
parcelRegister("eZJjh", function(module, exports) {

$parcel$export(module.exports, "default", () => $77aa4ae7d5f158a1$export$2e2bcd8739ae039);
/* spinner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");


var $iEPWv = parcelRequire("iEPWv");
/**
 * Returns the appropriate circle stroke color.
 */ function $77aa4ae7d5f158a1$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? `var(--ds-icon-subtle, ${0, $829f609a65d26a98$export$c39c0fe0f26207ae})` : `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$29a4f05edc054374})`;
}
const $77aa4ae7d5f158a1$var$rotate = null;
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ const $77aa4ae7d5f158a1$var$loadIn = null;
const $77aa4ae7d5f158a1$var$styles = {
    rotateStyles: "_j7hqsf8s _5sag12kz _tip812c5 _1pgl2qsq _8hrz1h6o",
    loadInStyles: "_j7hq1eco _5sag9cwz _1pgl1ytf _1o51q7pw _tzy4idpf",
    wrapperStyles: "_1e0c116y _s7n4nkob",
    circleStyles: "_lswuglyw _7ljx1dhp _opj11kw7 _134c892t _1snbbs82 _jcxd7g3v _1tjm1onz"
};
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ const $77aa4ae7d5f158a1$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/spinner/examples)
 * - [Code](https://atlassian.design/components/spinner/code)
 * - [Usage](https://atlassian.design/components/spinner/usage)
 */ const $77aa4ae7d5f158a1$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function Spinner({ appearance: appearance = 'inherit', delay: delay = 0, interactionName: interactionName, label: label, size: providedSize = 'medium', testId: testId }, ref) {
    const size = typeof providedSize === 'number' ? providedSize : (0, $iEPWv.presetSizes)[providedSize];
    const animationDelay = `${delay}ms`;
    const stroke = $77aa4ae7d5f158a1$var$getStrokeColor(appearance);
    const context = (0, $5uXOq.useContext)((0, $6wxJn.default));
    $77aa4ae7d5f158a1$var$useLayoutEffect(()=>{
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        /**
   * This span exists to off-load animations from the circle element,
   * which were causing performance issues (style recalculations)
   * on Safari and older versions of Chrome.
   *
   * This can be removed and styles placed back on the circle element once
   * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
   */ "data-testid": testId ? `${testId}-wrapper` : 'spinner-wrapper',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        },
        className: (0, $bwpsq.default)([
            $77aa4ae7d5f158a1$var$styles.wrapperStyles,
            $77aa4ae7d5f158a1$var$styles.rotateStyles
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 16 16",
            xmlns: "http://www.w3.org/2000/svg",
            "data-testid": testId,
            ref: ref,
            "aria-label": label || undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                animationDelay: animationDelay
            },
            role: label ? 'img' : 'none',
            className: (0, $bwpsq.default)([
                $77aa4ae7d5f158a1$var$styles.loadInStyles
            ]),
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("circle", {
                cx: "8",
                cy: "8",
                r: "7",
                style: {
                    stroke: stroke
                },
                className: (0, $bwpsq.default)([
                    $77aa4ae7d5f158a1$var$styles.circleStyles
                ])
            })
        })
    });
}));
var $77aa4ae7d5f158a1$export$2e2bcd8739ae039 = $77aa4ae7d5f158a1$var$Spinner;

});
parcelRegister("iEPWv", function(module, exports) {

$parcel$export(module.exports, "presetSizes", () => $98aa8c0748f46758$export$4e9f1640bbe7a1a8);
const $98aa8c0748f46758$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});




parcelRegister("9yOBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b1864b7acf48d9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $1NPPK = parcelRequire("1NPPK");

var $2cblg = parcelRequire("2cblg");

var $gfji5 = parcelRequire("gfji5");

var $doU3u = parcelRequire("doU3u");

var $dkK4L = parcelRequire("dkK4L");
function $34b1864b7acf48d9$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $34b1864b7acf48d9$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $34b1864b7acf48d9$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $dkK4L.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $5uXOq.useState)($34b1864b7acf48d9$var$initial);
    const onMouseEnter = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $5uXOq.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dkK4L.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1NPPK.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dkK4L.default).Consumer, {
                    mode: mode,
                    state: $34b1864b7acf48d9$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $gfji5.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $2cblg.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $doU3u.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $dkK4L.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$34b1864b7acf48d9$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $34b1864b7acf48d9$export$2e2bcd8739ae039 = $34b1864b7acf48d9$var$CustomThemeButton;

});
parcelRegister("dkK4L", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", () => $920a6d92635d5ba4$export$643db0b8d8778e);
$parcel$export(module.exports, "defaultThemeFn", () => $920a6d92635d5ba4$export$437a7f77d13d7916);
$parcel$export(module.exports, "default", () => $920a6d92635d5ba4$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $82itC = parcelRequire("82itC");

var $4k7Ke = parcelRequire("4k7Ke");
const $920a6d92635d5ba4$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $920a6d92635d5ba4$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', mode: mode = 'light', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $4k7Ke.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $920a6d92635d5ba4$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $920a6d92635d5ba4$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $920a6d92635d5ba4$export$437a7f77d13d7916(current, values) {
    return current(values);
}
const $920a6d92635d5ba4$var$Theme = (0, $82itC.createTheme)((themeProps)=>({
        buttonStyles: $920a6d92635d5ba4$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$920a6d92635d5ba4$export$2e2bcd8739ae039 = $920a6d92635d5ba4$var$Theme;

});


parcelRegister("ldJSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0a944023d04b057$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");
function $d0a944023d04b057$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d0a944023d04b057$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $d0a944023d04b057$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        css: $d0a944023d04b057$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $f8Sb3.jsx)((0, $5uXOq.Fragment), {
            key: idx
        }, child);
    }));
}

});


parcelRegister("1PVpv", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => (parcelRequire("6bTzA")).ELEMENTS_CONTEXT);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => (parcelRequire("6bTzA")).FabricElementsAnalyticsContext);
$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => (parcelRequire("4sEDC")).NAVIGATION_CONTEXT);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => (parcelRequire("4sEDC")).NavigationAnalyticsContext);
$parcel$export(module.exports, "EDITOR_CONTEXT", () => (parcelRequire("d93fQ")).EDITOR_CONTEXT);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => (parcelRequire("d93fQ")).FabricEditorAnalyticsContext);
$parcel$export(module.exports, "MEDIA_CONTEXT", () => $b276966247f2f12d$export$70df29c238ba7306);
$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => (parcelRequire("82PEg")).PEOPLE_TEAMS_CONTEXT);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => (parcelRequire("82PEg")).PeopleTeamsAnalyticsContext);
$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => (parcelRequire("aa77w")).NOTIFICATIONS_CONTEXT);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => (parcelRequire("aa77w")).NotificationsAnalyticsContext);
$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => (parcelRequire("dFBIZ")).RECENT_WORK_CONTEXT);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => (parcelRequire("dFBIZ")).RecentWorkAnalyticsContext);
$parcel$export(module.exports, "ATLAS_CONTEXT", () => (parcelRequire("334CK")).ATLAS_CONTEXT);
$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => (parcelRequire("11Xme")).LINKING_PLATFORM_CONTEXT);
$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => (parcelRequire("i2uxb")).POST_OFFICE_CONTEXT);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => (parcelRequire("i2uxb")).PostOfficeAnalyticsContext);
$parcel$export(module.exports, "AI_MATE_CONTEXT", () => (parcelRequire("3bERc")).AI_MATE_CONTEXT);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => (parcelRequire("3bERc")).AIMateAnalyticsContext);
$parcel$export(module.exports, "AVP_CONTEXT", () => (parcelRequire("7tjJx")).AVP_CONTEXT);
$parcel$export(module.exports, "GROWTH_CONTEXT", () => (parcelRequire("2qof0")).GROWTH_CONTEXT);

var $6bTzA = parcelRequire("6bTzA");

var $4sEDC = parcelRequire("4sEDC");

var $d93fQ = parcelRequire("d93fQ");


var $82PEg = parcelRequire("82PEg");

var $aa77w = parcelRequire("aa77w");

var $dFBIZ = parcelRequire("dFBIZ");

var $334CK = parcelRequire("334CK");

var $11Xme = parcelRequire("11Xme");

var $i2uxb = parcelRequire("i2uxb");

var $3bERc = parcelRequire("3bERc");

var $7tjJx = parcelRequire("7tjJx");

var $2qof0 = parcelRequire("2qof0");

});
parcelRegister("6bTzA", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_CONTEXT", () => $2c66b9a3208a7e16$export$80450e0a84a5ede9);
$parcel$export(module.exports, "FabricElementsAnalyticsContext", () => $2c66b9a3208a7e16$export$3fe25500478a635c);

var $igqHG = parcelRequire("igqHG");
const $2c66b9a3208a7e16$export$80450e0a84a5ede9 = 'fabricElementsCtx';
const $2c66b9a3208a7e16$export$3fe25500478a635c = (0, $igqHG.default)($2c66b9a3208a7e16$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');

});
parcelRegister("igqHG", function(module, exports) {

$parcel$export(module.exports, "default", () => $67dda0a649b7ec82$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $67dda0a649b7ec82$var$createNamespaceContext = (namespace, displayName = 'NamespacedContext')=>{
    const Component = (props)=>{
        const newData = {
            [namespace]: props.data
        };
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
            data: newData,
            children: (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.only(props.children)
        });
    };
    Component.displayName = displayName;
    return Component;
};
var $67dda0a649b7ec82$export$2e2bcd8739ae039 = $67dda0a649b7ec82$var$createNamespaceContext;

});
parcelRegister("daJ0i", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5a03b622e6a7f96$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3yqGI = parcelRequire("3yqGI");

var $kwHHJ = parcelRequire("kwHHJ");

var $5Vn4e = parcelRequire("5Vn4e");
const $d5a03b622e6a7f96$var$ExportedAnalyticsContext = (props)=>{
    const isModernContext = (0, $3yqGI.default) || (0, $VSDnB.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Vn4e.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kwHHJ.default), {
        ...props
    });
};
var $d5a03b622e6a7f96$export$2e2bcd8739ae039 = $d5a03b622e6a7f96$var$ExportedAnalyticsContext;

});
parcelRegister("3yqGI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a10ab2daba9b639$export$2e2bcd8739ae039);
/// <reference types="node" />

var $6cAn5 = parcelRequire("6cAn5");
var $4a10ab2daba9b639$export$2e2bcd8739ae039 = typeof $6cAn5 !== 'undefined' && $6cAn5 !== null && $6cAn5.env?.['ANALYTICS_NEXT_MODERN_CONTEXT'];

});

parcelRegister("kwHHJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c67bbeb3cb6bc101$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $fy0vt = parcelRequire("fy0vt");
const $c67bbeb3cb6bc101$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
};
const $c67bbeb3cb6bc101$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c67bbeb3cb6bc101$var$AnalyticsContext extends (0, $5uXOq.Component) {
    static{
        this.contextTypes = $c67bbeb3cb6bc101$var$ContextTypes;
    }
    static{
        this.childContextTypes = $c67bbeb3cb6bc101$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsContext: this.getAnalyticsContext
            }), this.getAnalyticsContext = ()=>{
            const { data: data } = this.props;
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $c67bbeb3cb6bc101$var$noop } = this.context;
            return [
                ...getAtlaskitAnalyticsContext(),
                data
            ];
        }, this.getAnalyticsEventHandlers = ()=>{
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $c67bbeb3cb6bc101$var$noop } = this.context;
            return getAtlaskitAnalyticsEventHandlers();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fy0vt.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
var $c67bbeb3cb6bc101$export$2e2bcd8739ae039 = $c67bbeb3cb6bc101$var$AnalyticsContext;

});

parcelRegister("5Vn4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f9de7944715e0a2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fy0vt = parcelRequire("fy0vt");

var $7UMkI = parcelRequire("7UMkI");

var $lwCsy = parcelRequire("lwCsy");
const $6f9de7944715e0a2$var$AnalyticsContext = ({ data: data, children: children })=>{
    const dataRef = (0, $lwCsy.useTrackedRef)(data);
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsContext: getOriginalAnalyticsContext } = (0, $7UMkI.useAnalyticsContext)();
    const getAtlaskitAnalyticsContext = (0, $5uXOq.useCallback)(()=>{
        return [
            ...getOriginalAnalyticsContext(),
            dataRef.current
        ];
    }, [
        getOriginalAnalyticsContext,
        dataRef
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAtlaskitAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fy0vt.default).Provider, {
        value: value,
        children: children
    });
};
var $6f9de7944715e0a2$export$2e2bcd8739ae039 = $6f9de7944715e0a2$var$AnalyticsContext;

});




parcelRegister("4sEDC", function(module, exports) {

$parcel$export(module.exports, "NAVIGATION_CONTEXT", () => $4bdf770b21c85f64$export$1fd3aad76a7c6788);
$parcel$export(module.exports, "NavigationAnalyticsContext", () => $4bdf770b21c85f64$export$d0a82da1a0b94929);

var $igqHG = parcelRequire("igqHG");
const $4bdf770b21c85f64$export$1fd3aad76a7c6788 = 'navigationCtx';
const $4bdf770b21c85f64$export$d0a82da1a0b94929 = (0, $igqHG.default)($4bdf770b21c85f64$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');

});

parcelRegister("d93fQ", function(module, exports) {

$parcel$export(module.exports, "EDITOR_CONTEXT", () => $561cc55456056a35$export$8c8f6d8f1fa796f0);
$parcel$export(module.exports, "EDITOR_APPEARANCE_CONTEXT", () => $561cc55456056a35$export$9eb2b47430ed3f7c);
$parcel$export(module.exports, "FabricEditorAnalyticsContext", () => $561cc55456056a35$export$629cada6c5e621e1);

var $igqHG = parcelRequire("igqHG");
const $561cc55456056a35$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $561cc55456056a35$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
const $561cc55456056a35$export$629cada6c5e621e1 = (0, $igqHG.default)($561cc55456056a35$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');

});

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $b276966247f2f12d$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

parcelRegister("82PEg", function(module, exports) {

$parcel$export(module.exports, "PEOPLE_TEAMS_CONTEXT", () => $0a1b262c89cb820d$export$b326383bee6cb993);
$parcel$export(module.exports, "PeopleTeamsAnalyticsContext", () => $0a1b262c89cb820d$export$4119ddb38ccbfb87);

var $igqHG = parcelRequire("igqHG");
const $0a1b262c89cb820d$export$b326383bee6cb993 = 'peopleTeamsCtx';
const $0a1b262c89cb820d$export$4119ddb38ccbfb87 = (0, $igqHG.default)($0a1b262c89cb820d$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');

});

parcelRegister("aa77w", function(module, exports) {

$parcel$export(module.exports, "NOTIFICATIONS_CONTEXT", () => $5aff655c649847f3$export$da1befb791e93c7e);
$parcel$export(module.exports, "NotificationsAnalyticsContext", () => $5aff655c649847f3$export$6f8e7ff1e3feafd7);

var $igqHG = parcelRequire("igqHG");
const $5aff655c649847f3$export$da1befb791e93c7e = 'NotificationsCtx';
const $5aff655c649847f3$export$6f8e7ff1e3feafd7 = (0, $igqHG.default)($5aff655c649847f3$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');

});

parcelRegister("dFBIZ", function(module, exports) {

$parcel$export(module.exports, "RECENT_WORK_CONTEXT", () => $e8adf6096a913f16$export$fc7a65795610cb71);
$parcel$export(module.exports, "RecentWorkAnalyticsContext", () => $e8adf6096a913f16$export$745926731087ebe2);

var $igqHG = parcelRequire("igqHG");
const $e8adf6096a913f16$export$fc7a65795610cb71 = 'RecentWorkCtx';
const $e8adf6096a913f16$export$745926731087ebe2 = (0, $igqHG.default)($e8adf6096a913f16$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');

});

parcelRegister("334CK", function(module, exports) {

$parcel$export(module.exports, "ATLAS_CONTEXT", () => $971e23271d795e3c$export$4906017439f33fc0);

var $igqHG = parcelRequire("igqHG");
const $971e23271d795e3c$export$4906017439f33fc0 = 'atlasCtx';
const $971e23271d795e3c$export$43ebbe41370d4543 = (0, $igqHG.default)($971e23271d795e3c$export$4906017439f33fc0, 'AtlasAnalyticsContext');

});

parcelRegister("11Xme", function(module, exports) {

$parcel$export(module.exports, "LINKING_PLATFORM_CONTEXT", () => $405089afd504d7d4$export$3240443bf2b83834);

var $igqHG = parcelRequire("igqHG");
const $405089afd504d7d4$export$3240443bf2b83834 = 'linkingPlatformCtx';
const $405089afd504d7d4$export$6d568da622ce0a08 = (0, $igqHG.default)($405089afd504d7d4$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');

});

parcelRegister("i2uxb", function(module, exports) {

$parcel$export(module.exports, "POST_OFFICE_CONTEXT", () => $223e1584eec3686e$export$ef0c05448f0f8f9);
$parcel$export(module.exports, "PostOfficeAnalyticsContext", () => $223e1584eec3686e$export$dcd232f3be312f94);

var $igqHG = parcelRequire("igqHG");
const $223e1584eec3686e$export$ef0c05448f0f8f9 = 'postOfficeCtx';
const $223e1584eec3686e$export$dcd232f3be312f94 = (0, $igqHG.default)($223e1584eec3686e$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');

});

parcelRegister("3bERc", function(module, exports) {

$parcel$export(module.exports, "AI_MATE_CONTEXT", () => $c5374555d8900bda$export$5c3a6fd8b96e8b66);
$parcel$export(module.exports, "AIMateAnalyticsContext", () => $c5374555d8900bda$export$de3826c30468da26);

var $igqHG = parcelRequire("igqHG");
const $c5374555d8900bda$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
const $c5374555d8900bda$export$de3826c30468da26 = (0, $igqHG.default)($c5374555d8900bda$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');

});

parcelRegister("7tjJx", function(module, exports) {

$parcel$export(module.exports, "AVP_CONTEXT", () => $d99f00f25dde0b7e$export$c2a811a4e42f4af5);

var $igqHG = parcelRequire("igqHG");
const $d99f00f25dde0b7e$export$c2a811a4e42f4af5 = 'avpCtx';
const $d99f00f25dde0b7e$export$da383e8879a25b03 = (0, $igqHG.default)($d99f00f25dde0b7e$export$c2a811a4e42f4af5, 'AVPAnalyticsContext');

});

parcelRegister("2qof0", function(module, exports) {

$parcel$export(module.exports, "GROWTH_CONTEXT", () => $12e3117ea2ac92f4$export$82023f2f4bfb06c1);

var $igqHG = parcelRequire("igqHG");
const $12e3117ea2ac92f4$export$82023f2f4bfb06c1 = 'editionAwarenessCtx';
const $12e3117ea2ac92f4$export$84980182680018f = (0, $igqHG.default)($12e3117ea2ac92f4$export$82023f2f4bfb06c1, 'GrowthAnalyticsContext');

});


parcelRegister("e8KHW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("7dF4h")).default);
$parcel$export(module.exports, "LOG_LEVEL", () => (parcelRequire("11ek6")).LOG_LEVEL);
$parcel$export(module.exports, "FabricChannel", () => (parcelRequire("dWAZk")).FabricChannel);

var $7dF4h = parcelRequire("7dF4h");

var $11ek6 = parcelRequire("11ek6");

var $dWAZk = parcelRequire("dWAZk");

});
parcelRegister("7dF4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3670c54573a1509$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $3OX36 = parcelRequire("3OX36");

var $atyO4 = parcelRequire("atyO4");

var $11ek6 = parcelRequire("11ek6");

var $aTL5l = parcelRequire("aTL5l");

var $k2NeX = parcelRequire("k2NeX");

var $iiiw8 = parcelRequire("iiiw8");

var $7c0WJ = parcelRequire("7c0WJ");

var $h08AR = parcelRequire("h08AR");

var $jqTf8 = parcelRequire("jqTf8");

var $aBb5V = parcelRequire("aBb5V");

var $cdITG = parcelRequire("cdITG");

var $g2q31 = parcelRequire("g2q31");

var $h8m2w = parcelRequire("h8m2w");

var $4Fo1a = parcelRequire("4Fo1a");

var $1ZdOg = parcelRequire("1ZdOg");

var $eTLWl = parcelRequire("eTLWl");
const $e3670c54573a1509$var$listenerMap = {
    [(0, $dWAZk.FabricChannel).elements]: (0, $3OX36.default),
    [(0, $dWAZk.FabricChannel).editor]: (0, $k2NeX.default),
    [(0, $dWAZk.FabricChannel).atlaskit]: (0, $atyO4.default),
    [(0, $dWAZk.FabricChannel).navigation]: (0, $aTL5l.default),
    [(0, $dWAZk.FabricChannel).media]: (0, $iiiw8.default),
    [(0, $dWAZk.FabricChannel).peopleTeams]: (0, $7c0WJ.default),
    [(0, $dWAZk.FabricChannel).notifications]: (0, $h08AR.default),
    [(0, $dWAZk.FabricChannel).recentWork]: (0, $jqTf8.default),
    [(0, $dWAZk.FabricChannel).atlas]: (0, $aBb5V.default),
    [(0, $dWAZk.FabricChannel).crossFlow]: (0, $cdITG.default),
    [(0, $dWAZk.FabricChannel).linkingPlatform]: (0, $g2q31.default),
    [(0, $dWAZk.FabricChannel).postOffice]: (0, $h8m2w.default),
    [(0, $dWAZk.FabricChannel).aiMate]: (0, $4Fo1a.default),
    [(0, $dWAZk.FabricChannel).avp]: (0, $1ZdOg.default),
    [(0, $dWAZk.FabricChannel).growth]: (0, $eTLWl.default)
};
class $e3670c54573a1509$var$FabricAnalyticsListeners extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    constructor(props){
        super(props);
        this.logger = new (0, $11ek6.default)({
            logLevel: props.logLevel
        });
    }
    render() {
        const { client: client, children: children, logLevel: logLevel, excludedChannels: excludedChannels } = this.props;
        if (typeof logLevel === 'number') this.logger.setLogLevel(logLevel);
        const listeners = Object.keys($e3670c54573a1509$var$listenerMap).filter((channel)=>!excludedChannels || excludedChannels.indexOf(channel) < 0).map((channel)=>$e3670c54573a1509$var$listenerMap[channel]).reduce((prev, Listener)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Listener, {
                client: client,
                logger: this.logger,
                children: prev
            }), children);
        return listeners;
    }
}
var $e3670c54573a1509$export$2e2bcd8739ae039 = $e3670c54573a1509$var$FabricAnalyticsListeners;

});
parcelRegister("dWAZk", function(module, exports) {

$parcel$export(module.exports, "FabricChannel", () => $dfd384fa96b5f313$export$8faa0b115ef0268b);
var $dfd384fa96b5f313$export$8faa0b115ef0268b = /*#__PURE__*/ function(FabricChannel) {
    FabricChannel["atlaskit"] = "atlaskit";
    FabricChannel["elements"] = "fabric-elements";
    FabricChannel["navigation"] = "navigation";
    FabricChannel["editor"] = "editor";
    FabricChannel["media"] = "media";
    FabricChannel["peopleTeams"] = "peopleTeams";
    FabricChannel["notifications"] = "notifications";
    FabricChannel["recentWork"] = "recentWork";
    FabricChannel["atlas"] = "atlas";
    FabricChannel["crossFlow"] = "crossFlow";
    FabricChannel["linkingPlatform"] = "linkingPlatform";
    FabricChannel["postOffice"] = "postOffice";
    FabricChannel["aiMate"] = "aiMate";
    FabricChannel["avp"] = "avp";
    FabricChannel["growth"] = "growth";
    return FabricChannel;
}({});

});

parcelRegister("3OX36", function(module, exports) {

$parcel$export(module.exports, "ELEMENTS_TAG", () => $e83f70883abce0b0$export$ed71ae78997933a);
$parcel$export(module.exports, "default", () => $e83f70883abce0b0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $dWAZk = parcelRequire("dWAZk");

var $8Mzko = parcelRequire("8Mzko");
const $e83f70883abce0b0$export$ed71ae78997933a = 'fabricElements';
class $e83f70883abce0b0$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $dWAZk.FabricChannel).elements,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $8Mzko.handleEvent)(event, $e83f70883abce0b0$export$ed71ae78997933a, this.props.logger, this.props.client);
        };
    }
}

});
parcelRegister("bvUB1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce6fdf32d075b016$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3yqGI = parcelRequire("3yqGI");

var $1tn7f = parcelRequire("1tn7f");

var $ffKfk = parcelRequire("ffKfk");
const $ce6fdf32d075b016$var$ExportedAnalyticsListener = (props)=>{
    const isModernContext = (0, $3yqGI.default) || (0, $VSDnB.fg)('analytics-next-use-modern-context_jira');
    return isModernContext ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ffKfk.default), {
        ...props
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1tn7f.default), {
        ...props
    });
};
var $ce6fdf32d075b016$export$2e2bcd8739ae039 = $ce6fdf32d075b016$var$ExportedAnalyticsListener;

});
parcelRegister("1tn7f", function(module, exports) {

$parcel$export(module.exports, "default", () => $c98d7a11ff60cbc2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8rCP3 = parcelRequire("8rCP3");

var $fy0vt = parcelRequire("fy0vt");
const $c98d7a11ff60cbc2$var$ContextTypes = {
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func,
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($8rCP3))).func
};
const $c98d7a11ff60cbc2$var$noop = ()=>[];
// eslint-disable-next-line @repo/internal/react/no-class-components
class $c98d7a11ff60cbc2$var$AnalyticsListener extends (0, $5uXOq.Component) {
    static{
        this.contextTypes = $c98d7a11ff60cbc2$var$ContextTypes;
    }
    static{
        this.childContextTypes = $c98d7a11ff60cbc2$var$ContextTypes;
    }
    constructor(props){
        super(props), this.getChildContext = ()=>({
                getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers,
                getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext
            }), this.getAnalyticsEventHandlers = ()=>{
            const { channel: channel, onEvent: onEvent } = this.props;
            const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = $c98d7a11ff60cbc2$var$noop } = this.context;
            const handler = (event, eventChannel)=>{
                if (channel === '*' || channel === eventChannel) onEvent(event, eventChannel);
            };
            return [
                handler,
                ...getAtlaskitAnalyticsEventHandlers()
            ];
        }, this.getAtlaskitAnalyticsContext = ()=>{
            const { getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext = $c98d7a11ff60cbc2$var$noop } = this.context;
            return getAtlaskitAnalyticsContext();
        };
        this.contextValue = {
            getAtlaskitAnalyticsContext: this.getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: this.getAnalyticsEventHandlers
        };
    }
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fy0vt.default).Provider, {
            value: this.contextValue,
            children: children
        });
    }
}
var $c98d7a11ff60cbc2$export$2e2bcd8739ae039 = $c98d7a11ff60cbc2$var$AnalyticsListener;

});

parcelRegister("ffKfk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f32ec1b00fc59f4c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fy0vt = parcelRequire("fy0vt");

var $7UMkI = parcelRequire("7UMkI");

var $lwCsy = parcelRequire("lwCsy");
const $f32ec1b00fc59f4c$var$AnalyticsListener = ({ children: children, channel: channel, onEvent: onEvent })=>{
    const { getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers = ()=>[], getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext } = (0, $7UMkI.useAnalyticsContext)();
    const onEventRef = (0, $lwCsy.useTrackedRef)(onEvent);
    const channelRef = (0, $lwCsy.useTrackedRef)(channel);
    const getAnalyticsEventHandlers = (0, $5uXOq.useCallback)(()=>{
        const thisHandler = (event, eventChannel)=>{
            if (channelRef.current === '*' || channelRef.current === eventChannel) onEventRef.current(event, eventChannel);
        };
        return [
            thisHandler,
            ...getAtlaskitAnalyticsEventHandlers()
        ];
    }, [
        channelRef,
        onEventRef,
        getAtlaskitAnalyticsEventHandlers
    ]);
    const value = (0, $5uXOq.useMemo)(()=>({
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: getAnalyticsEventHandlers
        }), [
        getAtlaskitAnalyticsContext,
        getAnalyticsEventHandlers
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fy0vt.default).Provider, {
        value: value,
        children: children
    });
};
var $f32ec1b00fc59f4c$export$2e2bcd8739ae039 = $f32ec1b00fc59f4c$var$AnalyticsListener;

});


parcelRegister("8Mzko", function(module, exports) {

$parcel$export(module.exports, "handleEvent", () => $bfef4f592754b2fa$export$d6e5ca10785815df);

var $eqmz9 = parcelRequire("eqmz9");

var $e52LY = parcelRequire("e52LY");
const $bfef4f592754b2fa$export$d6e5ca10785815df = (event, // If passing through multiple tags, the primary tag should be first in the array.
// The primary tag is used for matching context.
tags, logger, client)=>{
    if (!event.payload) return;
    const payload = (0, $e52LY.processEventPayload)(event, tags);
    (0, $eqmz9.sendEvent)(logger, client)(payload);
};

});
parcelRegister("eqmz9", function(module, exports) {

$parcel$export(module.exports, "sendEvent", () => $b39a96496b07abed$export$7329bcdc3edcd90e);
const $b39a96496b07abed$var$isPromise = (c)=>{
    return typeof c.then === 'function';
};
const $b39a96496b07abed$export$7329bcdc3edcd90e = (logger, client)=>(event)=>{
        if (client) {
            const { eventType: eventType, ...gasEvent } = event;
            const withClient = (cb)=>{
                if ($b39a96496b07abed$var$isPromise(client)) client.then(cb).catch((e)=>logger.warn('There was an error sending the event', e));
                else try {
                    cb(client);
                } catch (e) {
                    logger.warn('There was an error sending the event', e);
                }
            };
            switch(event.eventType){
                case 'ui':
                    logger.debug('Sending UI Event via analytics client', gasEvent);
                    withClient((client)=>client.sendUIEvent(gasEvent));
                    break;
                case 'operational':
                    logger.debug('Sending Operational Event via analytics client', gasEvent);
                    withClient((client)=>client.sendOperationalEvent(gasEvent));
                    break;
                case 'track':
                    logger.debug('Sending Track Event via analytics client', gasEvent);
                    withClient((client)=>client.sendTrackEvent(gasEvent));
                    break;
                case 'screen':
                    logger.debug('Sending Screen Event via analytics client', gasEvent);
                    withClient((client)=>client.sendScreenEvent(gasEvent));
                    break;
                default:
                    logger.error(`cannot map eventType ${event.eventType} to an analytics-web-client function`);
            }
        } else logger.warn('AnalyticsWebClient instance is not provided');
    };

});

parcelRegister("e52LY", function(module, exports) {

$parcel$export(module.exports, "processEventPayload", () => $9cef75674c0f5085$export$c37d638b7f2ca192);

parcelRequire("1PVpv");
var $d93fQ = parcelRequire("d93fQ");
var $6bTzA = parcelRequire("6bTzA");

var $1UikQ = parcelRequire("1UikQ");

var $3OX36 = parcelRequire("3OX36");

var $k2NeX = parcelRequire("k2NeX");
const $9cef75674c0f5085$var$extractFieldsFromContext = (fieldsToPick)=>(contexts)=>contexts.map((ctx)=>fieldsToPick.reduce((result, key)=>ctx[key] ? (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, {
                    [key]: ctx[key]
                }) : result, {})).reduce((result, item)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, item), {});
const $9cef75674c0f5085$var$fieldExtractor = (contextKey)=>$9cef75674c0f5085$var$extractFieldsFromContext([
        'source',
        'objectType',
        'objectId',
        'containerType',
        'containerId',
        contextKey
    ]);
const $9cef75674c0f5085$var$getContextKey = (tag)=>{
    switch(tag){
        case 0, $3OX36.ELEMENTS_TAG:
            return 0, $6bTzA.ELEMENTS_CONTEXT;
        case 0, $k2NeX.EDITOR_TAG:
            return 0, $d93fQ.EDITOR_CONTEXT;
        default:
            return '';
    }
};
const $9cef75674c0f5085$var$updatePayloadWithContext = (primaryTag, event)=>{
    if (event.context.length === 0) return {
        source: (0, $676c5e519aa5ba55$export$b055de0e665cb20c),
        ...event.payload
    };
    const contextKey = $9cef75674c0f5085$var$getContextKey(primaryTag) || 'attributes';
    const { [contextKey]: attributes, ...fields } = $9cef75674c0f5085$var$fieldExtractor(contextKey)(event.context);
    if (attributes) event.payload.attributes = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(attributes, event.payload.attributes || {});
    return {
        source: (0, $676c5e519aa5ba55$export$b055de0e665cb20c),
        ...fields,
        ...event.payload
    };
};
const $9cef75674c0f5085$var$addTags = (tags, originalTags = [])=>{
    const mergedTags = new Set([
        ...originalTags,
        ...tags
    ]);
    return Array.from(mergedTags);
};
/**
 * The primary tag is used for matching the analytics event payload
 * with its context.
 */ function $9cef75674c0f5085$var$getPrimaryTag(tags) {
    if (typeof tags === 'string') return tags;
    if (!tags.length) throw new Error('Empty tags string array. Unable to match analytics event payload with context');
    return tags[0];
}
const $9cef75674c0f5085$export$c37d638b7f2ca192 = (event, tags)=>{
    const primaryTag = $9cef75674c0f5085$var$getPrimaryTag(tags);
    const tagsArray = typeof tags === 'string' ? [
        tags
    ] : tags;
    return {
        ...$9cef75674c0f5085$var$updatePayloadWithContext(primaryTag, event),
        tags: $9cef75674c0f5085$var$addTags(tagsArray, event.payload.tags)
    };
};

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $676c5e519aa5ba55$export$a1562d08625f5d7e = 'ui';
const $676c5e519aa5ba55$export$947dac6c72b26f81 = 'track';
const $676c5e519aa5ba55$export$f1d537d508d2945a = 'screen';
const $676c5e519aa5ba55$export$12346a674644c156 = 'operational';
const $676c5e519aa5ba55$export$b055de0e665cb20c = 'unknown';

parcelRegister("k2NeX", function(module, exports) {

$parcel$export(module.exports, "EDITOR_TAG", () => $459b93a24e0bd23f$export$a1d9dc589a29b3aa);
$parcel$export(module.exports, "default", () => $459b93a24e0bd23f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $dWAZk = parcelRequire("dWAZk");

var $8Mzko = parcelRequire("8Mzko");
const $459b93a24e0bd23f$export$a1d9dc589a29b3aa = 'editor';
const $459b93a24e0bd23f$export$8aa0d788f94a809 = 'fabricEditor';
class $459b93a24e0bd23f$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
            onEvent: this.handleEventWrapper,
            channel: (0, $dWAZk.FabricChannel).editor,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.handleEventWrapper = (event)=>{
            (0, $8Mzko.handleEvent)(event, [
                $459b93a24e0bd23f$export$a1d9dc589a29b3aa,
                $459b93a24e0bd23f$export$8aa0d788f94a809
            ], this.props.logger, this.props.client);
        };
    }
}

});




parcelRegister("atyO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a958474021ee40ad$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $dVY8Y = parcelRequire("dVY8Y");

var $7gra0 = parcelRequire("7gra0");
function $a958474021ee40ad$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).atlaskit,
        processEvent: (0, $dVY8Y.default)
    });
}

});
parcelRegister("dVY8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $24c1d873a780dbe9$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");


var $8vDvF = parcelRequire("8vDvF");
const $24c1d873a780dbe9$var$ATLASKIT_TAG = 'atlaskit';
const $24c1d873a780dbe9$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the Atlaskit event format into the analytics platform format.
 *
 * Atlaskit event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $24c1d873a780dbe9$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $8vDvF.getSources)(event);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $8vDvF.getExtraAttributes)(event);
    const components = (0, $8vDvF.getComponents)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $8vDvF.getPackageInfo)(event)) || {};
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubjectId: actionSubjectId, attributes: payloadAttributes, containerId: containerId } = event.payload;
    const attributes = {
        listenerVersion: $24c1d873a780dbe9$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: (0, $8vDvF.getPackageHierarchy)(event) || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure atlaskit tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($24c1d873a780dbe9$var$ATLASKIT_TAG);
    if (event.payload) {
        if (eventType === (0, $676c5e519aa5ba55$export$a1562d08625f5d7e)) return {
            eventType: eventType,
            source: source,
            actionSubject: (0, $8vDvF.getActionSubject)(event),
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: attributes,
            containerId: containerId,
            tags: Array.from(tags)
        };
        if (eventType === (0, $676c5e519aa5ba55$export$947dac6c72b26f81) || eventType === (0, $676c5e519aa5ba55$export$12346a674644c156) || eventType === (0, $676c5e519aa5ba55$export$f1d537d508d2945a)) logger.error('Track, screen and operational events are currently not supported for atlaskit events');
        else logger.error('Invalid event type', eventType);
    }
    return null;
};

});
parcelRegister("8vDvF", function(module, exports) {

$parcel$export(module.exports, "extractFromEventContext", () => $02528f285214ef43$export$9b947b4502cd2705);
$parcel$export(module.exports, "getActionSubject", () => $02528f285214ef43$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getSources", () => $02528f285214ef43$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $02528f285214ef43$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $02528f285214ef43$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $02528f285214ef43$export$cd17d76da7967240);
$parcel$export(module.exports, "getPackageHierarchy", () => $02528f285214ef43$export$4e0b83da1896ebc7);
/**
 * Largely taken from analytics-web-react
 */ 
var $1UikQ = parcelRequire("1UikQ");
const $02528f285214ef43$export$9b947b4502cd2705 = (propertyName, event)=>event.context.map((contextItem)=>contextItem[propertyName]).filter(Boolean);
const $02528f285214ef43$export$6f40cdf6d42c018d = (event)=>{
    const overrides = $02528f285214ef43$export$9b947b4502cd2705('actionSubjectOverride', event);
    const closestContext = event.context.length > 0 ? event.context[event.context.length - 1] : {};
    const actionSubject = event.payload.actionSubject || closestContext.component;
    return overrides.length > 0 ? overrides[0] : actionSubject;
};
const $02528f285214ef43$export$5f9bc633b116660f = (event)=>$02528f285214ef43$export$9b947b4502cd2705('source', event);
const $02528f285214ef43$export$4e811121b221213b = (event)=>$02528f285214ef43$export$9b947b4502cd2705('component', event);
const $02528f285214ef43$export$67c3590839ebecdd = (event)=>$02528f285214ef43$export$9b947b4502cd2705('attributes', event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraAttributes), {});
const $02528f285214ef43$export$cd17d76da7967240 = (event)=>event.context.map((contextItem)=>({
            packageName: contextItem.packageName,
            packageVersion: contextItem.packageVersion
        })).filter((p)=>p.packageName);
const $02528f285214ef43$export$18cd124b5098d330 = (event)=>$02528f285214ef43$export$9b947b4502cd2705('packageVersion', event);
function $02528f285214ef43$export$4e0b83da1896ebc7(event) {
    const packages = $02528f285214ef43$export$cd17d76da7967240(event) || [];
    return packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName).join(',') || undefined;
}

});


parcelRegister("7gra0", function(module, exports) {

$parcel$export(module.exports, "default", () => $699d8bc24f150984$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bvUB1 = parcelRequire("bvUB1");

var $eqmz9 = parcelRequire("eqmz9");
class $699d8bc24f150984$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    render() {
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bvUB1.default), {
            onEvent: this.listenerHandler,
            channel: this.props.channel,
            children: this.props.children
        });
    }
    constructor(...args){
        super(...args), this.listenerHandler = (event)=>{
            const { client: client, logger: logger, channel: channel, processEvent: processEvent } = this.props;
            if (!event.payload) return;
            logger.debug(`Received ${channel} event`, event);
            const payload = processEvent(event, logger);
            logger.debug(`Processed ${channel} event`, payload);
            if (payload) (0, $eqmz9.sendEvent)(logger, client)(payload);
        };
    }
}

});


parcelRegister("11ek6", function(module, exports) {

$parcel$export(module.exports, "LOG_LEVEL", () => $608c07d146e813e1$export$ffe0c436e29512cf);
$parcel$export(module.exports, "default", () => $608c07d146e813e1$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $608c07d146e813e1$export$ffe0c436e29512cf = {
    DEBUG: 0,
    INFO: 1,
    WARN: 2,
    ERROR: 3,
    OFF: 4
};
class $608c07d146e813e1$export$2e2bcd8739ae039 {
    constructor({ logLevel: logLevel } = {}){
        this.logLevel = $608c07d146e813e1$export$ffe0c436e29512cf.OFF;
        if (typeof logLevel === 'number') this.setLogLevel(logLevel);
    }
    setLogLevel(logLevel) {
        if (logLevel >= $608c07d146e813e1$export$ffe0c436e29512cf.DEBUG && logLevel <= $608c07d146e813e1$export$ffe0c436e29512cf.OFF) this.logLevel = +logLevel;
        else this.logLevel = $608c07d146e813e1$export$ffe0c436e29512cf.OFF;
    }
    logMessage(level, type, ...args) {
        if (level >= this.logLevel) console[type](...args);
    }
    debug(...args) {
        this.logMessage($608c07d146e813e1$export$ffe0c436e29512cf.DEBUG, 'log', ...args);
    }
    info(...args) {
        this.logMessage($608c07d146e813e1$export$ffe0c436e29512cf.INFO, 'info', ...args);
    }
    warn(...args) {
        this.logMessage($608c07d146e813e1$export$ffe0c436e29512cf.WARN, 'warn', ...args);
    }
    error(...args) {
        this.logMessage($608c07d146e813e1$export$ffe0c436e29512cf.ERROR, 'error', ...args);
    }
}

});

parcelRegister("aTL5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f49dfceb13b3cd5$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $bQkP1 = parcelRequire("bQkP1");

var $7gra0 = parcelRequire("7gra0");
function $1f49dfceb13b3cd5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).navigation,
        processEvent: (0, $bQkP1.default)
    });
}

});
parcelRegister("bQkP1", function(module, exports) {

$parcel$export(module.exports, "default", () => $afbd40956436bfdd$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("1PVpv");
var $4sEDC = parcelRequire("4sEDC");

var $gGQei = parcelRequire("gGQei");
const $afbd40956436bfdd$var$NAVIGATION_TAG = 'navigation';
const $afbd40956436bfdd$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $afbd40956436bfdd$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $4sEDC.NAVIGATION_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $4sEDC.NAVIGATION_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $4sEDC.NAVIGATION_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $4sEDC.NAVIGATION_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gGQei.getPackageInfo)(event, (0, $4sEDC.NAVIGATION_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $afbd40956436bfdd$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($afbd40956436bfdd$var$NAVIGATION_TAG);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});
parcelRegister("gGQei", function(module, exports) {

$parcel$export(module.exports, "getSources", () => $1685d91551268510$export$5f9bc633b116660f);
$parcel$export(module.exports, "getComponents", () => $1685d91551268510$export$4e811121b221213b);
$parcel$export(module.exports, "getExtraAttributes", () => $1685d91551268510$export$67c3590839ebecdd);
$parcel$export(module.exports, "getPackageInfo", () => $1685d91551268510$export$cd17d76da7967240);
/**
 * Largely taken from analytics-web-react
 */ 
var $1UikQ = parcelRequire("1UikQ");
const $1685d91551268510$var$extractFromEventContext = (propertyNames, event, namespacedContextOnly = true, contextName)=>event.context.reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            const navContext = contextItem[contextName];
            const navContextProp = navContext ? navContext[propertyName] : null;
            const value = namespacedContextOnly ? navContextProp : navContextProp || contextItem[propertyName];
            if (value) acc.push(value);
        });
        return acc;
    }, []);
const $1685d91551268510$export$5f9bc633b116660f = (event, contextName)=>$1685d91551268510$var$extractFromEventContext([
        'source'
    ], event, false, contextName);
const $1685d91551268510$export$4e811121b221213b = (event, contextName)=>$1685d91551268510$var$extractFromEventContext([
        'component',
        'componentName'
    ], event, false, contextName);
const $1685d91551268510$export$67c3590839ebecdd = (event, contextName)=>$1685d91551268510$var$extractFromEventContext([
        'attributes'
    ], event, true, contextName).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(result, extraAttributes), {});
const $1685d91551268510$export$cd17d76da7967240 = (event, contextName)=>event.context.map((contextItem)=>{
        const navContext = contextItem[contextName];
        const item = navContext ? navContext : contextItem;
        return {
            packageName: item.packageName,
            packageVersion: item.packageVersion
        };
    }).filter((p)=>p.packageName);
const $1685d91551268510$export$18cd124b5098d330 = (event, contextName)=>$1685d91551268510$var$extractFromEventContext([
        'packageVersion'
    ], event, true, contextName);

});



parcelRegister("iiiw8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b8ff463fded57fb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $jwSDG = parcelRequire("jwSDG");

var $7gra0 = parcelRequire("7gra0");
function $9b8ff463fded57fb$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).media,
        processEvent: (0, $jwSDG.processEvent)
    });
}

});
parcelRegister("jwSDG", function(module, exports) {

$parcel$export(module.exports, "processEvent", () => $9c936535ea19d439$export$22af68e3614bf024);

parcelRequire("1PVpv");

var $1UikQ = parcelRequire("1UikQ");

var $hYfgW = parcelRequire("hYfgW");

var $8vDvF = parcelRequire("8vDvF");
const $9c936535ea19d439$var$listenerVersion = "0.0.0-use.local";
function $9c936535ea19d439$var$getMediaContexts(event) {
    return (0, $8vDvF.extractFromEventContext)((0, $b276966247f2f12d$export$70df29c238ba7306), event);
}
function $9c936535ea19d439$var$getMediaRegion() {
    try {
        return window && window.sessionStorage && window.sessionStorage.getItem('media-api-region');
    } catch (e) {
        return;
    }
}
function $9c936535ea19d439$export$22af68e3614bf024(event) {
    const sources = (0, $8vDvF.getSources)(event);
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $8vDvF.getPackageInfo)(event)) || {};
    const extraAttributes = (0, $8vDvF.getExtraAttributes)(event);
    const mediaContexts = $9c936535ea19d439$var$getMediaContexts(event) || [];
    const mediaAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, ...mediaContexts);
    const tags = new Set(event.payload.tags || []);
    tags.add('media');
    const components = (0, $8vDvF.getComponents)(event);
    const mediaRegion = $9c936535ea19d439$var$getMediaRegion();
    const payload = {
        source: (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c),
        actionSubject: event.payload.actionSubject,
        action: event.payload.action,
        eventType: event.payload.eventType,
        actionSubjectId: event.payload.actionSubjectId,
        // for backward compatibilty
        name: event.payload.name,
        tags: Array.from(tags),
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, extraAttributes, mediaAttributes, event.payload.attributes),
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: (0, $8vDvF.getPackageHierarchy)(event),
            sourceHierarchy: sources.join('.') || undefined,
            listenerVersion: $9c936535ea19d439$var$listenerVersion,
            ...mediaRegion ? {
                mediaRegion: mediaRegion
            } : undefined
        },
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
}

});


parcelRegister("7c0WJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e32629f4ab09b89f$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $75TRE = parcelRequire("75TRE");

var $7gra0 = parcelRequire("7gra0");
function $e32629f4ab09b89f$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).peopleTeams,
        processEvent: (0, $75TRE.default)
    });
}

});
parcelRegister("75TRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8e70800fbb0b364$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("1PVpv");
var $82PEg = parcelRequire("82PEg");

var $gGQei = parcelRequire("gGQei");
const $c8e70800fbb0b364$var$PEOPLE_TEAMS_TAG = 'peopleTeams';
const $c8e70800fbb0b364$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $c8e70800fbb0b364$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $82PEg.PEOPLE_TEAMS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $82PEg.PEOPLE_TEAMS_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $82PEg.PEOPLE_TEAMS_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $82PEg.PEOPLE_TEAMS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gGQei.getPackageInfo)(event, (0, $82PEg.PEOPLE_TEAMS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $c8e70800fbb0b364$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($c8e70800fbb0b364$var$PEOPLE_TEAMS_TAG);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("h08AR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c25e0721256779dd$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $hNdkx = parcelRequire("hNdkx");

var $7gra0 = parcelRequire("7gra0");
function $c25e0721256779dd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).notifications,
        processEvent: (0, $hNdkx.default)
    });
}

});
parcelRegister("hNdkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $efde88e27fba1dbe$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");


var $gGQei = parcelRequire("gGQei");
parcelRequire("1PVpv");
var $aa77w = parcelRequire("aa77w");

var $dWAZk = parcelRequire("dWAZk");
const $efde88e27fba1dbe$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $efde88e27fba1dbe$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $aa77w.NOTIFICATIONS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $aa77w.NOTIFICATIONS_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $aa77w.NOTIFICATIONS_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $aa77w.NOTIFICATIONS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gGQei.getPackageInfo)(event, (0, $aa77w.NOTIFICATIONS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $efde88e27fba1dbe$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $dWAZk.FabricChannel).notifications);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("jqTf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9df52c786362d8d9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $4wdgm = parcelRequire("4wdgm");

var $7gra0 = parcelRequire("7gra0");
function $9df52c786362d8d9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).recentWork,
        processEvent: (0, $4wdgm.default)
    });
}

});
parcelRegister("4wdgm", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a5647a7500d9abc$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");


var $gGQei = parcelRequire("gGQei");
parcelRequire("1PVpv");
var $dFBIZ = parcelRequire("dFBIZ");

var $dWAZk = parcelRequire("dWAZk");
const $9a5647a7500d9abc$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $9a5647a7500d9abc$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $dFBIZ.RECENT_WORK_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $dFBIZ.RECENT_WORK_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $dFBIZ.RECENT_WORK_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $dFBIZ.RECENT_WORK_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gGQei.getPackageInfo)(event, (0, $dFBIZ.RECENT_WORK_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $9a5647a7500d9abc$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $dWAZk.FabricChannel).recentWork);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("aBb5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8e5d1f85cf2472$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $829yz = parcelRequire("829yz");

var $7gra0 = parcelRequire("7gra0");
function $5f8e5d1f85cf2472$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).atlas,
        processEvent: (0, $829yz.default)
    });
}

});
parcelRegister("829yz", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb3fd10dfe7bbcb3$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");


var $gGQei = parcelRequire("gGQei");
parcelRequire("1PVpv");
var $334CK = parcelRequire("334CK");
const $eb3fd10dfe7bbcb3$var$ATLAS_TAG = 'atlas';
const $eb3fd10dfe7bbcb3$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $eb3fd10dfe7bbcb3$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $334CK.ATLAS_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $334CK.ATLAS_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $334CK.ATLAS_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $334CK.ATLAS_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gGQei.getPackageInfo)(event, (0, $334CK.ATLAS_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $eb3fd10dfe7bbcb3$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($eb3fd10dfe7bbcb3$var$ATLAS_TAG);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("cdITG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6efff2e5e2b7a8b9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $bcN18 = parcelRequire("bcN18");

var $7gra0 = parcelRequire("7gra0");
function $6efff2e5e2b7a8b9$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).crossFlow,
        processEvent: (0, $bcN18.default)
    });
}

});
parcelRegister("bcN18", function(module, exports) {

$parcel$export(module.exports, "default", () => $082255bb7ac3cecd$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 

var $hYfgW = parcelRequire("hYfgW");
parcelRequire("1PVpv");
var $4sEDC = parcelRequire("4sEDC");

var $8vDvF = parcelRequire("8vDvF");

var $gGQei = parcelRequire("gGQei");
const $082255bb7ac3cecd$var$CROSS_FLOW_TAG = 'crossFlow';
var $082255bb7ac3cecd$export$2e2bcd8739ae039 = (event, logger)=>{
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, name: name } = event.payload;
    let sources = (0, $8vDvF.getSources)(event);
    const lastSourceFromContext = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources);
    const source = event.payload.source ?? lastSourceFromContext;
    if (lastSourceFromContext !== source) sources.push(source);
    const attributes = {
        // To get extra attributes from AnalyticsContext from other products/platforms, e.g. Jira-frontend
        ...(0, $8vDvF.getExtraAttributes)(event),
        // To inherit the extra attributes from the navigation (Atlassian Switcher) context into the crossFlow events,
        // because the events current crossFlow touchpionts already inherit these attributes in the payload.
        ...(0, $gGQei.getExtraAttributes)(event, (0, $4sEDC.NAVIGATION_CONTEXT)),
        ...event.payload.attributes,
        namespaces: sources.join('.')
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($082255bb7ac3cecd$var$CROSS_FLOW_TAG);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("g2q31", function(module, exports) {

$parcel$export(module.exports, "default", () => $123301f0fff171e0$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $5Hi2S = parcelRequire("5Hi2S");

var $dWAZk = parcelRequire("dWAZk");

var $7gra0 = parcelRequire("7gra0");
function $123301f0fff171e0$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).linkingPlatform,
        processEvent: (0, $5Hi2S.default)
    });
}

});
parcelRegister("5Hi2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $8119fe56a665318a$export$2e2bcd8739ae039);

var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("1PVpv");
var $11Xme = parcelRequire("11Xme");

var $gGQei = parcelRequire("gGQei");

var $dWAZk = parcelRequire("dWAZk");
const $8119fe56a665318a$var$listenerVersion = "0.0.0-use.local";
var $8119fe56a665318a$export$2e2bcd8739ae039 = (event)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $11Xme.LINKING_PLATFORM_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $11Xme.LINKING_PLATFORM_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $11Xme.LINKING_PLATFORM_CONTEXT));
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $11Xme.LINKING_PLATFORM_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(packages) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const tags = new Set(event.payload.tags || []);
    tags.add((0, $dWAZk.FabricChannel).linkingPlatform);
    const payload = {
        name: event.payload.name,
        action: event.payload.action,
        actionSubject: event.payload.actionSubject,
        actionSubjectId: event.payload.actionSubjectId,
        eventType: event.payload.eventType,
        attributes: {
            packageName: packageName,
            packageVersion: packageVersion,
            listenerVersion: $8119fe56a665318a$var$listenerVersion,
            sourceHierarchy: sources.join('.') || undefined,
            componentHierarchy: components.join('.') || undefined,
            packageHierarchy: packageHierarchy.join(',') || undefined,
            ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, event.payload.attributes)
        },
        tags: Array.from(tags),
        source: (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c),
        nonPrivacySafeAttributes: event.payload.nonPrivacySafeAttributes
    };
    return payload;
};

});


parcelRegister("h8m2w", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa37129c8bcf6195$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $8ud9R = parcelRequire("8ud9R");

var $7gra0 = parcelRequire("7gra0");
function $fa37129c8bcf6195$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).postOffice,
        processEvent: (0, $8ud9R.default)
    });
}

});
parcelRegister("8ud9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f3df75f3a3414af$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("1PVpv");
var $i2uxb = parcelRequire("i2uxb");

var $gGQei = parcelRequire("gGQei");

var $dWAZk = parcelRequire("dWAZk");
const $3f3df75f3a3414af$var$POST_OFFICE_TAG = (0, $dWAZk.FabricChannel).postOffice;
const $3f3df75f3a3414af$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $3f3df75f3a3414af$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $i2uxb.POST_OFFICE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $i2uxb.POST_OFFICE_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $i2uxb.POST_OFFICE_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $i2uxb.POST_OFFICE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gGQei.getPackageInfo)(event, (0, $i2uxb.POST_OFFICE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $3f3df75f3a3414af$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($3f3df75f3a3414af$var$POST_OFFICE_TAG);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("4Fo1a", function(module, exports) {

$parcel$export(module.exports, "default", () => $954c1b60e928a432$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $bW1UO = parcelRequire("bW1UO");

var $7gra0 = parcelRequire("7gra0");
function $954c1b60e928a432$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).aiMate,
        processEvent: (0, $bW1UO.default)
    });
}

});
parcelRegister("bW1UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a6e2118d92159c$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("1PVpv");
var $3bERc = parcelRequire("3bERc");

var $gGQei = parcelRequire("gGQei");
const $e8a6e2118d92159c$var$AI_MATE_TAG = 'aiMate';
const $e8a6e2118d92159c$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $e8a6e2118d92159c$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $3bERc.AI_MATE_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $3bERc.AI_MATE_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $3bERc.AI_MATE_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $3bERc.AI_MATE_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gGQei.getPackageInfo)(event, (0, $3bERc.AI_MATE_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $e8a6e2118d92159c$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($e8a6e2118d92159c$var$AI_MATE_TAG);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("1ZdOg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2146241625da39db$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $fVbZF = parcelRequire("fVbZF");

var $7gra0 = parcelRequire("7gra0");
function $2146241625da39db$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).avp,
        processEvent: (0, $fVbZF.default)
    });
}

});
parcelRegister("fVbZF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d04c17a8d96daccd$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("1PVpv");
var $7tjJx = parcelRequire("7tjJx");

var $gGQei = parcelRequire("gGQei");
const $d04c17a8d96daccd$var$AVP_TAG = 'avp';
const $d04c17a8d96daccd$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $d04c17a8d96daccd$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $7tjJx.AVP_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $7tjJx.AVP_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $7tjJx.AVP_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $7tjJx.AVP_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gGQei.getPackageInfo)(event, (0, $7tjJx.AVP_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $d04c17a8d96daccd$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, ...event.context)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($d04c17a8d96daccd$var$AVP_TAG);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});


parcelRegister("eTLWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7269e3b7977f492d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dWAZk = parcelRequire("dWAZk");

var $iLSwp = parcelRequire("iLSwp");

var $7gra0 = parcelRequire("7gra0");
function $7269e3b7977f492d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7gra0.default), {
        ...props,
        channel: (0, $dWAZk.FabricChannel).growth,
        processEvent: (0, $iLSwp.default)
    });
}

});
parcelRegister("iLSwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a9913210d16a296$export$2e2bcd8739ae039);
/**
 * Inspired by analytics-web-react
 */ 
var $hYfgW = parcelRequire("hYfgW");

var $1UikQ = parcelRequire("1UikQ");

parcelRequire("1PVpv");
var $2qof0 = parcelRequire("2qof0");

var $gGQei = parcelRequire("gGQei");
const $9a9913210d16a296$var$GROWTH_TAG = 'growth';
const $9a9913210d16a296$var$listenerVersion = "0.0.0-use.local";
var /**
 * This util exists to convert the analytics-next event format into the analytics platform format.
 *
 * Analytics-next event format:
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Analytics platform event format:
 *  event {
 *      type: @atlaskit/analytics-gas-types.EventType
 *      payload {
 *          ...mandatoryAttributesBasedOnEventType
 *          attributes: {
 *              ...arbitraryAttributes
 *          }
 *      }
 *  }
 */ $9a9913210d16a296$export$2e2bcd8739ae039 = (event, logger)=>{
    const sources = (0, $gGQei.getSources)(event, (0, $2qof0.GROWTH_CONTEXT));
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(sources) || (0, $676c5e519aa5ba55$export$b055de0e665cb20c);
    const extraAttributes = (0, $gGQei.getExtraAttributes)(event, (0, $2qof0.GROWTH_CONTEXT));
    const components = (0, $gGQei.getComponents)(event, (0, $2qof0.GROWTH_CONTEXT));
    const packages = (0, $gGQei.getPackageInfo)(event, (0, $2qof0.GROWTH_CONTEXT));
    const { packageName: packageName, packageVersion: packageVersion } = (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, $gGQei.getPackageInfo)(event, (0, $2qof0.GROWTH_CONTEXT))) || {};
    const packageHierarchy = packages.map((p)=>p.packageVersion ? `${p.packageName}@${p.packageVersion}` : p.packageName);
    const { eventType: eventType = (0, $676c5e519aa5ba55$export$a1562d08625f5d7e), action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: payloadAttributes, name: name } = event.payload;
    const attributes = {
        listenerVersion: $9a9913210d16a296$var$listenerVersion,
        sourceHierarchy: sources.join('.') || undefined,
        componentHierarchy: components.join('.') || undefined,
        packageHierarchy: packageHierarchy.join(',') || undefined,
        packageName: packageName,
        packageVersion: packageVersion,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(extraAttributes, payloadAttributes)
    };
    // Ensure navigation tag is not duplicated by using Set
    const tags = new Set(event.payload.tags || []);
    tags.add($9a9913210d16a296$var$GROWTH_TAG);
    if (event.payload) switch(eventType){
        case 0, $676c5e519aa5ba55$export$a1562d08625f5d7e:
        case 0, $676c5e519aa5ba55$export$12346a674644c156:
        case 0, $676c5e519aa5ba55$export$947dac6c72b26f81:
            return {
                eventType: eventType,
                source: source,
                actionSubject: actionSubject,
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: attributes,
                tags: Array.from(tags)
            };
        case 0, $676c5e519aa5ba55$export$f1d537d508d2945a:
            return {
                eventType: eventType,
                name: name,
                attributes: attributes,
                tags: Array.from(tags)
            };
        default:
            logger.error('Invalid event type', eventType);
            break;
    }
    return null;
};

});




parcelRegister("cYqgi", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("epfFv")).default);
$parcel$export(module.exports, "AutoDismissFlag", () => (parcelRequire("fWXJB")).default);
$parcel$export(module.exports, "FlagGroup", () => (parcelRequire("6ARj7")).default);
$parcel$export(module.exports, "useFlags", () => (parcelRequire("bKCvK")).useFlags);
$parcel$export(module.exports, "withFlagsProvider", () => (parcelRequire("bKCvK")).withFlagsProvider);
$parcel$export(module.exports, "FlagsProvider", () => (parcelRequire("bKCvK")).FlagsProvider);

var $epfFv = parcelRequire("epfFv");

var $fWXJB = parcelRequire("fWXJB");

var $6ARj7 = parcelRequire("6ARj7");

var $bKCvK = parcelRequire("bKCvK");

});
parcelRegister("epfFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc9b5e5cdcf0a64$export$2e2bcd8739ae039);
/* flag.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $jldZL = parcelRequire("jldZL");


var $aB5C5 = parcelRequire("aB5C5");

var $6ARj7 = parcelRequire("6ARj7");

var $yPPrD = parcelRequire("yPPrD");
var $bFliP = parcelRequire("bFliP");

var $hZKVY = parcelRequire("hZKVY");
const $bbc9b5e5cdcf0a64$var$styles = {
    overflowWrap: "_1i4qfg65",
    flag: "_2rkosqtm _1reo15vq _18m915vq _v564z97a _16qs8sq4 _1pbyni7l _1bsb1osq"
};
const $bbc9b5e5cdcf0a64$var$CSS_VAR_ICON_COLOR = '--flag-icon-color';
const $bbc9b5e5cdcf0a64$var$oldDescriptionStyles = null;
const $bbc9b5e5cdcf0a64$var$descriptionStyles = null;
const $bbc9b5e5cdcf0a64$var$oldIconWrapperStyles = null;
const $bbc9b5e5cdcf0a64$var$iconWrapperStyles = null;
const $bbc9b5e5cdcf0a64$var$flagWrapperStyles = null;
const $bbc9b5e5cdcf0a64$var$analyticsAttributes = {
    componentName: 'flag',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $bbc9b5e5cdcf0a64$var$transitionStyles = null; /**
                                * __Flag__
                                *
                                * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
                                * often displayed using a flag group.
                                *
                                * - [Examples](https://atlassian.design/components/flag/examples)
                                * - [Code](https://atlassian.design/components/flag/code)
                                * - [Usage](https://atlassian.design/components/flag/usage)
                                */ 
const $bbc9b5e5cdcf0a64$var$Flag = (props)=>{
    const { actions: actions = [], appearance: appearance = (0, $ff8b18549b2c06bf$export$d6830277b06edd6), icon: icon, title: title, description: description, linkComponent: linkComponent, onMouseOver: onMouseOver, onFocus: onFocus = (0, $eGmKJ.default), onMouseOut: onMouseOut, onBlur: onBlur = (0, $eGmKJ.default), onDismissed: onDismissedProp = (0, $eGmKJ.default), testId: testId, id: id, analyticsContext: analyticsContext, delayAnnouncement: delayAnnouncement, headingLevel: headingLevel = 2 } = props;
    const [isDelayToAnnounce, setIsDelayToAnnounce] = (0, $5uXOq.useState)(false);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $6ARj7.useFlagGroup)();
    const onDismissed = (0, $5uXOq.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(false);
    const onDismissedAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        ...$bbc9b5e5cdcf0a64$var$analyticsAttributes
    });
    const isBold = appearance !== (0, $ff8b18549b2c06bf$export$d6830277b06edd6);
    const toggleExpand = (0, $5uXOq.useCallback)(()=>{
        setIsExpanded((previous)=>!previous);
    }, []);
    const buttonActionCallback = (0, $5uXOq.useCallback)(()=>{
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!delayAnnouncement) return;
        setTimeout(()=>{
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    const onFocusAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onFocus,
        action: 'focused',
        analyticsData: analyticsContext,
        ...$bbc9b5e5cdcf0a64$var$analyticsAttributes
    });
    const onBlurAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onBlur,
        action: 'blurred',
        analyticsData: analyticsContext,
        ...$bbc9b5e5cdcf0a64$var$analyticsAttributes
    });
    const autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    const textColor = (0, $hZKVY.flagTextColor)[appearance];
    const iconColor = (0, $hZKVY.flagIconColor)[appearance];
    const iconGlyph = (0, $hZKVY.flagIconGlyph)[appearance];
    const isDismissable = isBold || isDismissAllowed;
    const shouldRenderGap = !isBold && (description || actions.length) || isExpanded; // when delayAnnouncement is available we will use a hidden content for announcement
    const delayedAnnouncement = delayAnnouncement ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $jldZL.default), {
        children: [
            title,
            description
        ]
    }) : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        role: "alert",
        "data-testid": testId,
        ...autoDismissProps,
        className: (0, $bwpsq.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            padding: "space.200",
            backgroundColor: (0, $hZKVY.flagBackgroundColor)[appearance],
            xcss: $bbc9b5e5cdcf0a64$var$styles.flag,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                alignBlock: (0, $VSDnB.fg)('platform_ads_component_no_icon_spacing_support') ? 'start' : 'stretch',
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    , {
                        style: {
                            [$bbc9b5e5cdcf0a64$var$CSS_VAR_ICON_COLOR]: iconColor
                        },
                        "data-testid": testId && `${testId}-icon-container`,
                        className: (0, $bwpsq.default)([
                            (0, $VSDnB.fg)('platform_ads_component_no_icon_spacing_support') ? "_1e0c1txw _1ul91tcg _1tke1tcg _4cvr1h6o _1bah1h6o _1o9zidpf _syaz1jn0" : "_1e0c1txw _4cvrv2br _1o9zidpf _syaz1jn0"
                        ]),
                        children: icon || (iconGlyph && (0, $VSDnB.fg)('platform_ads_component_no_icon_spacing_support') ? iconGlyph : null)
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                        className: (0, $bwpsq.default)([
                            "_v5641hdc _16jlkb7n"
                        ]),
                        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                            space: shouldRenderGap ? 'space.100' : 'space.0',
                            children: [
                                isDelayToAnnounce && delayedAnnouncement,
                                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                                    alignBlock: "stretch",
                                    space: "space.100",
                                    spread: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                                            paddingBlockStart: "space.050",
                                            paddingBlockEnd: "space.025",
                                            xcss: $bbc9b5e5cdcf0a64$var$styles.overflowWrap,
                                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                                                as: `h${headingLevel}`,
                                                size: "xsmall",
                                                color: textColor,
                                                children: /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                                                    /* if isDelayToAnnounce is true, we will hide the content form screen reader to avoid duplicate announcement */ "aria-hidden": isDelayToAnnounce,
                                                    children: title
                                                })
                                            })
                                        }),
                                        isDismissable ? !(isBold && !description && !actions.length) && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $yPPrD.default), {
                                            testId: testId,
                                            appearance: appearance,
                                            isBold: isBold,
                                            isExpanded: isExpanded,
                                            onClick: isBold ? toggleExpand : buttonActionCallback
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $bFliP.default), {
                                    isExpanded: !isBold || isExpanded,
                                    testId: testId,
                                    children: [
                                        description && /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                        , {
                                            style: {
                                                color: (0, $hZKVY.flagTextColorToken)[appearance]
                                            },
                                            "data-testid": testId && `${testId}-description`,
                                            "aria-hidden": isDelayToAnnounce,
                                            className: (0, $bwpsq.default)([
                                                (0, $VSDnB.fg)('platform_ads_explicit_font_styles') ? "_11c82smr _1reo1wug _18m91wug _c71l53f4 _1i4qfg65" : "_1reo1wug _18m91wug _c71l53f4 _1i4qfg65"
                                            ]),
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aB5C5.default), {
                                            actions: actions,
                                            appearance: appearance,
                                            linkComponent: linkComponent,
                                            testId: testId
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
var $bbc9b5e5cdcf0a64$export$2e2bcd8739ae039 = $bbc9b5e5cdcf0a64$var$Flag;

});
parcelRegister("l1N8i", function(module, exports) {

$parcel$export(module.exports, "default", () => $8055cb9560a32d8d$export$2e2bcd8739ae039);
/* heading.partial.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $55sHU = parcelRequire("55sHU");

var $aCkBt = parcelRequire("aCkBt");

var $lfdem = parcelRequire("lfdem");

var $6cAn5 = parcelRequire("6cAn5");
const $8055cb9560a32d8d$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
const $8055cb9560a32d8d$var$styles = {
    reset: "_1mouidpf _1dyz4jg8 _1p1dglyw"
};
const $8055cb9560a32d8d$var$headingColorStylesMap = {
    'color.text': "_syaz1fxt",
    'color.text.inverse': "_syaz15cr",
    'color.text.warning.inverse': "_syazal3n"
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c47bed69b7a147a63fdb8c394e98514a>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ const $8055cb9560a32d8d$var$headingSizeStylesMap = {
    xxlarge: "_11c84xcc",
    xlarge: "_11c81c04",
    large: "_11c8nf1z",
    medium: "_11c8lodh",
    small: "_11c8nbxd",
    xsmall: "_11c8140y",
    xxsmall: "_11c81vhk"
};
/**
 * @codegenEnd
 */ const $8055cb9560a32d8d$var$useColor = (colorProp)=>{
    const surface = (0, $aCkBt.useSurface)();
    if (colorProp) return colorProp;
    if ((0, $55sHU.inverseColorMap).hasOwnProperty(surface)) return (0, $55sHU.inverseColorMap)[surface];
    return 'color.text';
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ const $8055cb9560a32d8d$var$Heading = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { children: children, size: size, id: id, testId: testId, as: as, color: colorProp } = props;
    typeof $6cAn5;
    const [hLevel, inferredElement] = (0, $lfdem.useHeading)($8055cb9560a32d8d$var$sizeTagMap[size]);
    const Component = as || inferredElement;
    const needsAriaRole = Component === 'div' && hLevel;
    const color = $8055cb9560a32d8d$var$useColor(colorProp);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        ref: ref,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        className: (0, $bwpsq.default)([
            $8055cb9560a32d8d$var$styles.reset,
            size && $8055cb9560a32d8d$var$headingSizeStylesMap[size],
            $8055cb9560a32d8d$var$headingColorStylesMap[color]
        ]),
        children: children
    });
});
var $8055cb9560a32d8d$export$2e2bcd8739ae039 = $8055cb9560a32d8d$var$Heading;

});
parcelRegister("55sHU", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $14eb19ed8aa4d37e$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $14eb19ed8aa4d37e$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $14eb19ed8aa4d37e$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $14eb19ed8aa4d37e$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $14eb19ed8aa4d37e$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $14eb19ed8aa4d37e$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $14eb19ed8aa4d37e$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $14eb19ed8aa4d37e$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $14eb19ed8aa4d37e$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $14eb19ed8aa4d37e$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $14eb19ed8aa4d37e$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $14eb19ed8aa4d37e$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "fontMap", () => $14eb19ed8aa4d37e$export$6ffa317d5e70375);
$parcel$export(module.exports, "fontWeightMap", () => $14eb19ed8aa4d37e$export$303e322c6b1ed114);
$parcel$export(module.exports, "fontFamilyMap", () => $14eb19ed8aa4d37e$export$3c7e9587132614b4);
$parcel$export(module.exports, "paddingStylesMap", () => $14eb19ed8aa4d37e$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $14eb19ed8aa4d37e$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $14eb19ed8aa4d37e$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $14eb19ed8aa4d37e$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "textSizeStylesMap", () => $14eb19ed8aa4d37e$export$219d364c0da35ae4);
$parcel$export(module.exports, "textWeightStylesMap", () => $14eb19ed8aa4d37e$export$38845ca010b93505);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $14eb19ed8aa4d37e$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $14eb19ed8aa4d37e$export$5e65a44e5b6ecadb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $f8Sb3 = parcelRequire("f8Sb3");

var $f8twK = parcelRequire("f8twK");
const $14eb19ed8aa4d37e$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $14eb19ed8aa4d37e$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $14eb19ed8aa4d37e$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $14eb19ed8aa4d37e$export$632685d741f3dbbf = {
    ...$14eb19ed8aa4d37e$export$958d0ae7f2977ae4,
    ...$14eb19ed8aa4d37e$export$d2dc61f58390201c
};
const $14eb19ed8aa4d37e$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $14eb19ed8aa4d37e$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $14eb19ed8aa4d37e$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $14eb19ed8aa4d37e$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $14eb19ed8aa4d37e$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $14eb19ed8aa4d37e$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $14eb19ed8aa4d37e$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $14eb19ed8aa4d37e$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B778C)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $14eb19ed8aa4d37e$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $14eb19ed8aa4d37e$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $14eb19ed8aa4d37e$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $14eb19ed8aa4d37e$export$6ffa317d5e70375 = {
    'font.body': "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.UNSAFE_small': "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.code': "var(--ds-font-code, normal 400 0.875em/1 ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.heading.large': "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.medium': "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.small': "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xlarge': "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xsmall': "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxlarge': "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.heading.xxsmall': "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $14eb19ed8aa4d37e$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 700)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $14eb19ed8aa4d37e$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $14eb19ed8aa4d37e$export$236bfe3a33ef1292 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $14eb19ed8aa4d37e$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
// Generate maps for Box props. backgroundColor, padding, etc
const $14eb19ed8aa4d37e$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = /*#__PURE__*/ (0, $f8Sb3.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $14eb19ed8aa4d37e$export$e615f061ca585a6c = $14eb19ed8aa4d37e$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7(spacingProperty, $14eb19ed8aa4d37e$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $14eb19ed8aa4d37e$export$bf46c3f9eeafc71f = $14eb19ed8aa4d37e$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7(spacingProperty, $14eb19ed8aa4d37e$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $14eb19ed8aa4d37e$export$e7af83bafe7f9e63 = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7('backgroundColor', $14eb19ed8aa4d37e$export$d1d79bf68ac056bd);
const $14eb19ed8aa4d37e$export$3a1bcba60b23d7f0 = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7('color', $14eb19ed8aa4d37e$export$8473307aa00d6ea1);
const $14eb19ed8aa4d37e$export$45f3f4fe16f9f7d5 = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7('fontWeight', $14eb19ed8aa4d37e$export$303e322c6b1ed114);
const $14eb19ed8aa4d37e$export$68cc305da27dbaa4 = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7('fontFamily', $14eb19ed8aa4d37e$export$3c7e9587132614b4);
const $14eb19ed8aa4d37e$export$128f10c238242f83 = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7('font', $14eb19ed8aa4d37e$export$6ffa317d5e70375);
const $14eb19ed8aa4d37e$export$219d364c0da35ae4 = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7('font', $14eb19ed8aa4d37e$export$236bfe3a33ef1292);
const $14eb19ed8aa4d37e$export$38845ca010b93505 = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7('fontWeight', $14eb19ed8aa4d37e$export$855cfd311192d666);
const $14eb19ed8aa4d37e$export$ff257d957d48c421 = $14eb19ed8aa4d37e$export$ca0f9c2de39ffed7((0, $f8twK.CURRENT_SURFACE_CSS_VAR), $14eb19ed8aa4d37e$export$41a358c9c2356760);
const $14eb19ed8aa4d37e$export$5e65a44e5b6ecadb = (color)=>$14eb19ed8aa4d37e$export$41a358c9c2356760[color] !== undefined;

});
parcelRegister("f8twK", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $5ea767242ca11bf1$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $5ea767242ca11bf1$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $5ea767242ca11bf1$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $5ea767242ca11bf1$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $5ea767242ca11bf1$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $5ea767242ca11bf1$export$9d7b58831ae93caa);
const $5ea767242ca11bf1$export$4ef52930e33717cd = 'data-theme';
const $5ea767242ca11bf1$export$a00eac3f8684bcd0 = 'data-color-mode';
const $5ea767242ca11bf1$export$2112803007239c61 = 'data-contrast-mode';
const $5ea767242ca11bf1$export$352e418ed5b6193a = 'data-custom-theme';
const $5ea767242ca11bf1$export$6f0c6fb8c80fcc92 = 'ds';
const $5ea767242ca11bf1$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
const $5ea767242ca11bf1$export$dddac1532e822863 = `--${$5ea767242ca11bf1$export$6f0c6fb8c80fcc92}-token-not-found`;
const $5ea767242ca11bf1$export$9d7b58831ae93caa = `--${$5ea767242ca11bf1$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});


parcelRegister("aCkBt", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $89aa358534da83d3$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $89aa358534da83d3$export$1aeb4f6b93c4540d);

var $5uXOq = parcelRequire("5uXOq");
const $89aa358534da83d3$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5uXOq.createContext)('elevation.surface');
const $89aa358534da83d3$export$1aeb4f6b93c4540d = ()=>{
    return (0, $5uXOq.useContext)($89aa358534da83d3$export$1ca2a26fecb070ae);
};
$89aa358534da83d3$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});

parcelRegister("lfdem", function(module, exports) {

$parcel$export(module.exports, "useHeading", () => $2f043ada89a3b8b1$export$97a37b1befbbf9b1);
$parcel$export(module.exports, "default", () => $2f043ada89a3b8b1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
const $2f043ada89a3b8b1$var$HeadingLevelContext = /*#__PURE__*/ (0, $5uXOq.createContext)(0);
/**
 * @internal
 * @returns The current heading level context.
 */ const $2f043ada89a3b8b1$var$useHeadingLevel = ()=>{
    return (0, $5uXOq.useContext)($2f043ada89a3b8b1$var$HeadingLevelContext);
};
const $2f043ada89a3b8b1$export$97a37b1befbbf9b1 = (fallback)=>{
    const hLevel = $2f043ada89a3b8b1$var$useHeadingLevel();
    /**
	 * Order here is important, we for now apply
	 * 1. inferred a11y level (this only applies if context is present)
	 * 2. default final fallback
	 */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : `h${hLevel}`) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ const $2f043ada89a3b8b1$var$HeadingLevelContextProvider = ({ children: children, value: value })=>{
    const parentHeadingLevel = $2f043ada89a3b8b1$var$useHeadingLevel();
    const headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2f043ada89a3b8b1$var$HeadingLevelContext.Provider, {
        value: value || headingLevel,
        children: children
    });
};
var $2f043ada89a3b8b1$export$2e2bcd8739ae039 = $2f043ada89a3b8b1$var$HeadingLevelContextProvider;

});


parcelRegister("MHKc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $57f1138a169e9ef6$export$2e2bcd8739ae039);
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $aCkBt = parcelRequire("aCkBt");
const $57f1138a169e9ef6$var$baseStyles = null;
const $57f1138a169e9ef6$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhk1fno",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1eds",
    'color.background.accent.lime.subtler.pressed': "_bfhk1hgz",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhkhgj8",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhk1b17",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhk1pbw",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkrw5d",
    'color.background.accent.red.subtler.pressed': "_bfhk69rw",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1tf4",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhkprmn",
    'color.background.accent.orange.subtlest': "_bfhk1g3m",
    'color.background.accent.orange.subtlest.hovered': "_bfhkg4tm",
    'color.background.accent.orange.subtlest.pressed': "_bfhk1ya0",
    'color.background.accent.orange.subtler': "_bfhkf2vu",
    'color.background.accent.orange.subtler.hovered': "_bfhk1lml",
    'color.background.accent.orange.subtler.pressed': "_bfhkuxsx",
    'color.background.accent.orange.subtle': "_bfhk1g6e",
    'color.background.accent.orange.subtle.hovered': "_bfhk1oew",
    'color.background.accent.orange.subtle.pressed': "_bfhk1phk",
    'color.background.accent.orange.bolder': "_bfhkjgng",
    'color.background.accent.orange.bolder.hovered': "_bfhkhi52",
    'color.background.accent.orange.bolder.pressed': "_bfhkf767",
    'color.background.accent.yellow.subtlest': "_bfhk1ozg",
    'color.background.accent.yellow.subtlest.hovered': "_bfhk19g9",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk31d1",
    'color.background.accent.yellow.subtler': "_bfhk3fv2",
    'color.background.accent.yellow.subtler.hovered': "_bfhklg04",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1d44",
    'color.background.accent.yellow.subtle': "_bfhkry5t",
    'color.background.accent.yellow.subtle.hovered': "_bfhk17e6",
    'color.background.accent.yellow.subtle.pressed': "_bfhko0y5",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk32kj",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkv5yf",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhkung8",
    'color.background.accent.green.subtler.pressed': "_bfhk1p19",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk8h4p",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1azz",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1j2h",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkg5py",
    'color.background.accent.teal.subtler.pressed': "_bfhkq7li",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk10ai",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhkse6l",
    'color.background.accent.blue.subtlest': "_bfhkavxe",
    'color.background.accent.blue.subtlest.hovered': "_bfhkay3p",
    'color.background.accent.blue.subtlest.pressed': "_bfhk1xmr",
    'color.background.accent.blue.subtler': "_bfhk4v9p",
    'color.background.accent.blue.subtler.hovered': "_bfhk16e6",
    'color.background.accent.blue.subtler.pressed': "_bfhk1uh7",
    'color.background.accent.blue.subtle': "_bfhk1j89",
    'color.background.accent.blue.subtle.hovered': "_bfhk1f4s",
    'color.background.accent.blue.subtle.pressed': "_bfhkqctv",
    'color.background.accent.blue.bolder': "_bfhkc8cv",
    'color.background.accent.blue.bolder.hovered': "_bfhk1cwi",
    'color.background.accent.blue.bolder.pressed': "_bfhkhcrq",
    'color.background.accent.purple.subtlest': "_bfhkp7j4",
    'color.background.accent.purple.subtlest.hovered': "_bfhkm0d5",
    'color.background.accent.purple.subtlest.pressed': "_bfhkgslw",
    'color.background.accent.purple.subtler': "_bfhk1jkz",
    'color.background.accent.purple.subtler.hovered': "_bfhk1wyu",
    'color.background.accent.purple.subtler.pressed': "_bfhk5fkp",
    'color.background.accent.purple.subtle': "_bfhkdh45",
    'color.background.accent.purple.subtle.hovered': "_bfhk1wob",
    'color.background.accent.purple.subtle.pressed': "_bfhkwz05",
    'color.background.accent.purple.bolder': "_bfhkygwo",
    'color.background.accent.purple.bolder.hovered': "_bfhkadgs",
    'color.background.accent.purple.bolder.pressed': "_bfhk1uro",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1een",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1r0p",
    'color.background.accent.magenta.subtler.pressed': "_bfhkxuzc",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk1ovh",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkwaw3",
    'color.background.accent.gray.subtlest': "_bfhk11bn",
    'color.background.accent.gray.subtlest.hovered': "_bfhk12j4",
    'color.background.accent.gray.subtlest.pressed': "_bfhk1lb4",
    'color.background.accent.gray.subtler': "_bfhk1v33",
    'color.background.accent.gray.subtler.hovered': "_bfhk1f7l",
    'color.background.accent.gray.subtler.pressed': "_bfhkd8a2",
    'color.background.accent.gray.subtle': "_bfhk1t05",
    'color.background.accent.gray.subtle.hovered': "_bfhk1a2l",
    'color.background.accent.gray.subtle.pressed': "_bfhk1z0s",
    'color.background.accent.gray.bolder': "_bfhk1t1b",
    'color.background.accent.gray.bolder.hovered': "_bfhke4nv",
    'color.background.accent.gray.bolder.pressed': "_bfhk82ra",
    'color.background.disabled': "_bfhksyzs",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhk1d5g",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhkm7j4",
    'color.background.neutral.hovered': "_bfhk15ej",
    'color.background.neutral.pressed': "_bfhkip91",
    'color.background.neutral.subtle': "_bfhk1w7a",
    'color.background.neutral.subtle.hovered': "_bfhk166n",
    'color.background.neutral.subtle.pressed': "_bfhk1dty",
    'color.background.neutral.bold': "_bfhkcdhy",
    'color.background.neutral.bold.hovered': "_bfhk1bsc",
    'color.background.neutral.bold.pressed': "_bfhk1b6k",
    'color.background.selected': "_bfhkfg4m",
    'color.background.selected.hovered': "_bfhki1yw",
    'color.background.selected.pressed': "_bfhk19ru",
    'color.background.selected.bold': "_bfhk1fvw",
    'color.background.selected.bold.hovered': "_bfhk18hz",
    'color.background.selected.bold.pressed': "_bfhkgr1v",
    'color.background.brand.subtlest': "_bfhk3wxy",
    'color.background.brand.subtlest.hovered': "_bfhkezq1",
    'color.background.brand.subtlest.pressed': "_bfhk2ggb",
    'color.background.brand.bold': "_bfhkb29m",
    'color.background.brand.bold.hovered': "_bfhku1se",
    'color.background.brand.bold.pressed': "_bfhkqkzo",
    'color.background.brand.boldest': "_bfhk15mt",
    'color.background.brand.boldest.hovered': "_bfhk1uwk",
    'color.background.brand.boldest.pressed': "_bfhk17jr",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1io2",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk9pqq",
    'color.background.warning': "_bfhk1tzq",
    'color.background.warning.hovered': "_bfhk1rd4",
    'color.background.warning.pressed': "_bfhk11dh",
    'color.background.warning.bold': "_bfhk190i",
    'color.background.warning.bold.hovered': "_bfhk1i4c",
    'color.background.warning.bold.pressed': "_bfhkrj9s",
    'color.background.success': "_bfhkmv6i",
    'color.background.success.hovered': "_bfhk1jgi",
    'color.background.success.pressed': "_bfhky4f1",
    'color.background.success.bold': "_bfhk8emd",
    'color.background.success.bold.hovered': "_bfhk1q4l",
    'color.background.success.bold.pressed': "_bfhkcrcn",
    'color.background.discovery': "_bfhk1nvp",
    'color.background.discovery.hovered': "_bfhk1xp7",
    'color.background.discovery.pressed': "_bfhkdlkp",
    'color.background.discovery.bold': "_bfhk1lri",
    'color.background.discovery.bold.hovered': "_bfhk1w72",
    'color.background.discovery.bold.pressed': "_bfhkrb53",
    'color.background.information': "_bfhk33gi",
    'color.background.information.hovered': "_bfhk1vps",
    'color.background.information.pressed': "_bfhk1s0z",
    'color.background.information.bold': "_bfhk14wj",
    'color.background.information.bold.hovered': "_bfhk1amz",
    'color.background.information.bold.pressed': "_bfhk5bth",
    'color.blanket': "_bfhk10xm",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkn82g",
    'color.skeleton.subtle': "_bfhkh3tw",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk108i",
    'elevation.surface.pressed': "_bfhk1ji5",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk16qz",
    'elevation.surface.overlay.pressed': "_bfhkvq0a",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk1a0f",
    'elevation.surface.raised.pressed': "_bfhkf7u5",
    'elevation.surface.sunken': "_bfhkqbzx",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $57f1138a169e9ef6$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $57f1138a169e9ef6$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l108i",
    'elevation.surface.pressed': "_1q1l1ji5",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l16qz",
    'elevation.surface.overlay.pressed': "_1q1lvq0a",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l1a0f",
    'elevation.surface.raised.pressed': "_1q1lf7u5",
    'elevation.surface.sunken': "_1q1lqbzx"
};
const $57f1138a169e9ef6$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $57f1138a169e9ef6$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $57f1138a169e9ef6$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $57f1138a169e9ef6$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
};
/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */ const $57f1138a169e9ef6$var$Box = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error -- className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $bwpsq.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $57f1138a169e9ef6$var$backgroundColorMap[backgroundColor],
            backgroundColor && $57f1138a169e9ef6$var$isSurfaceToken(backgroundColor) && $57f1138a169e9ef6$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $57f1138a169e9ef6$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $57f1138a169e9ef6$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $57f1138a169e9ef6$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $57f1138a169e9ef6$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aCkBt.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
var $57f1138a169e9ef6$export$2e2bcd8739ae039 = $57f1138a169e9ef6$var$Box;
function $57f1138a169e9ef6$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $57f1138a169e9ef6$var$setSurfaceTokenMap;
}

});

parcelRegister("c0aEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed572e62fc5b1cd0$export$2e2bcd8739ae039);
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $ed572e62fc5b1cd0$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazjjyb _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $ed572e62fc5b1cd0$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $ed572e62fc5b1cd0$var$styles.separator
        ]),
        children: children
    });
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $ed572e62fc5b1cd0$var$Inline = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $2OMIu.jsx)($ed572e62fc5b1cd0$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $5uXOq.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $ed572e62fc5b1cd0$var$styles.hug, grow === 'fill' && $ed572e62fc5b1cd0$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$ed572e62fc5b1cd0$var$Inline.displayName = 'Inline';
var $ed572e62fc5b1cd0$export$2e2bcd8739ae039 = $ed572e62fc5b1cd0$var$Inline;

});
parcelRegister("3JT92", function(module, exports) {

$parcel$export(module.exports, "cx", () => $dee9ac326c478b67$export$a274e22fb40f762e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ parcelRequire("5uXOq");

var $1tTNc = parcelRequire("1tTNc");
const { XCSSProp: $dee9ac326c478b67$var$XCSSProp, css: $dee9ac326c478b67$export$dbf350e5966cf602, cssMap: $dee9ac326c478b67$export$eb1ecd84a24ee424, cx: $dee9ac326c478b67$export$a274e22fb40f762e } = (0, $1tTNc.createStrictAPI)();

});

parcelRegister("bUmQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0ccb72b8ddc20b7$export$2e2bcd8739ae039);
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d0ccb72b8ddc20b7$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $d0ccb72b8ddc20b7$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $d0ccb72b8ddc20b7$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $d0ccb72b8ddc20b7$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $d0ccb72b8ddc20b7$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $d0ccb72b8ddc20b7$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $d0ccb72b8ddc20b7$var$styles = {
    root: "_1e0c1txw _vchhusvi"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $d0ccb72b8ddc20b7$var$Flex = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        role: role,
        className: (0, $bwpsq.default)([
            $d0ccb72b8ddc20b7$var$styles.root,
            gap && $d0ccb72b8ddc20b7$var$columnGapMap[gap],
            columnGap && $d0ccb72b8ddc20b7$var$columnGapMap[columnGap],
            gap && $d0ccb72b8ddc20b7$var$rowGapMap[gap],
            rowGap && $d0ccb72b8ddc20b7$var$rowGapMap[rowGap],
            alignItems && $d0ccb72b8ddc20b7$var$alignItemsMap[alignItems],
            direction && $d0ccb72b8ddc20b7$var$flexDirectionMap[direction],
            justifyContent && $d0ccb72b8ddc20b7$var$justifyContentMap[justifyContent],
            wrap && $d0ccb72b8ddc20b7$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$d0ccb72b8ddc20b7$var$Flex.displayName = 'Flex';
var $d0ccb72b8ddc20b7$export$2e2bcd8739ae039 = $d0ccb72b8ddc20b7$var$Flex;

});


parcelRegister("414Wj", function(module, exports) {

$parcel$export(module.exports, "default", () => $452354e10b30c8d8$export$2e2bcd8739ae039);
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $bUmQV = parcelRequire("bUmQV");
const $452354e10b30c8d8$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $452354e10b30c8d8$var$Stack = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bUmQV.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $3JT92.cx)(grow === 'hug' && $452354e10b30c8d8$var$styles.hug, grow === 'fill' && $452354e10b30c8d8$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$452354e10b30c8d8$var$Stack.displayName = 'Stack';
var $452354e10b30c8d8$export$2e2bcd8739ae039 = $452354e10b30c8d8$var$Stack;

});

const $ff8b18549b2c06bf$export$d6830277b06edd6 = 'normal';

parcelRegister("aB5C5", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc2d9fb2e0bff6da$export$2e2bcd8739ae039);
/* flag-actions.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");

var $VSDnB = parcelRequire("VSDnB");

var $c0aEF = parcelRequire("c0aEF");


var $hZKVY = parcelRequire("hZKVY");
const $fc2d9fb2e0bff6da$var$buttonStyles = null;
const $fc2d9fb2e0bff6da$var$fontStyles = null;
const $fc2d9fb2e0bff6da$var$appearanceNormalButtonStyles = null;
const $fc2d9fb2e0bff6da$var$appearanceNormalActionsContainerStyles = null;
const $fc2d9fb2e0bff6da$var$FlagActions = (props)=>{
    const { appearance: appearance = (0, $ff8b18549b2c06bf$export$d6830277b06edd6), actions: actions = [], linkComponent: linkComponent, testId: testId } = props;
    if (!actions.length) return null;
    const isBold = appearance !== (0, $ff8b18549b2c06bf$export$d6830277b06edd6);
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            !isBold && "_1g4l107e _y8dn107e",
            (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && "_11c82smr"
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
            space: "space.100",
            shouldWrap: true,
            alignBlock: "center",
            separator: isBold ? undefined : "\xb7",
            testId: testId && `${testId}-actions`,
            children: actions.map((action, index)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $9yOBd.default), {
                    onClick: action.onClick,
                    href: action.href,
                    target: action.target,
                    appearance: isBold ? 'default' : 'link',
                    component: linkComponent,
                    spacing: "compact",
                    testId: action.testId,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        '--color': (0, $hZKVY.actionTextColor)[appearance],
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color': (0, $hZKVY.actionBackgroundColor)[appearance].default,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-hover': (0, $hZKVY.actionBackgroundColor)[appearance].pressed,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                        '--bg-color-active': (0, $hZKVY.actionBackgroundColor)[appearance].active
                    },
                    className: (0, $bwpsq.default)([
                        "_nup91zz4 _u4iq1zz4 _1w901pkf _qkwg1pkf _12r21wq8 _il101wq8 _1ku2grf3 _1v8mgrf3 _gbuigrf3 _1dwvgrf3 _1bk61a66 _1wy61a66 _b3g31a66 _eqps1a66 _ow0718uv _1p6b18uv _8dbm18uv _77mc18uv _17rj8stv _1p6m8stv _5kwq8stv _1pd88stv _1iqunqa1 _1ejunqa1 _b6ztnqa1 _1rsgnqa1 _u1mb14jz _10fu17w4",
                        appearance === (0, $ff8b18549b2c06bf$export$d6830277b06edd6) && "_1dltgrf3 _h03xgrf3 _w8sqgrf3 _1iysgrf3 _fjwrgrf3 _cwkngrf3 _1yxxgrf3 _z7cdgrf3"
                    ]),
                    children: action.content
                }, index))
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fc2d9fb2e0bff6da$export$2e2bcd8739ae039 = $fc2d9fb2e0bff6da$var$FlagActions;

});
parcelRegister("hZKVY", function(module, exports) {

$parcel$export(module.exports, "flagBackgroundColor", () => $05db7c791fb0c023$export$59e42969c95d314);
$parcel$export(module.exports, "flagIconColor", () => $05db7c791fb0c023$export$7f70afe2167f8235);
$parcel$export(module.exports, "flagIconGlyph", () => $05db7c791fb0c023$export$73f08aee70487cd4);
$parcel$export(module.exports, "flagTextColor", () => $05db7c791fb0c023$export$f50075b2584087f);
$parcel$export(module.exports, "flagTextColorToken", () => $05db7c791fb0c023$export$13b42cd9d596bfe0);
$parcel$export(module.exports, "actionBackgroundColor", () => $05db7c791fb0c023$export$81ba6b63eedb299f);
$parcel$export(module.exports, "actionTextColor", () => $05db7c791fb0c023$export$7bcfe3cca4dd78b6);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $05db7c791fb0c023$export$59e42969c95d314 = {
    error: 'color.background.danger.bold',
    info: 'color.background.neutral.bold',
    normal: 'elevation.surface.overlay',
    success: 'color.background.success.bold',
    warning: 'color.background.warning.bold'
};
const $05db7c791fb0c023$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, #FFFFFF)",
    info: "var(--ds-icon-inverse, #FFFFFF)",
    normal: "var(--ds-icon-subtle, #626F86)",
    success: "var(--ds-icon-inverse, #FFFFFF)",
    warning: "var(--ds-icon-warning-inverse, #172B4D)"
};
const $05db7c791fb0c023$export$73f08aee70487cd4 = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-danger-bold, #C9372C)"
    }),
    info: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-neutral-bold, #44546F)"
    }),
    normal: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-subtle, ${(0, $829f609a65d26a98$export$c39c0fe0f26207ae)})`,
        LEGACY_secondaryColor: "var(--ds-surface-overlay, #FFFFFF)"
    }),
    success: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        LEGACY_secondaryColor: "var(--ds-background-success-bold, #1F845A)"
    }),
    warning: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        label: "",
        LEGACY_primaryColor: `var(--ds-icon-warning-inverse, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
        LEGACY_secondaryColor: "var(--ds-background-warning-bold, #F5CD47)"
    })
};
const $05db7c791fb0c023$export$f50075b2584087f = {
    error: 'color.text.inverse',
    info: 'color.text.inverse',
    normal: 'color.text',
    success: 'color.text.inverse',
    warning: 'color.text.warning.inverse'
};
const $05db7c791fb0c023$export$13b42cd9d596bfe0 = {
    error: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    info: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    normal: `var(--ds-text, ${(0, $829f609a65d26a98$export$7d61b15e0da132af)})`,
    success: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`
};
const $05db7c791fb0c023$export$81ba6b63eedb299f = {
    success: {
        default: `var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
    },
    info: {
        default: `var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
    },
    error: {
        default: `var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
    },
    warning: {
        default: `var(--ds-background-inverse-subtle, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        active: `var(--ds-background-inverse-subtle-pressed, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`,
        pressed: `var(--ds-background-inverse-subtle-hovered, ${(0, $829f609a65d26a98$export$920c0d5c49070351)})`
    },
    normal: {
        default: 'none',
        active: 'none',
        pressed: 'none'
    }
};
const $05db7c791fb0c023$export$7bcfe3cca4dd78b6 = {
    success: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    info: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    error: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    warning: `var(--ds-text-warning-inverse, ${(0, $829f609a65d26a98$export$ad0bacf983b7ddaa)})`,
    normal: `var(--ds-link, ${(0, $829f609a65d26a98$export$b3de0ae08da2ce64)})`
};

});
parcelRegister("dD7Zc", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3a36a65999ae3c13d3a1917b5e2b052e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ec51cc6530104e1$var$_react = $9ec51cc6530104e1$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9ec51cc6530104e1$var$_error = $9ec51cc6530104e1$var$_interopRequireDefault((parcelRequire("hMVoD")));

var $9ec51cc6530104e1$var$_error2 = $9ec51cc6530104e1$var$_interopRequireDefault((parcelRequire("7nnPp")));
function $9ec51cc6530104e1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when there is an error.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ec51cc6530104e1$var$ErrorIcon = (props)=>/*#__PURE__*/ $9ec51cc6530104e1$var$_react.default.createElement($9ec51cc6530104e1$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $9ec51cc6530104e1$var$_error2.default
    }, props));
$9ec51cc6530104e1$var$ErrorIcon.Name = 'ErrorIconMigration';
var $9ec51cc6530104e1$var$_default = module.exports.default = $9ec51cc6530104e1$var$ErrorIcon;

});

parcelRegister("1jWct", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a62cd542d4ba6c4ac33816bbd6056646>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f64b62884a9bedb$var$_react = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0f64b62884a9bedb$var$_information = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2Yv61")));

var $0f64b62884a9bedb$var$_info = $0f64b62884a9bedb$var$_interopRequireDefault((parcelRequire("2hXfb")));
function $0f64b62884a9bedb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "InfoIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f64b62884a9bedb$var$InformationIcon = (props)=>/*#__PURE__*/ $0f64b62884a9bedb$var$_react.default.createElement($0f64b62884a9bedb$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $0f64b62884a9bedb$var$_info.default
    }, props));
$0f64b62884a9bedb$var$InformationIcon.Name = 'InformationIconMigration';
var $0f64b62884a9bedb$var$_default = module.exports.default = $0f64b62884a9bedb$var$InformationIcon;

});

parcelRegister("c2i4s", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::934663f3d49f13f5eb4d23bc2f11a666>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8c33b074f80a91d5$var$_react = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8c33b074f80a91d5$var$_success = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("b0JGA")));

var $8c33b074f80a91d5$var$_checkCircle = $8c33b074f80a91d5$var$_interopRequireDefault((parcelRequire("btivG")));
function $8c33b074f80a91d5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8c33b074f80a91d5$var$SuccessIcon = (props)=>/*#__PURE__*/ $8c33b074f80a91d5$var$_react.default.createElement($8c33b074f80a91d5$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $8c33b074f80a91d5$var$_checkCircle.default
    }, props));
$8c33b074f80a91d5$var$SuccessIcon.Name = 'SuccessIconMigration';
var $8c33b074f80a91d5$var$_default = module.exports.default = $8c33b074f80a91d5$var$SuccessIcon;

});

parcelRegister("bU3PY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::783ce92761ea23bbb39745cb99e4a6be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8aa7e6aabd9c587d$var$_react = $8aa7e6aabd9c587d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8aa7e6aabd9c587d$var$_warning = $8aa7e6aabd9c587d$var$_interopRequireDefault((parcelRequire("34Rrn")));

var $8aa7e6aabd9c587d$var$_warning2 = $8aa7e6aabd9c587d$var$_interopRequireDefault((parcelRequire("gtreQ")));
function $8aa7e6aabd9c587d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for WarningIcon.
 * This component is WarningIcon, with `UNSAFE_fallbackIcon` set to "WarningIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for warning system status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8aa7e6aabd9c587d$var$WarningIcon = (props)=>/*#__PURE__*/ $8aa7e6aabd9c587d$var$_react.default.createElement($8aa7e6aabd9c587d$var$_warning.default, Object.assign({
        LEGACY_fallbackIcon: $8aa7e6aabd9c587d$var$_warning2.default
    }, props));
$8aa7e6aabd9c587d$var$WarningIcon.Name = 'WarningIconMigration';
var $8aa7e6aabd9c587d$var$_default = module.exports.default = $8aa7e6aabd9c587d$var$WarningIcon;

});



parcelRegister("6ARj7", function(module, exports) {

$parcel$export(module.exports, "useFlagGroup", () => $8d34e438d3df6578$export$e91ea202abb66350);
$parcel$export(module.exports, "default", () => $8d34e438d3df6578$export$2e2bcd8739ae039);
/* flag-group.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $35XSW = parcelRequire("35XSW");
var $8Sbj3 = parcelRequire("8Sbj3");

var $k8nZq = parcelRequire("k8nZq");

var $k5uoT = parcelRequire("k5uoT");

var $jldZL = parcelRequire("jldZL");
const $8d34e438d3df6578$export$1eee5ddc4f6d41c5 = 400;
const $8d34e438d3df6578$var$defaultFlagGroupContext = {
    onDismissed: (0, $eGmKJ.default),
    isDismissAllowed: false
};
const $8d34e438d3df6578$export$c57ba665aaa722be = /*#__PURE__*/ (0, $5uXOq.createContext)($8d34e438d3df6578$var$defaultFlagGroupContext);
function $8d34e438d3df6578$export$e91ea202abb66350() {
    return (0, $5uXOq.useContext)($8d34e438d3df6578$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
const $8d34e438d3df6578$var$groupStyles = {
    root: "_v5641b8g _1bsb1kdj _kqswstnw _u7coidpf _1eqkauwl",
    first: "_v564glyw _t9ec1ygq _1pbyqfx8",
    second: "_1pbyegat",
    nth: "_5sag5cps _t9ec1hw2",
    hidden: "_3um015vq"
};
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
const $8d34e438d3df6578$var$dismissAllowedStyles = null;
const $8d34e438d3df6578$var$flagGroupContainerStyles = null;
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ const $8d34e438d3df6578$var$FlagGroup = (props)=>{
    const { id: id, label: label = 'Flag notifications', labelTag: LabelTag = 'h2', shouldRenderToParent: shouldRenderToParent = false, children: children, onDismissed: onDismissed = (0, $eGmKJ.default) } = props;
    const hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    const dismissFlagContext = (0, $5uXOq.useMemo)(()=>({
            onDismissed: onDismissed,
            isDismissAllowed: true
        }), [
        onDismissed
    ]);
    const renderChildren = ()=>{
        return children && typeof children === 'object' ? (0, $5uXOq.Children).map(children, (flag, index)=>{
            const isDismissAllowed = index === 0;
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8Sbj3.default), {
                enterFrom: "left",
                fade: "inout",
                duration: "medium",
                animationTimingFunction: "ease-in",
                children: ({ className: className, ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, $bwpsq.default)([
                            $8d34e438d3df6578$var$groupStyles.root,
                            index === 0 && $8d34e438d3df6578$var$groupStyles.first,
                            index === 1 && $8d34e438d3df6578$var$groupStyles.second,
                            index >= 1 && $8d34e438d3df6578$var$groupStyles.nth,
                            index >= 2 && $8d34e438d3df6578$var$groupStyles.hidden,
                            isDismissAllowed && "_12a7luct",
                            className
                        ]),
                        ref: ref,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)($8d34e438d3df6578$export$c57ba665aaa722be.Provider, {
                            value: // Only the first flag should be able to be dismissed.
                            isDismissAllowed ? dismissFlagContext : $8d34e438d3df6578$var$defaultFlagGroupContext,
                            children: flag
                        })
                    })
            });
        }) : false;
    };
    const flags = /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        id: id,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _1pbyxejw _u7cooahv _1e021epz _1iafidpf _il0widpf"
        ]),
        children: [
            hasFlags ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(LabelTag, {
                    children: label
                })
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
                appear: false,
                children: renderChildren()
            })
        ]
    });
    return shouldRenderToParent ? flags : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
        zIndex: (0, $k5uoT.layers).flag(),
        children: flags
    });
};
var $8d34e438d3df6578$export$2e2bcd8739ae039 = $8d34e438d3df6578$var$FlagGroup;

});
parcelRegister("35XSW", function(module, exports) {

$parcel$export(module.exports, "useExitingPersistence", () => $e2c75fc83fcbf0a4$export$3b6f38abbdcbd000);
$parcel$export(module.exports, "default", () => $e2c75fc83fcbf0a4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $dWt6p = parcelRequire("dWt6p");
// We define empty context here so the object doesn't change.
const $e2c75fc83fcbf0a4$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
/**
 * __Exiting context__
 *
 * An exiting context.
 */ const $e2c75fc83fcbf0a4$var$ExitingContext = /*#__PURE__*/ (0, $5uXOq.createContext)($e2c75fc83fcbf0a4$var$emptyContext);
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ const $e2c75fc83fcbf0a4$var$wrapChildWithContextProvider = (child, value = $e2c75fc83fcbf0a4$var$emptyContext)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)($e2c75fc83fcbf0a4$var$ExitingContext.Provider, {
        value: value,
        children: child
    }, `${child.key}-provider`);
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ const $e2c75fc83fcbf0a4$var$childrenToArray = (children)=>{
    const childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5uXOq.Children).toArray(children).forEach((child)=>{
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
const $e2c75fc83fcbf0a4$var$spliceNewElementsIntoPrevious = (current, previous)=>{
    const splicedChildren = previous.concat([]);
    const previousMap = $e2c75fc83fcbf0a4$var$childrenToObj(previous);
    for(let i = 0; i < current.length; i++){
        const child = current[i];
        const childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
const $e2c75fc83fcbf0a4$var$childrenToObj = (children)=>{
    return children.reduce((acc, child)=>{
        acc[child.key] = child;
        return acc;
    }, {});
};
const $e2c75fc83fcbf0a4$var$getMissingKeys = (current, previous)=>{
    const currentMapKeys = new Set(current.map((child)=>child.key));
    const missing = new Set();
    for(let i = 0; i < previous.length; i++){
        const element = previous[i];
        const key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * How does this component work?
 *
 * It looks at changes in its children to see what is removed.
 *
 * If a child is removed it clones it and wraps it with context providing an `onFinish` callback.
 *
 * The cloned child will call the `onFinish` when it finishes its exit animation,
 * which lets `ExitingPersistence` know to stop rendering it.
 */ /**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $e2c75fc83fcbf0a4$var$ExitingPersistence = /*#__PURE__*/ (0, $5uXOq.memo)(({ appear: appear = false, children: children, exitThenEnter: exitThenEnter })=>{
    const [stateChildren, setChildren] = (0, $5uXOq.useState)([
        null,
        children
    ]);
    const [exitingChildren, setExitingChildren] = (0, $5uXOq.useState)([]);
    const [defaultContext, setDefaultContext] = (0, $5uXOq.useState)(()=>({
            appear: appear,
            isExiting: false
        }));
    (0, $5uXOq.useEffect)(()=>{
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $dWt6p.isReducedMotion)() && !(0, $VSDnB.fg)('platform_design_system_motion_on_finish_fix')) /**
			 * We still want to use the `ExitingPersistence` with reduced motion,
			 * otherwise the exiting `onFinish` is not called.
			 */ return children;
    /**
		 * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
		 * useState is mocked to return a boolean value.
		 */ if (typeof stateChildren === 'boolean') return children;
    const [previousChildren, currentChildren] = stateChildren;
    const previous = $e2c75fc83fcbf0a4$var$childrenToArray(previousChildren);
    const current = $e2c75fc83fcbf0a4$var$childrenToArray(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    const missingKeys = $e2c75fc83fcbf0a4$var$getMissingKeys(current, previous);
    const isSomeChildRemoved = !!missingKeys.size;
    let visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = $e2c75fc83fcbf0a4$var$spliceNewElementsIntoPrevious(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            const nextExitingChildren = visibleChildren.filter((child)=>missingKeys.has(child.key));
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map((child)=>{
        const isExiting = missingKeys.has(child.key);
        return $e2c75fc83fcbf0a4$var$wrapChildWithContextProvider(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? ()=>{
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map((child)=>$e2c75fc83fcbf0a4$var$wrapChildWithContextProvider(child, defaultContext));
    return visibleChildren;
});
const $e2c75fc83fcbf0a4$export$3b6f38abbdcbd000 = ()=>{
    return (0, $5uXOq.useContext)($e2c75fc83fcbf0a4$var$ExitingContext);
};
$e2c75fc83fcbf0a4$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $e2c75fc83fcbf0a4$export$2e2bcd8739ae039 = $e2c75fc83fcbf0a4$var$ExitingPersistence;

});
parcelRegister("dWt6p", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", () => $b37b9404b84070c5$export$b7baf7667a68d87c);
$parcel$export(module.exports, "useIsReducedMotion", () => $b37b9404b84070c5$export$c537e63161742ce3);
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", () => $b37b9404b84070c5$export$f0f789643ba5a83c);
$parcel$export(module.exports, "prefersReducedMotion", () => $b37b9404b84070c5$export$ff7706047246b98b);

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");
const $b37b9404b84070c5$var$isMatchMediaAvailable = ()=>typeof window !== 'undefined' && 'matchMedia' in window;
const $b37b9404b84070c5$export$b7baf7667a68d87c = ()=>{
    if (!$b37b9404b84070c5$var$isMatchMediaAvailable()) return false;
    const { matches: matches } = window.matchMedia('(prefers-reduced-motion: reduce)');
    return matches;
};
const $b37b9404b84070c5$export$c537e63161742ce3 = ()=>{
    const [prefersReducedMotion, setPrefersReducedMotion] = (0, $5uXOq.useState)($b37b9404b84070c5$export$b7baf7667a68d87c);
    (0, $5uXOq.useEffect)(()=>{
        if (!$b37b9404b84070c5$var$isMatchMediaAvailable()) return;
        const mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        const onChange = (event)=>setPrefersReducedMotion(event.matches);
        return (0, $cBeZP.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
const $b37b9404b84070c5$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
const $b37b9404b84070c5$export$ff7706047246b98b = ()=>$b37b9404b84070c5$export$f0f789643ba5a83c;

});


parcelRegister("8Sbj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $75b01f79419e8d5a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2Yynb = parcelRequire("2Yynb");
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ const $75b01f79419e8d5a$var$SlideIn = ({ children: children, enterFrom: enterFrom, exitTo: exitTo, fade: fade = 'none', duration: duration = 'medium', isPaused: isPaused, onFinish: onFinish, animationTimingFunction: animationTimingFunction = 'ease-out', animationTimingFunctionExiting: animationTimingFunctionExiting = 'ease-in' })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Yynb.default), {
        duration: duration,
        enteringAnimation: `slide-in-from-${enterFrom}`,
        exitingAnimation: `slide-out-from-${exitTo || enterFrom}`,
        animationTimingFunction: animationTimingFunction,
        animationTimingFunctionExiting: animationTimingFunctionExiting,
        isPaused: isPaused,
        onFinish: onFinish,
        children: children
    });
};
var $75b01f79419e8d5a$export$2e2bcd8739ae039 = $75b01f79419e8d5a$var$SlideIn;

});
parcelRegister("2Yynb", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbb87beef6fc0dca$export$2e2bcd8739ae039);
/* keyframes-motion.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");

var $dWt6p = parcelRequire("dWt6p");

var $lObw7 = parcelRequire("lObw7");

var $bh8Xz = parcelRequire("bh8Xz");

var $35XSW = parcelRequire("35XSW");

var $kGrQ8 = parcelRequire("kGrQ8");
const $dbb87beef6fc0dca$var$zoomIn = null;
const $dbb87beef6fc0dca$var$zoomOut = null;
const $dbb87beef6fc0dca$var$fadeIn = null;
const $dbb87beef6fc0dca$var$fadeOut = null;
const $dbb87beef6fc0dca$var$fadeInFromTop = null;
const $dbb87beef6fc0dca$var$fadeOutFromTop = null;
const $dbb87beef6fc0dca$var$fadeInFromLeft = null;
const $dbb87beef6fc0dca$var$fadeOutFromLeft = null;
const $dbb87beef6fc0dca$var$fadeInFromBottom = null;
const $dbb87beef6fc0dca$var$fadeOutFromBottom = null;
const $dbb87beef6fc0dca$var$fadeInFromRight = null;
const $dbb87beef6fc0dca$var$fadeOutFromRight = null;
const $dbb87beef6fc0dca$var$fadeInFromTopConstant = null;
const $dbb87beef6fc0dca$var$fadeOutFromTopConstant = null;
const $dbb87beef6fc0dca$var$fadeInFromLeftConstant = null;
const $dbb87beef6fc0dca$var$fadeOutFromLeftConstant = null;
const $dbb87beef6fc0dca$var$fadeInFromBottomConstant = null;
const $dbb87beef6fc0dca$var$fadeOutFromBottomConstant = null;
const $dbb87beef6fc0dca$var$fadeInFromRightConstant = null;
const $dbb87beef6fc0dca$var$fadeOutFromRightConstant = null;
const $dbb87beef6fc0dca$var$slideInFromTop = null;
const $dbb87beef6fc0dca$var$slideOutFromTop = null;
const $dbb87beef6fc0dca$var$slideInFromRight = null;
const $dbb87beef6fc0dca$var$slideOutFromRight = null;
const $dbb87beef6fc0dca$var$slideInFromBottom = null;
const $dbb87beef6fc0dca$var$slideOutFromBottom = null;
const $dbb87beef6fc0dca$var$slideInFromLeft = null;
const $dbb87beef6fc0dca$var$slideOutFromLeft = null;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ const $dbb87beef6fc0dca$var$EnteringMotion = ({ children: children, animationTimingFunction: animationTimingFunction, animationTimingFunctionExiting: animationTimingFunctionExiting = animationTimingFunction, enteringAnimation: enteringAnimation, exitingAnimation: exitingAnimation = enteringAnimation, isPaused: isPaused, onFinish: onFinishMotion, duration: duration = 'large' })=>{
    const staggered = (0, $kGrQ8.useStaggeredEntrance)();
    const { isExiting: isExiting, onFinish: onExitFinished, appear: appear } = (0, $35XSW.useExitingPersistence)();
    const setTimeout = (0, $bh8Xz.useSetTimeout)();
    const paused = isPaused || !staggered.isReady;
    const delay = isExiting ? 0 : staggered.delay;
    const state = isExiting ? 'exiting' : 'entering';
    const [hasAnimationStyles, setHasAnimationStyles] = (0, $5uXOq.useState)(appear);
    (0, $5uXOq.useEffect)(()=>{
        // Tracking this to prevent changing state on an unmounted component
        let isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        /**
     * Updates relevant state.
     * Called when the animation is finished, or immediately with reduced motion.
     */ const onAnimationEnd = ()=>{
            if (state === 'exiting') // Updates the `ExitingPersistence` to remove this child
            onExitFinished?.();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion?.(state);
        };
        if ((0, $dWt6p.isReducedMotion)() && (0, $VSDnB.fg)('platform_design_system_motion_on_finish_fix')) {
            // If there is reduced motion there is no exit animation, so call this immediately
            onAnimationEnd();
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        // Queue `onAnimationEnd` for after the animation has finished
        setTimeout(onAnimationEnd, isExiting ? (0, $lObw7.exitingDurations)[duration] : (0, $lObw7.durations)[duration] + delay);
        return ()=>{
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return children({
        ref: staggered.ref,
        // @ts-expect-error: `ax` is not typed correctly
        className: hasAnimationStyles ? (0, $bwpsq.default)([
            (0, $bwpsq.default)([
                "_1o51eoah _1y0co91m _1bumglyw _sedtglyw"
            ]),
            paused && (0, $bwpsq.default)([
                "_1y0ctrqk"
            ]),
            duration === 'small' && (0, $bwpsq.default)([
                "_5sag1yx9"
            ]),
            duration === 'medium' && (0, $bwpsq.default)([
                "_5sag1ttt"
            ]),
            duration === 'large' && (0, $bwpsq.default)([
                "_5sagpwmj"
            ]),
            isExiting && duration === 'small' && (0, $bwpsq.default)([
                "_5sag14ed"
            ]),
            isExiting && duration === 'medium' && (0, $bwpsq.default)([
                "_5sagluct"
            ]),
            isExiting && duration === 'large' && (0, $bwpsq.default)([
                "_5sag1ttt"
            ]),
            isExiting && (0, $bwpsq.default)([
                "_ju255cps _1o51q7pw"
            ]),
            !isExiting && animationTimingFunction === 'linear' && (0, $bwpsq.default)([
                "_1pglp3kn"
            ]),
            !isExiting && animationTimingFunction === 'ease-out' && (0, $bwpsq.default)([
                "_1pgldkwg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in' && (0, $bwpsq.default)([
                "_1pgl1nzg"
            ]),
            !isExiting && animationTimingFunction === 'ease-in-out' && (0, $bwpsq.default)([
                "_1pgl1fu8"
            ]),
            isExiting && animationTimingFunction === 'linear' && (0, $bwpsq.default)([
                "_1pglp3kn"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-out' && (0, $bwpsq.default)([
                "_1pgldkwg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in' && (0, $bwpsq.default)([
                "_1pgl1nzg"
            ]),
            isExiting && animationTimingFunctionExiting === 'ease-in-out' && (0, $bwpsq.default)([
                "_1pgl1fu8"
            ]),
            (!isExiting && enteringAnimation === 'fade-in' || isExiting && exitingAnimation === 'fade-in') && (0, $bwpsq.default)([
                "_j7hq1cgr"
            ]),
            (!isExiting && enteringAnimation === 'fade-out' || isExiting && exitingAnimation === 'fade-out') && (0, $bwpsq.default)([
                "_j7hq1lln"
            ]),
            (!isExiting && enteringAnimation === 'zoom-in' || isExiting && exitingAnimation === 'zoom-in') && (0, $bwpsq.default)([
                "_j7hqe8p0"
            ]),
            (!isExiting && enteringAnimation === 'zoom-out' || isExiting && exitingAnimation === 'zoom-out') && (0, $bwpsq.default)([
                "_j7hqy6ql"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-top' || isExiting && exitingAnimation === 'slide-in-from-top') && (0, $bwpsq.default)([
                "_j7hqqshu"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-top' || isExiting && exitingAnimation === 'slide-out-from-top') && (0, $bwpsq.default)([
                "_j7hq7ri4"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-right' || isExiting && exitingAnimation === 'slide-in-from-right') && (0, $bwpsq.default)([
                "_j7hqdfjr"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-right' || isExiting && exitingAnimation === 'slide-out-from-right') && (0, $bwpsq.default)([
                "_j7hqonfj"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-bottom' || isExiting && exitingAnimation === 'slide-in-from-bottom') && (0, $bwpsq.default)([
                "_j7hq1liq"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-bottom' || isExiting && exitingAnimation === 'slide-out-from-bottom') && (0, $bwpsq.default)([
                "_j7hqhnf1"
            ]),
            (!isExiting && enteringAnimation === 'slide-in-from-left' || isExiting && exitingAnimation === 'slide-in-from-left') && (0, $bwpsq.default)([
                "_j7hq1bh1"
            ]),
            (!isExiting && enteringAnimation === 'slide-out-from-left' || isExiting && exitingAnimation === 'slide-out-from-left') && (0, $bwpsq.default)([
                "_j7hqj08w"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top' || isExiting && exitingAnimation === 'fade-in-from-top') && (0, $bwpsq.default)([
                "_j7hq2iua"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top' || isExiting && exitingAnimation === 'fade-out-from-top') && (0, $bwpsq.default)([
                "_j7hq39va"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left' || isExiting && exitingAnimation === 'fade-in-from-left') && (0, $bwpsq.default)([
                "_j7hq15m2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left' || isExiting && exitingAnimation === 'fade-out-from-left') && (0, $bwpsq.default)([
                "_j7hq1yiv"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom' || isExiting && exitingAnimation === 'fade-in-from-bottom') && (0, $bwpsq.default)([
                "_j7hq1w00"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom' || isExiting && exitingAnimation === 'fade-out-from-bottom') && (0, $bwpsq.default)([
                "_j7hqzy3z"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right' || isExiting && exitingAnimation === 'fade-in-from-right') && (0, $bwpsq.default)([
                "_j7hqpqak"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right' || isExiting && exitingAnimation === 'fade-out-from-right') && (0, $bwpsq.default)([
                "_j7hq1ebg"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-top-constant' || isExiting && exitingAnimation === 'fade-in-from-top-constant') && (0, $bwpsq.default)([
                "_j7hqm2e2"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-top-constant' || isExiting && exitingAnimation === 'fade-out-from-top-constant') && (0, $bwpsq.default)([
                "_j7hq97jn"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-left-constant' || isExiting && exitingAnimation === 'fade-in-from-left-constant') && (0, $bwpsq.default)([
                "_j7hqovgq"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-left-constant' || isExiting && exitingAnimation === 'fade-out-from-left-constant') && (0, $bwpsq.default)([
                "_j7hq15do"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-bottom-constant' || isExiting && exitingAnimation === 'fade-in-from-bottom-constant') && (0, $bwpsq.default)([
                "_j7hq797a"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-bottom-constant' || isExiting && exitingAnimation === 'fade-out-from-bottom-constant') && (0, $bwpsq.default)([
                "_j7hqwo7r"
            ]),
            (!isExiting && enteringAnimation === 'fade-in-from-right-constant' || isExiting && exitingAnimation === 'fade-in-from-right-constant') && (0, $bwpsq.default)([
                "_j7hqt8u5"
            ]),
            (!isExiting && enteringAnimation === 'fade-out-from-right-constant' || isExiting && exitingAnimation === 'fade-out-from-right-constant') && (0, $bwpsq.default)([
                "_j7hq1pgp"
            ])
        ]) : '',
        style: {
            animationDelay: `${delay}ms`
        }
    }, state);
};
var $dbb87beef6fc0dca$export$2e2bcd8739ae039 = $dbb87beef6fc0dca$var$EnteringMotion;

});
parcelRegister("lObw7", function(module, exports) {

$parcel$export(module.exports, "durations", () => $8d8e37a750cac32f$export$38b928a7167ce124);
$parcel$export(module.exports, "exitingDurations", () => $8d8e37a750cac32f$export$30fa1a2e62ae150c);
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ const $8d8e37a750cac32f$export$368bacef0dacbe05 = 25;
const $8d8e37a750cac32f$export$38b928a7167ce124 = {
    none: 0,
    small: 100,
    medium: 350,
    large: 700
};
/**
 * Used to multiply the initial duration for exiting motions.
 */ const $8d8e37a750cac32f$var$EXITING_MOTION_MULTIPLIER = 0.5;
const $8d8e37a750cac32f$export$30fa1a2e62ae150c = {
    none: $8d8e37a750cac32f$export$38b928a7167ce124.none,
    small: $8d8e37a750cac32f$export$38b928a7167ce124.small * $8d8e37a750cac32f$var$EXITING_MOTION_MULTIPLIER,
    medium: $8d8e37a750cac32f$export$38b928a7167ce124.medium * $8d8e37a750cac32f$var$EXITING_MOTION_MULTIPLIER,
    large: $8d8e37a750cac32f$export$38b928a7167ce124.large * $8d8e37a750cac32f$var$EXITING_MOTION_MULTIPLIER
};

});

parcelRegister("bh8Xz", function(module, exports) {

$parcel$export(module.exports, "useRequestAnimationFrame", () => $35af9640df728622$export$1775f27e7c8051ca);
$parcel$export(module.exports, "useSetTimeout", () => $35af9640df728622$export$4f34107a2b00f39c);

var $5uXOq = parcelRequire("5uXOq");
const $35af9640df728622$var$getHookDeps = (opts)=>{
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
const $35af9640df728622$export$1775f27e7c8051ca = (opts = {
    cleanup: 'unmount'
})=>{
    const frames = (0, $5uXOq.useRef)([]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (frames.current.length) {
                frames.current.forEach((id)=>cancelAnimationFrame(id));
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $35af9640df728622$var$getHookDeps(opts));
    return (0, $5uXOq.useCallback)((handler)=>{
        const id = requestAnimationFrame((time)=>{
            frames.current = frames.current.filter((frameId)=>frameId !== id);
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
const $35af9640df728622$export$4f34107a2b00f39c = (opts = {
    cleanup: 'unmount'
})=>{
    const timeouts = (0, $5uXOq.useRef)([]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            if (timeouts.current.length) {
                timeouts.current.forEach((id)=>clearTimeout(id));
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $35af9640df728622$var$getHookDeps(opts));
    return (0, $5uXOq.useCallback)((handler, timeout, ...args)=>{
        const id = setTimeout(()=>{
            timeouts.current = timeouts.current.filter((timeoutId)=>timeoutId !== id);
            handler();
        }, timeout, ...args);
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("kGrQ8", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", () => $81ab15a5e394cc24$export$25c7213fc07ec080);
$parcel$export(module.exports, "default", () => $81ab15a5e394cc24$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $fsENI = parcelRequire("fsENI");

var $aOYII = parcelRequire("aOYII");
const $81ab15a5e394cc24$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5uXOq.createContext)(()=>({
        isReady: true,
        delay: 0,
        ref: (0, $eGmKJ.default)
    }));
const $81ab15a5e394cc24$export$25c7213fc07ec080 = ()=>{
    const indentifier = (0, $aOYII.useUniqueId)();
    const context = (0, $5uXOq.useContext)($81ab15a5e394cc24$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ const $81ab15a5e394cc24$var$StaggeredEntrance = ({ children: children, column: column, columns: columns = 'responsive', delayStep: delayStep = 50 })=>{
    const elementRefs = (0, $5uXOq.useRef)([]);
    const indexes = [];
    const [actualColumns, setActualColumns] = (0, $5uXOq.useState)(()=>{
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    });
    (0, $fsENI.useLayoutEffect)(()=>{
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            let currentTop = 0;
            let numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(let i = 0; i < elementRefs.current.length; i++){
                const child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($81ab15a5e394cc24$var$StaggeredEntranceContext.Provider, {
        value: (id)=>{
            if (!indexes.includes(id)) indexes.push(id);
            const isReady = actualColumns > 0;
            const index = indexes.indexOf(id);
            const currentColumn = column || index % actualColumns;
            const currentRow = Math.floor(index / actualColumns);
            const distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            const delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: (element)=>elementRefs.current[index] = element
            };
        },
        children: children
    });
};
var $81ab15a5e394cc24$export$2e2bcd8739ae039 = $81ab15a5e394cc24$var$StaggeredEntrance;

});
parcelRegister("fsENI", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", () => $7ba8b78e286c1ed9$export$e5c5a5f917a5871c);

var $5uXOq = parcelRequire("5uXOq");
const $7ba8b78e286c1ed9$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5uXOq.useEffect) : (0, $5uXOq.useLayoutEffect);

});

parcelRegister("aOYII", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", () => $f7a9405e641a63da$export$c485849f2e393253);
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5uXOq = parcelRequire("5uXOq");
function $f7a9405e641a63da$export$c485849f2e393253() {
    const identifier = (0, $5uXOq.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("k8nZq", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a0890112998a39$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $kmAwu = parcelRequire("kmAwu");

var $dMNd6 = parcelRequire("dMNd6");

var $8IrpP = parcelRequire("8IrpP");

var $cXQJI = parcelRequire("cXQJI");
function $39a0890112998a39$export$2e2bcd8739ae039({ zIndex: zIndex = 0, children: children, mountStrategy: mountStrategy = 'effect' }) {
    const isSubsequentRender = (0, $8IrpP.default)(mountStrategy);
    (0, $cXQJI.default)(zIndex);
    return !(0, $VSDnB.fg)('platform_design_system_team_portal_logic_r18_fix') ? isSubsequentRender ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kmAwu.default), {
        zIndex: zIndex,
        children: children
    }) : null : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dMNd6.default), {
        zIndex: zIndex,
        children: children
    });
}

});
parcelRegister("kmAwu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a3f82871ccad70c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $hK8v6 = parcelRequire("hK8v6");
function $8a3f82871ccad70c$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const container = (0, $5uXOq.useMemo)(()=>(0, $hK8v6.createContainer)(zIndex), [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $hK8v6.appendPortalContainerIfNotAppended)(container);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            (0, $hK8v6.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(children, container);
}

});
parcelRegister("hK8v6", function(module, exports) {

$parcel$export(module.exports, "createContainer", () => $2f5d60011de182f2$export$26ae5ca175b4ec5a);
$parcel$export(module.exports, "removePortalContainer", () => $2f5d60011de182f2$export$da99f98bf3fe55b3);
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", () => $2f5d60011de182f2$export$c582005add11e141);
$parcel$export(module.exports, "createAtlaskitPortal", () => $2f5d60011de182f2$export$fef014d7cef9e543);
$parcel$export(module.exports, "createPortalParent", () => $2f5d60011de182f2$export$95029ca7aca2989e);

const $2f5d60011de182f2$export$26ae5ca175b4ec5a = (zIndex)=>{
    const container = document.createElement('div');
    container.className = (0, $af03419a6de12610$export$13f57c02915787b3);
    container.style.zIndex = `${zIndex}`;
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ const $2f5d60011de182f2$var$getBody = ()=>{
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ const $2f5d60011de182f2$var$getPortalParent = ()=>{
    const parentElement = document.querySelector((0, $af03419a6de12610$export$72f415121273627e));
    if (!parentElement) {
        const parent = document.createElement('div');
        parent.className = (0, $af03419a6de12610$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $2f5d60011de182f2$var$getBody()?.appendChild(parent);
        return parent;
    }
    return parentElement;
};
const $2f5d60011de182f2$export$da99f98bf3fe55b3 = (container)=>{
    $2f5d60011de182f2$var$getPortalParent().removeChild(container);
};
const $2f5d60011de182f2$export$c582005add11e141 = (container)=>{
    if (!container.parentElement) $2f5d60011de182f2$var$getPortalParent().appendChild(container);
};
const $2f5d60011de182f2$var$isDocumentDefined = ()=>{
    return document !== undefined;
};
const $2f5d60011de182f2$export$fef014d7cef9e543 = (zIndex)=>{
    //atlaskit-portal div
    if ($2f5d60011de182f2$var$isDocumentDefined()) {
        const atlaskitportal = document.createElement('div');
        atlaskitportal.className = (0, $af03419a6de12610$export$13f57c02915787b3);
        atlaskitportal.style.zIndex = `${zIndex}`;
        return atlaskitportal;
    }
};
const $2f5d60011de182f2$export$95029ca7aca2989e = ()=>{
    //atlaskit-portal-container div
    if ($2f5d60011de182f2$var$isDocumentDefined()) {
        const parentElement = document.querySelector((0, $af03419a6de12610$export$72f415121273627e));
        if (!parentElement) {
            const parent = document.createElement('div');
            parent.className = (0, $af03419a6de12610$export$e4c79eb95c23a0da);
            parent.style.display = 'flex';
            $2f5d60011de182f2$var$getBody()?.appendChild(parent);
            return parent;
        }
        return parentElement;
    }
};

});
const $af03419a6de12610$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $af03419a6de12610$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $af03419a6de12610$export$13f57c02915787b3 = 'atlaskit-portal';



parcelRegister("dMNd6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2020ba87dd6a3c59$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $aCin9 = parcelRequire("aCin9");

var $hK8v6 = parcelRequire("hK8v6");
function $2020ba87dd6a3c59$export$2e2bcd8739ae039(props) {
    const { zIndex: zIndex, children: children } = props;
    const [atlaskitPortal, setAtlaskitPortal] = (0, $5uXOq.useState)(null);
    (0, $aCin9.useIsomorphicLayoutEffect)(()=>{
        const tempPortalContainer = (0, $hK8v6.createAtlaskitPortal)(zIndex);
        setAtlaskitPortal(tempPortalContainer);
        const portalParent = (0, $hK8v6.createPortalParent)();
        if (!tempPortalContainer || !portalParent) return;
        portalParent.appendChild(tempPortalContainer);
        return ()=>{
            if (tempPortalContainer) portalParent.removeChild(tempPortalContainer);
            setAtlaskitPortal(null);
        };
    }, [
        zIndex
    ]);
    /**
	 * We wrap portal children with a Suspense boundary because in React 18 concurrent,
	 * if you suspend from _within_ a portal to a Suspense boundary _outside_ the portal,
	 * our portal gets in an infinite loop of rendering.
	 */ const suspendedChildren = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uXOq.Suspense), {
        fallback: null,
        children: children
    });
    return atlaskitPortal ? /*#__PURE__*/ (0, $7nsd3.createPortal)(suspendedChildren, atlaskitPortal) : null;
}

});
parcelRegister("aCin9", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $7270f744f78285f0$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
const $7270f744f78285f0$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5uXOq.useLayoutEffect) : (0, $5uXOq.useEffect);

});


parcelRegister("8IrpP", function(module, exports) {

$parcel$export(module.exports, "default", () => $54ab4dc44f44c04b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $aCin9 = parcelRequire("aCin9");
const $54ab4dc44f44c04b$var$useIsSubsequentRender = (mountStrategy)=>{
    const [isSubsequentRender, setIsSubsequentRender] = (0, $5uXOq.useState)(false);
    const [useMountEffect] = (0, $5uXOq.useState)(()=>mountStrategy === 'layoutEffect' ? (0, $aCin9.useIsomorphicLayoutEffect) : (0, $5uXOq.useEffect));
    useMountEffect(()=>{
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $54ab4dc44f44c04b$export$2e2bcd8739ae039 = $54ab4dc44f44c04b$var$useIsSubsequentRender;

});

parcelRegister("cXQJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $f08b79d1ab7ac8d6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $6BR56 = parcelRequire("6BR56");
const $f08b79d1ab7ac8d6$var$useFirePortalEvent = (zIndex)=>{
    const zIndexNumber = Number(zIndex);
    (0, $5uXOq.useEffect)(()=>{
        (0, $6BR56.default)((0, $edbbaf000cbe1dd7$export$ed5835cc67e87f72), zIndexNumber);
        return ()=>{
            (0, $6BR56.default)((0, $edbbaf000cbe1dd7$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $f08b79d1ab7ac8d6$export$2e2bcd8739ae039 = $f08b79d1ab7ac8d6$var$useFirePortalEvent;

});
const $edbbaf000cbe1dd7$export$ed5835cc67e87f72 = 'akPortalMount';
const $edbbaf000cbe1dd7$export$80816bd900e5bd00 = 'akPortalUnmount';

parcelRegister("6BR56", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3450fde5ef6aeb4$export$2e2bcd8739ae039);
const $b3450fde5ef6aeb4$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ const $b3450fde5ef6aeb4$var$getLayerName = (zIndex)=>{
    return $b3450fde5ef6aeb4$var$zIndexToName.hasOwnProperty(zIndex) ? $b3450fde5ef6aeb4$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ const $b3450fde5ef6aeb4$var$getEvent = (eventName, zIndex)=>{
    const detail = {
        layer: $b3450fde5ef6aeb4$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $b3450fde5ef6aeb4$export$2e2bcd8739ae039(eventName, zIndex) {
    const event = $b3450fde5ef6aeb4$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});




parcelRegister("yPPrD", function(module, exports) {

$parcel$export(module.exports, "default", () => $db0c3c8b80800207$export$2e2bcd8739ae039);
/* dismiss-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $84THj = parcelRequire("84THj");

var $6Tj4n = parcelRequire("6Tj4n");

var $2uJaV = parcelRequire("2uJaV");

var $3Lty3 = parcelRequire("3Lty3");

var $hZKVY = parcelRequire("hZKVY");
const $db0c3c8b80800207$var$styles = {
    button: "_16jlidpf _1o9zidpf _i0dl1wug _1dqoglyw _1e0c1txw _1bsb1tcg _4t3i1tcg _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _4cvr1h6o _1bah1h6o _80omtlke _o5721q9c"
};
const $db0c3c8b80800207$var$DismissButtonComponent = ({ appearance: appearance, onClick: onClick, isBold: isBold, isExpanded: isExpanded, testId: testId })=>{
    let ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($84THj)));
    let buttonLabel = 'Dismiss';
    let size = 'small';
    let buttonTestId = testId && `${testId}-dismiss`;
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($2uJaV))) : (0, (/*@__PURE__*/$parcel$interopDefault($6Tj4n)));
        buttonLabel = isExpanded ? 'Collapse' : 'Expand';
        size = 'medium';
        buttonTestId = testId && `${testId}-toggle`;
    }
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
        xcss: $db0c3c8b80800207$var$styles.button,
        onClick: onClick,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: {
            background: 'none'
        },
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId,
        "aria-label": buttonLabel,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)(ButtonIcon, {
            label: "",
            LEGACY_size: size,
            LEGACY_primaryColor: (0, $hZKVY.flagTextColorToken)[appearance],
            color: (0, $hZKVY.flagTextColorToken)[appearance]
        })
    });
};
const $db0c3c8b80800207$var$DismissButton = /*#__PURE__*/ (0, $5uXOq.memo)($db0c3c8b80800207$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db0c3c8b80800207$export$2e2bcd8739ae039 = $db0c3c8b80800207$var$DismissButton;

});
parcelRegister("84THj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e25fa526c0658720d6f2766d6bdbde06>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5e19e6ceaf4184b5$var$_react = $5e19e6ceaf4184b5$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5e19e6ceaf4184b5$var$_close = $5e19e6ceaf4184b5$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $5e19e6ceaf4184b5$var$_cross = $5e19e6ceaf4184b5$var$_interopRequireDefault((parcelRequire("lLLkM")));
function $5e19e6ceaf4184b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "CrossIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5e19e6ceaf4184b5$var$CloseIcon = (props)=>/*#__PURE__*/ $5e19e6ceaf4184b5$var$_react.default.createElement($5e19e6ceaf4184b5$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $5e19e6ceaf4184b5$var$_cross.default
    }, props));
$5e19e6ceaf4184b5$var$CloseIcon.Name = 'CloseIconMigration';
var $5e19e6ceaf4184b5$var$_default = module.exports.default = $5e19e6ceaf4184b5$var$CloseIcon;

});

parcelRegister("6Tj4n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d03c6653983b99c648f0774c0bc3810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5046abf4cb7e43cf$var$_react = $5046abf4cb7e43cf$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5046abf4cb7e43cf$var$_chevronDown = $5046abf4cb7e43cf$var$_interopRequireDefault((parcelRequire("hORKG")));

var $5046abf4cb7e43cf$var$_chevronDown2 = $5046abf4cb7e43cf$var$_interopRequireDefault((parcelRequire("k4n86")));
function $5046abf4cb7e43cf$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronDownIcon.
 * This component is ChevronDownIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronDownIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dropdown menus, selects, accordions, and expands.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5046abf4cb7e43cf$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $5046abf4cb7e43cf$var$_react.default.createElement($5046abf4cb7e43cf$var$_chevronDown.default, Object.assign({
        LEGACY_fallbackIcon: $5046abf4cb7e43cf$var$_chevronDown2.default
    }, props));
$5046abf4cb7e43cf$var$ChevronDownIcon.Name = 'ChevronDownIconMigration';
var $5046abf4cb7e43cf$var$_default = module.exports.default = $5046abf4cb7e43cf$var$ChevronDownIcon;

});

parcelRegister("2uJaV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3c9bd6be3e7327013ae0b836bac300b8>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1d116cf6f7443aef$var$_react = $1d116cf6f7443aef$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1d116cf6f7443aef$var$_chevronUp = $1d116cf6f7443aef$var$_interopRequireDefault((parcelRequire("jj3Gi")));

var $1d116cf6f7443aef$var$_chevronUp2 = $1d116cf6f7443aef$var$_interopRequireDefault((parcelRequire("cLqLT")));
function $1d116cf6f7443aef$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronUpIcon.
 * This component is ChevronUpIcon, with `UNSAFE_fallbackIcon` set to "HipchatChevronUpIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for accordions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1d116cf6f7443aef$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $1d116cf6f7443aef$var$_react.default.createElement($1d116cf6f7443aef$var$_chevronUp.default, Object.assign({
        LEGACY_fallbackIcon: $1d116cf6f7443aef$var$_chevronUp2.default
    }, props));
$1d116cf6f7443aef$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
var $1d116cf6f7443aef$var$_default = module.exports.default = $1d116cf6f7443aef$var$ChevronUpIcon;

});

parcelRegister("3Lty3", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eb08f4038c94d3$export$2e2bcd8739ae039);
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $DEWI6 = parcelRequire("DEWI6");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $6wxJn = parcelRequire("6wxJn");

var $a1dy0 = parcelRequire("a1dy0");
const $70eb08f4038c94d3$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $70eb08f4038c94d3$var$Pressable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $eGmKJ.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const handleClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $a1dy0.default // @ts-expect-error we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button" // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- TODO: Properly type this and allow pass-through if we can determine the type
        ,
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $DEWI6.cx)($70eb08f4038c94d3$var$styles.root, isDisabled && $70eb08f4038c94d3$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});
var $70eb08f4038c94d3$export$2e2bcd8739ae039 = $70eb08f4038c94d3$var$Pressable;

});
parcelRegister("a1dy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6caea09b6e959dc4$export$2e2bcd8739ae039);
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6caea09b6e959dc4$var$focusRingStyles = null;
const $6caea09b6e959dc4$var$insetFocusRingStyles = null;
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 */ const $6caea09b6e959dc4$var$Focusable = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        ...safeHtmlAttributes,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        className: (0, $bwpsq.default)([
            "_mizu194a _1ah31bk5 _ra3xnqa1 _128m1bk5 _1cvmnqa1 _4davt94y",
            isInset && "_1ah311pw _2mwq11pw",
            xcss
        ]),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $6caea09b6e959dc4$export$2e2bcd8739ae039 = $6caea09b6e959dc4$var$Focusable;

});



parcelRegister("bFliP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f76dbc056a5819fa$export$2e2bcd8739ae039);
/* expander.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $35XSW = parcelRequire("35XSW");
var $4uxPN = parcelRequire("4uxPN");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");
const $f76dbc056a5819fa$var$styles = {
    expander: "_1bsb1osq",
    container: "_v5641xzp"
};
const $f76dbc056a5819fa$var$Expander = ({ children: children, isExpanded: isExpanded, testId: testId })=>{
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $f76dbc056a5819fa$var$styles.expander,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: '1 1 100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && `${testId}-expander`,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $35XSW.default), {
            appear: true,
            children: isExpanded && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4uxPN.default), {
                children: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                        xcss: $f76dbc056a5819fa$var$styles.container,
                        ...props,
                        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $414Wj.default), {
                            space: "space.100",
                            children: children
                        })
                    })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f76dbc056a5819fa$export$2e2bcd8739ae039 = $f76dbc056a5819fa$var$Expander;

});
parcelRegister("4uxPN", function(module, exports) {

$parcel$export(module.exports, "default", () => $a07c4811a74c9dfc$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $2Yynb = parcelRequire("2Yynb");
const $a07c4811a74c9dfc$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $a07c4811a74c9dfc$var$FadeIn = ({ children: children, duration: duration = 'large', entranceDirection: entranceDirection, exitDirection: exitDirection, distance: distance = 'proportional', onFinish: onFinish, isPaused: isPaused })=>{
    const invertedEntranceDirection = entranceDirection !== undefined ? $a07c4811a74c9dfc$var$invertedDirection[entranceDirection] : undefined;
    const isExitDirect = Boolean(exitDirection || invertedEntranceDirection) ? `fade-out-from-${exitDirection || invertedEntranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-out';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2Yynb.default), {
        duration: duration,
        enteringAnimation: entranceDirection ? `fade-in-from-${entranceDirection}${distance === 'proportional' ? '' : '-constant'}` : 'fade-in',
        exitingAnimation: isExitDirect,
        animationTimingFunction: "ease-in-out",
        onFinish: onFinish,
        isPaused: isPaused,
        children: children
    });
};
var $a07c4811a74c9dfc$export$2e2bcd8739ae039 = $a07c4811a74c9dfc$var$FadeIn;

});



parcelRegister("fWXJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $62d2a81938c91217$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $epfFv = parcelRequire("epfFv");

var $6ARj7 = parcelRequire("6ARj7");
const $62d2a81938c91217$var$packageName = "platform-pkg";
const $62d2a81938c91217$var$packageVersion = "0.0.0-use.local";
const $62d2a81938c91217$export$66c3d409977b5615 = 8;
/**
 * __Auto dismiss flag__
 *
 * An auto dismiss flag is dismissed automatically after eight seconds.
 *
 * - [Examples](https://atlassian.design/components/flag/auto-dismiss-flag/examples)
 * - [Code](https://atlassian.design/components/flag/auto-dismiss-flag/code)
 */ const $62d2a81938c91217$var$AutoDismissFlag = (props)=>{
    const { id: id, analyticsContext: analyticsContext, onDismissed: onDismissedProp = (0, $eGmKJ.default) } = props;
    const autoDismissTimer = (0, $5uXOq.useRef)(null);
    const { onDismissed: onDismissedFromFlagGroup, isDismissAllowed: isDismissAllowed } = (0, $6ARj7.useFlagGroup)();
    const onDismissed = (0, $5uXOq.useCallback)((id, analyticsEvent)=>{
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    const onDismissedAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onDismissed,
        action: 'dismissed',
        analyticsData: analyticsContext,
        componentName: 'flag',
        packageName: $62d2a81938c91217$var$packageName,
        packageVersion: $62d2a81938c91217$var$packageVersion
    });
    const isAutoDismissAllowed = isDismissAllowed && onDismissed;
    const dismissFlag = (0, $5uXOq.useCallback)(()=>{
        if (isAutoDismissAllowed) onDismissedAnalytics(id);
    }, [
        id,
        onDismissedAnalytics,
        isAutoDismissAllowed
    ]);
    const stopAutoDismissTimer = (0, $5uXOq.useCallback)(()=>{
        if (autoDismissTimer.current) {
            clearTimeout(autoDismissTimer.current);
            autoDismissTimer.current = null;
        }
    }, []);
    const startAutoDismissTimer = (0, $5uXOq.useCallback)(()=>{
        if (!isAutoDismissAllowed) return;
        stopAutoDismissTimer();
        autoDismissTimer.current = window.setTimeout(dismissFlag, $62d2a81938c91217$export$66c3d409977b5615 * 1000);
    }, [
        dismissFlag,
        stopAutoDismissTimer,
        isAutoDismissAllowed
    ]);
    (0, $5uXOq.useEffect)(()=>{
        startAutoDismissTimer();
        return stopAutoDismissTimer;
    }, [
        startAutoDismissTimer,
        stopAutoDismissTimer
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $epfFv.default), {
        ...props,
        onMouseOver: stopAutoDismissTimer,
        onFocus: stopAutoDismissTimer,
        onMouseOut: startAutoDismissTimer,
        onBlur: startAutoDismissTimer
    });
};
var $62d2a81938c91217$export$2e2bcd8739ae039 = $62d2a81938c91217$var$AutoDismissFlag;

});

parcelRegister("bKCvK", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $7fd62a41400dabab$export$2879604e6aec4ab);
$parcel$export(module.exports, "FlagsProvider", () => $7fd62a41400dabab$export$a4270ab432ac8a58);
$parcel$export(module.exports, "withFlagsProvider", () => $7fd62a41400dabab$export$7b676815c264eaf3);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $fWXJB = parcelRequire("fWXJB");

var $epfFv = parcelRequire("epfFv");

var $6ARj7 = parcelRequire("6ARj7");
const $7fd62a41400dabab$var$FlagContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(null);
function $7fd62a41400dabab$export$2879604e6aec4ab() {
    const api = (0, $5uXOq.useContext)($7fd62a41400dabab$var$FlagContext);
    if (api == null) throw new Error('Unable to find FlagProviderContext');
    return api;
}
const $7fd62a41400dabab$var$getUniqueId = (()=>{
    let count = 0;
    return ()=>`flag-provider-unique-id:${count++}`;
})();
function $7fd62a41400dabab$export$a4270ab432ac8a58({ children: children, shouldRenderToParent: shouldRenderToParent }) {
    const [flags, setFlags] = (0, $5uXOq.useState)([]);
    const removeFlag = (0, $5uXOq.useCallback)((id)=>{
        setFlags((current)=>{
            return current.slice(0).filter((flag)=>flag.id !== id);
        });
    }, []);
    const api = (0, $5uXOq.useMemo)(()=>({
            showFlag: function show(value) {
                const flag = {
                    ...value,
                    id: value.id || $7fd62a41400dabab$var$getUniqueId()
                };
                setFlags((current)=>{
                    const index = current.findIndex((value)=>value.id === flag.id);
                    // If flag is not found add it
                    if (index === -1) return [
                        flag,
                        ...current
                    ];
                    // If flag already exists with the same id, then replace it
                    const shallow = [
                        ...current
                    ];
                    shallow[index] = flag;
                    return shallow;
                });
                return function dismiss() {
                    removeFlag(flag.id);
                };
            }
        }), [
        removeFlag
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)($7fd62a41400dabab$var$FlagContext.Provider, {
                value: api,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6ARj7.default), {
                onDismissed: removeFlag,
                shouldRenderToParent: shouldRenderToParent,
                children: flags.map((flag)=>{
                    const { isAutoDismiss: isAutoDismiss, ...restProps } = flag;
                    const FlagType = isAutoDismiss ? (0, $fWXJB.default) : (0, $epfFv.default);
                    return /*#__PURE__*/ (0, $5uXOq.createElement)(FlagType, {
                        ...restProps,
                        key: flag.id
                    });
                })
            })
        ]
    });
}
const $7fd62a41400dabab$export$7b676815c264eaf3 = (fn)=>/*#__PURE__*/ (0, $2OMIu.jsx)($7fd62a41400dabab$export$a4270ab432ac8a58, {
        children: fn()
    });

});


parcelRegister("lA9Ix", function(module, exports) {

$parcel$export(module.exports, "Popper", () => (parcelRequire("4oNEb")).Popper);
$parcel$export(module.exports, "placements", () => (parcelRequire("97wfz")).placements);
$parcel$export(module.exports, "Manager", () => (parcelRequire("gkD4s")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("1V7PR")).Reference);

var $97wfz = parcelRequire("97wfz");
var $4oNEb = parcelRequire("4oNEb");

var $gkD4s = parcelRequire("gkD4s");
var $1V7PR = parcelRequire("1V7PR");

});
parcelRegister("97wfz", function(module, exports) {

$parcel$export(module.exports, "top", () => $6a3dc8b95c9b354c$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $6a3dc8b95c9b354c$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $6a3dc8b95c9b354c$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $6a3dc8b95c9b354c$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $6a3dc8b95c9b354c$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $6a3dc8b95c9b354c$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $6a3dc8b95c9b354c$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $6a3dc8b95c9b354c$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $6a3dc8b95c9b354c$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $6a3dc8b95c9b354c$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $6a3dc8b95c9b354c$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $6a3dc8b95c9b354c$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $6a3dc8b95c9b354c$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $6a3dc8b95c9b354c$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $6a3dc8b95c9b354c$export$d087d3878fdf71d5);
var $6a3dc8b95c9b354c$export$1e95b668f3b82d = 'top';
var $6a3dc8b95c9b354c$export$40e543e69a8b3fbb = 'bottom';
var $6a3dc8b95c9b354c$export$79ffe56a765070d2 = 'right';
var $6a3dc8b95c9b354c$export$eabcd2c8791e7bf4 = 'left';
var $6a3dc8b95c9b354c$export$dfb5619354ba860 = 'auto';
var $6a3dc8b95c9b354c$export$aec2ce47c367b8c3 = [
    $6a3dc8b95c9b354c$export$1e95b668f3b82d,
    $6a3dc8b95c9b354c$export$40e543e69a8b3fbb,
    $6a3dc8b95c9b354c$export$79ffe56a765070d2,
    $6a3dc8b95c9b354c$export$eabcd2c8791e7bf4
];
var $6a3dc8b95c9b354c$export$b3571188c770cc5a = 'start';
var $6a3dc8b95c9b354c$export$bd5df0f255a350f8 = 'end';
var $6a3dc8b95c9b354c$export$390fd549c5303b4d = 'clippingParents';
var $6a3dc8b95c9b354c$export$d7b7311ec04a3e8f = 'viewport';
var $6a3dc8b95c9b354c$export$ae5ab1c730825774 = 'popper';
var $6a3dc8b95c9b354c$export$ca50aac9f3ba507f = 'reference';
var $6a3dc8b95c9b354c$export$368f9a87e87fa4e1 = /*#__PURE__*/ $6a3dc8b95c9b354c$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $6a3dc8b95c9b354c$export$b3571188c770cc5a,
        placement + "-" + $6a3dc8b95c9b354c$export$bd5df0f255a350f8
    ]);
}, []);
var $6a3dc8b95c9b354c$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($6a3dc8b95c9b354c$export$aec2ce47c367b8c3, [
    $6a3dc8b95c9b354c$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $6a3dc8b95c9b354c$export$b3571188c770cc5a,
        placement + "-" + $6a3dc8b95c9b354c$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $6a3dc8b95c9b354c$export$421679a7c3d56e = 'beforeRead';
var $6a3dc8b95c9b354c$export$aafa59e2e03f2942 = 'read';
var $6a3dc8b95c9b354c$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $6a3dc8b95c9b354c$export$c65e99957a05207c = 'beforeMain';
var $6a3dc8b95c9b354c$export$f22da7240b7add18 = 'main';
var $6a3dc8b95c9b354c$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $6a3dc8b95c9b354c$export$8d4d2d70e7d46032 = 'beforeWrite';
var $6a3dc8b95c9b354c$export$68d8715fc104d294 = 'write';
var $6a3dc8b95c9b354c$export$70a6e5159acce2e6 = 'afterWrite';
var $6a3dc8b95c9b354c$export$d087d3878fdf71d5 = [
    $6a3dc8b95c9b354c$export$421679a7c3d56e,
    $6a3dc8b95c9b354c$export$aafa59e2e03f2942,
    $6a3dc8b95c9b354c$export$6964f6c886723980,
    $6a3dc8b95c9b354c$export$c65e99957a05207c,
    $6a3dc8b95c9b354c$export$f22da7240b7add18,
    $6a3dc8b95c9b354c$export$bab79516f2d662fe,
    $6a3dc8b95c9b354c$export$8d4d2d70e7d46032,
    $6a3dc8b95c9b354c$export$68d8715fc104d294,
    $6a3dc8b95c9b354c$export$70a6e5159acce2e6
];

});

parcelRegister("4oNEb", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $5e8703aad122767a$export$badac9ada3a0bdf9);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $cYN2Q = parcelRequire("cYN2Q");

var $2UrTs = parcelRequire("2UrTs");

var $97wfz = parcelRequire("97wfz");
const $5e8703aad122767a$var$viewportPadding = 5;
const $5e8703aad122767a$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: $5e8703aad122767a$var$viewportPadding,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    }
];
function $5e8703aad122767a$var$defaultChildrenFn() {
    return null;
}
const $5e8703aad122767a$var$defaultOffset = [
    0,
    8
];
function $5e8703aad122767a$export$badac9ada3a0bdf9({ children: children = $5e8703aad122767a$var$defaultChildrenFn, offset: offset = $5e8703aad122767a$var$defaultOffset, placement: placement = 'bottom-start', referenceElement: referenceElement, modifiers: modifiers, strategy: strategy = 'fixed', shouldFitViewport: shouldFitViewport = false }) {
    const [offsetX, offsetY] = offset;
    const internalModifiers = (0, $5uXOq.useMemo)(()=>{
        const preventOverflowModifier = {
            name: 'preventOverflow',
            options: {
                padding: $5e8703aad122767a$var$viewportPadding,
                rootBoundary: shouldFitViewport ? 'viewport' : 'document'
            }
        };
        const offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        const maxSizeModifiers = shouldFitViewport ? (0, $2UrTs.getMaxSizeModifiers)({
            viewportPadding: $5e8703aad122767a$var$viewportPadding
        }) : [];
        // @ts-ignore Type errors from incompatible @popperjs/core versions between Jira and AFM Platform... we are using ts-ignore here because ts-expect-error will cause an "Unused '@ts-expect-error' directive." error
        return [
            ...$5e8703aad122767a$var$constantModifiers,
            preventOverflowModifier,
            offsetModifier,
            ...maxSizeModifiers
        ];
    }, [
        offsetX,
        offsetY,
        shouldFitViewport
    ]);
    // Merge custom props and memoize
    const mergedModifiers = (0, $5uXOq.useMemo)(()=>{
        if (modifiers == null) return internalModifiers;
        return [
            ...internalModifiers,
            ...modifiers
        ];
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cYN2Q.Popper), {
        // @ts-expect-error - No overload matches this call
        // This error was introduced after upgrading to TypeScript 5
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement,
        children: children
    });
}

});
parcelRegister("cYN2Q", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $973121f249a0fe5d$export$badac9ada3a0bdf9);

var $5uXOq = parcelRequire("5uXOq");

var $gkD4s = parcelRequire("gkD4s");

var $wofBo = parcelRequire("wofBo");

var $1RPFd = parcelRequire("1RPFd");
var $973121f249a0fe5d$var$NOOP = function NOOP() {
    return void 0;
};
var $973121f249a0fe5d$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $973121f249a0fe5d$var$EMPTY_MODIFIERS = [];
function $973121f249a0fe5d$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $973121f249a0fe5d$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5uXOq.useContext((0, $gkD4s.ManagerReferenceNodeContext));
    var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5uXOq.useEffect(function() {
        (0, $wofBo.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5uXOq.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $1RPFd.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5uXOq.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $973121f249a0fe5d$var$NOOP,
            update: update || $973121f249a0fe5d$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $wofBo.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("gkD4s", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $be3cd2466cdab68f$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $be3cd2466cdab68f$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $be3cd2466cdab68f$export$d0d38e7dec7a1a61);

var $5uXOq = parcelRequire("5uXOq");
var $be3cd2466cdab68f$export$3dbd3405086fec7b = $5uXOq.createContext();
var $be3cd2466cdab68f$export$cbabb21c2529b130 = $5uXOq.createContext();
function $be3cd2466cdab68f$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5uXOq.useRef(false);
    $5uXOq.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5uXOq.createElement($be3cd2466cdab68f$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5uXOq.createElement($be3cd2466cdab68f$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("wofBo", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $0615ccf2757a5c7c$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $0615ccf2757a5c7c$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $0615ccf2757a5c7c$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $0615ccf2757a5c7c$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $0615ccf2757a5c7c$export$700979bc83e7db82);

var $5uXOq = parcelRequire("5uXOq");
var $0615ccf2757a5c7c$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $0615ccf2757a5c7c$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $0615ccf2757a5c7c$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $0615ccf2757a5c7c$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $0615ccf2757a5c7c$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $0615ccf2757a5c7c$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;

});

parcelRegister("1RPFd", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $15c2d102ec62c02a$export$f4d5bf230a36dd6e);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $8YJFs = parcelRequire("8YJFs");

var $lHrkK = parcelRequire("lHrkK");

var $wofBo = parcelRequire("wofBo");
var $15c2d102ec62c02a$var$EMPTY_MODIFIERS = [];
var $15c2d102ec62c02a$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5uXOq.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $15c2d102ec62c02a$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5uXOq.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5uXOq.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7nsd3.flushSync(function() {
                    setState({
                        styles: (0, $wofBo.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $wofBo.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5uXOq.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5uXOq.useRef();
    (0, $wofBo.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $wofBo.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $8YJFs.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("8YJFs", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $689759fe4e25494e$export$8f7491d57c8f97a9);

var $772oL = parcelRequire("772oL");

var $kimZ1 = parcelRequire("kimZ1");

var $aALKT = parcelRequire("aALKT");

var $bFhSn = parcelRequire("bFhSn");

var $9DiRv = parcelRequire("9DiRv");

var $6CPUt = parcelRequire("6CPUt");

var $7qnBI = parcelRequire("7qnBI");

var $i1We5 = parcelRequire("i1We5");

var $i7KKQ = parcelRequire("i7KKQ");

var $96zAb = parcelRequire("96zAb");


var $689759fe4e25494e$export$d34966752335dd47 = [
    (0, $kimZ1.default),
    (0, $aALKT.default),
    (0, $bFhSn.default),
    (0, $9DiRv.default),
    (0, $6CPUt.default),
    (0, $7qnBI.default),
    (0, $i1We5.default),
    (0, $i7KKQ.default),
    (0, $96zAb.default)
];
var $689759fe4e25494e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $772oL.popperGenerator)({
    defaultModifiers: $689759fe4e25494e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("772oL", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $52db0c2390f3b1c0$export$ed5e13716264f202);

var $9RFSe = parcelRequire("9RFSe");

var $3TzO0 = parcelRequire("3TzO0");

var $fH1k9 = parcelRequire("fH1k9");

var $17t4z = parcelRequire("17t4z");

var $a14yC = parcelRequire("a14yC");

var $hJZ5H = parcelRequire("hJZ5H");

var $dlKFY = parcelRequire("dlKFY");


var $hWxDy = parcelRequire("hWxDy");
var $52db0c2390f3b1c0$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $52db0c2390f3b1c0$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $52db0c2390f3b1c0$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $52db0c2390f3b1c0$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $52db0c2390f3b1c0$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $hWxDy.isElement)(reference) ? (0, $fH1k9.default)(reference) : reference.contextElement ? (0, $fH1k9.default)(reference.contextElement) : [],
                    popper: (0, $fH1k9.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $a14yC.default)((0, $dlKFY.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$52db0c2390f3b1c0$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $9RFSe.default)(reference, (0, $17t4z.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3TzO0.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $hJZ5H.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$52db0c2390f3b1c0$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $52db0c2390f3b1c0$export$8f7491d57c8f97a9 = /*#__PURE__*/ $52db0c2390f3b1c0$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("9RFSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $72e98b8ec3b5d067$export$2e2bcd8739ae039);

var $gbunM = parcelRequire("gbunM");

var $alirk = parcelRequire("alirk");

var $dVOZH = parcelRequire("dVOZH");

var $hWxDy = parcelRequire("hWxDy");

var $7oNWS = parcelRequire("7oNWS");

var $kPwvt = parcelRequire("kPwvt");

var $hCuKB = parcelRequire("hCuKB");

var $p9QXG = parcelRequire("p9QXG");
function $72e98b8ec3b5d067$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $p9QXG.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $p9QXG.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $72e98b8ec3b5d067$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $hWxDy.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $hWxDy.isHTMLElement)(offsetParent) && $72e98b8ec3b5d067$var$isElementScaled(offsetParent);
    var documentElement = (0, $kPwvt.default)(offsetParent);
    var rect = (0, $gbunM.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $dVOZH.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $hCuKB.default)(documentElement)) scroll = (0, $alirk.default)(offsetParent);
        if ((0, $hWxDy.isHTMLElement)(offsetParent)) {
            offsets = (0, $gbunM.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $7oNWS.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gbunM", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc853dc1ed990c64$export$2e2bcd8739ae039);

var $hWxDy = parcelRequire("hWxDy");

var $p9QXG = parcelRequire("p9QXG");

var $dhdx1 = parcelRequire("dhdx1");

var $2N65T = parcelRequire("2N65T");
function $bc853dc1ed990c64$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $hWxDy.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $p9QXG.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $p9QXG.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $hWxDy.isElement)(element) ? (0, $dhdx1.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2N65T.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("hWxDy", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $d101f20f8ed11355$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $d101f20f8ed11355$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $d101f20f8ed11355$export$af51f0f06c0f328a);

var $dhdx1 = parcelRequire("dhdx1");
function $d101f20f8ed11355$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $dhdx1.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $d101f20f8ed11355$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $dhdx1.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $d101f20f8ed11355$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $dhdx1.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("dhdx1", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aa75c009e597072$export$2e2bcd8739ae039);
function $9aa75c009e597072$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("p9QXG", function(module, exports) {

$parcel$export(module.exports, "max", () => $04b9fa8ee5d6ca59$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $04b9fa8ee5d6ca59$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $04b9fa8ee5d6ca59$export$2077e0241d6afd3c);
var $04b9fa8ee5d6ca59$export$8960430cfd85939f = Math.max;
var $04b9fa8ee5d6ca59$export$96ec731ed4dcb222 = Math.min;
var $04b9fa8ee5d6ca59$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2N65T", function(module, exports) {

$parcel$export(module.exports, "default", () => $2084e283c4832202$export$2e2bcd8739ae039);

var $ddwrL = parcelRequire("ddwrL");
function $2084e283c4832202$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $ddwrL.default)());
}

});
parcelRegister("ddwrL", function(module, exports) {

$parcel$export(module.exports, "default", () => $99f5a882134978d5$export$2e2bcd8739ae039);
function $99f5a882134978d5$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("alirk", function(module, exports) {

$parcel$export(module.exports, "default", () => $787a2b5124a923ec$export$2e2bcd8739ae039);

var $8vnMG = parcelRequire("8vnMG");

var $dhdx1 = parcelRequire("dhdx1");

var $hWxDy = parcelRequire("hWxDy");

var $6aZTO = parcelRequire("6aZTO");
function $787a2b5124a923ec$export$2e2bcd8739ae039(node) {
    if (node === (0, $dhdx1.default)(node) || !(0, $hWxDy.isHTMLElement)(node)) return (0, $8vnMG.default)(node);
    else return (0, $6aZTO.default)(node);
}

});
parcelRegister("8vnMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6313ab07a8a9b5aa$export$2e2bcd8739ae039);

var $dhdx1 = parcelRequire("dhdx1");
function $6313ab07a8a9b5aa$export$2e2bcd8739ae039(node) {
    var win = (0, $dhdx1.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("6aZTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $47f3b12a4be830ce$export$2e2bcd8739ae039);
function $47f3b12a4be830ce$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("dVOZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a24827a1f946acca$export$2e2bcd8739ae039);
function $a24827a1f946acca$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("7oNWS", function(module, exports) {

$parcel$export(module.exports, "default", () => $56318509e689dc96$export$2e2bcd8739ae039);

var $gbunM = parcelRequire("gbunM");

var $kPwvt = parcelRequire("kPwvt");

var $8vnMG = parcelRequire("8vnMG");
function $56318509e689dc96$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gbunM.default)((0, $kPwvt.default)(element)).left + (0, $8vnMG.default)(element).scrollLeft;
}

});
parcelRegister("kPwvt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2a1c938c13197dd$export$2e2bcd8739ae039);

var $hWxDy = parcelRequire("hWxDy");
function $f2a1c938c13197dd$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $hWxDy.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("hCuKB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd3dd6b3991333ac$export$2e2bcd8739ae039);

var $e6U9j = parcelRequire("e6U9j");
function $cd3dd6b3991333ac$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $e6U9j.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("e6U9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $a45d2e4bd08a02f4$export$2e2bcd8739ae039);

var $dhdx1 = parcelRequire("dhdx1");
function $a45d2e4bd08a02f4$export$2e2bcd8739ae039(element) {
    return (0, $dhdx1.default)(element).getComputedStyle(element);
}

});



parcelRegister("3TzO0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d62485cc82b80ab$export$2e2bcd8739ae039);

var $gbunM = parcelRequire("gbunM");
function $2d62485cc82b80ab$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gbunM.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("fH1k9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6cbe61b6259d74d$export$2e2bcd8739ae039);

var $4XNxl = parcelRequire("4XNxl");

var $2CmGY = parcelRequire("2CmGY");

var $dhdx1 = parcelRequire("dhdx1");

var $hCuKB = parcelRequire("hCuKB");
function $b6cbe61b6259d74d$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $4XNxl.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $dhdx1.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $hCuKB.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($b6cbe61b6259d74d$export$2e2bcd8739ae039((0, $2CmGY.default)(target)));
}

});
parcelRegister("4XNxl", function(module, exports) {

$parcel$export(module.exports, "default", () => $39d31914e91cb65c$export$2e2bcd8739ae039);

var $2CmGY = parcelRequire("2CmGY");

var $hCuKB = parcelRequire("hCuKB");

var $dVOZH = parcelRequire("dVOZH");

var $hWxDy = parcelRequire("hWxDy");
function $39d31914e91cb65c$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $dVOZH.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $hWxDy.isHTMLElement)(node) && (0, $hCuKB.default)(node)) return node;
    return $39d31914e91cb65c$export$2e2bcd8739ae039((0, $2CmGY.default)(node));
}

});
parcelRegister("2CmGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e80bb902883abf6$export$2e2bcd8739ae039);

var $dVOZH = parcelRequire("dVOZH");

var $kPwvt = parcelRequire("kPwvt");

var $hWxDy = parcelRequire("hWxDy");
function $1e80bb902883abf6$export$2e2bcd8739ae039(element) {
    if ((0, $dVOZH.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $hWxDy.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $kPwvt.default)(element) // fallback
    );
}

});



parcelRegister("17t4z", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d0cff1edcf8d867$export$2e2bcd8739ae039);

var $dhdx1 = parcelRequire("dhdx1");

var $dVOZH = parcelRequire("dVOZH");

var $e6U9j = parcelRequire("e6U9j");

var $hWxDy = parcelRequire("hWxDy");

var $bY7G8 = parcelRequire("bY7G8");

var $2CmGY = parcelRequire("2CmGY");

var $ddwrL = parcelRequire("ddwrL");
function $0d0cff1edcf8d867$var$getTrueOffsetParent(element) {
    if (!(0, $hWxDy.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $e6U9j.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $0d0cff1edcf8d867$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $ddwrL.default)());
    var isIE = /Trident/i.test((0, $ddwrL.default)());
    if (isIE && (0, $hWxDy.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $e6U9j.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $2CmGY.default)(element);
    if ((0, $hWxDy.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $hWxDy.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $dVOZH.default)(currentNode)) < 0){
        var css = (0, $e6U9j.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $0d0cff1edcf8d867$export$2e2bcd8739ae039(element) {
    var window = (0, $dhdx1.default)(element);
    var offsetParent = $0d0cff1edcf8d867$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $bY7G8.default)(offsetParent) && (0, $e6U9j.default)(offsetParent).position === 'static')offsetParent = $0d0cff1edcf8d867$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $dVOZH.default)(offsetParent) === 'html' || (0, $dVOZH.default)(offsetParent) === 'body' && (0, $e6U9j.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $0d0cff1edcf8d867$var$getContainingBlock(element) || window;
}

});
parcelRegister("bY7G8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6b411d50df9258$export$2e2bcd8739ae039);

var $dVOZH = parcelRequire("dVOZH");
function $8b6b411d50df9258$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $dVOZH.default)(element)) >= 0;
}

});


parcelRegister("a14yC", function(module, exports) {

$parcel$export(module.exports, "default", () => $74ad88649ff52357$export$2e2bcd8739ae039);

var $97wfz = parcelRequire("97wfz");
function $74ad88649ff52357$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $74ad88649ff52357$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $74ad88649ff52357$var$order(modifiers); // order based on phase
    return (0, $97wfz.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRegister("hJZ5H", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea607085262199c$export$2e2bcd8739ae039);
function $cea607085262199c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("dlKFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b817169ec2e5fb5$export$2e2bcd8739ae039);
function $9b817169ec2e5fb5$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("kimZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d01e35fb2909a8$export$2e2bcd8739ae039);

var $dhdx1 = parcelRequire("dhdx1");
var $03d01e35fb2909a8$var$passive = {
    passive: true
};
function $03d01e35fb2909a8$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $dhdx1.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $03d01e35fb2909a8$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $03d01e35fb2909a8$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $03d01e35fb2909a8$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $03d01e35fb2909a8$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $03d01e35fb2909a8$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $03d01e35fb2909a8$var$effect,
    data: {}
};

});

parcelRegister("aALKT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b624f604164f783$export$2e2bcd8739ae039);

var $8KFuB = parcelRequire("8KFuB");
function $7b624f604164f783$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $8KFuB.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $7b624f604164f783$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $7b624f604164f783$var$popperOffsets,
    data: {}
};

});
parcelRegister("8KFuB", function(module, exports) {

$parcel$export(module.exports, "default", () => $65f2ce26ee70bf81$export$2e2bcd8739ae039);

var $gz8EB = parcelRequire("gz8EB");

var $7Xvdx = parcelRequire("7Xvdx");

var $lrbuJ = parcelRequire("lrbuJ");

var $97wfz = parcelRequire("97wfz");
function $65f2ce26ee70bf81$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $gz8EB.default)(placement) : null;
    var variation = placement ? (0, $7Xvdx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $97wfz.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $97wfz.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $97wfz.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $97wfz.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lrbuJ.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $97wfz.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $97wfz.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("gz8EB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f6a0b5476113a5$export$2e2bcd8739ae039);

function $c0f6a0b5476113a5$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("7Xvdx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cb64235aa6d3d88$export$2e2bcd8739ae039);
function $5cb64235aa6d3d88$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lrbuJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9b509371a942d7f$export$2e2bcd8739ae039);
function $f9b509371a942d7f$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("bFhSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e163dc8333e494$export$2e2bcd8739ae039);

var $97wfz = parcelRequire("97wfz");

var $17t4z = parcelRequire("17t4z");

var $dhdx1 = parcelRequire("dhdx1");

var $kPwvt = parcelRequire("kPwvt");

var $e6U9j = parcelRequire("e6U9j");

var $gz8EB = parcelRequire("gz8EB");

var $7Xvdx = parcelRequire("7Xvdx");

var $p9QXG = parcelRequire("p9QXG");
var $87e163dc8333e494$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $87e163dc8333e494$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $p9QXG.round)(x * dpr) / dpr || 0,
        y: (0, $p9QXG.round)(y * dpr) / dpr || 0
    };
}
function $87e163dc8333e494$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $97wfz.left);
    var sideY = (0, $97wfz.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $17t4z.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $dhdx1.default)(popper)) {
            offsetParent = (0, $kPwvt.default)(popper);
            if ((0, $e6U9j.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $97wfz.top) || (placement === (0, $97wfz.left) || placement === (0, $97wfz.right)) && variation === (0, $97wfz.end)) {
            sideY = (0, $97wfz.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $97wfz.left) || (placement === (0, $97wfz.top) || placement === (0, $97wfz.bottom)) && variation === (0, $97wfz.end)) {
            sideX = (0, $97wfz.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $87e163dc8333e494$var$unsetSides);
    var _ref4 = roundOffsets === true ? $87e163dc8333e494$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $dhdx1.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $87e163dc8333e494$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $gz8EB.default)(state.placement),
        variation: (0, $7Xvdx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $87e163dc8333e494$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $87e163dc8333e494$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $87e163dc8333e494$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $87e163dc8333e494$var$computeStyles,
    data: {}
};

});

parcelRegister("9DiRv", function(module, exports) {

$parcel$export(module.exports, "default", () => $70366328af9caf71$export$2e2bcd8739ae039);

var $dVOZH = parcelRequire("dVOZH");

var $hWxDy = parcelRequire("hWxDy");
// and applies them to the HTMLElements such as popper and arrow
function $70366328af9caf71$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $hWxDy.isHTMLElement)(element) || !(0, $dVOZH.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $70366328af9caf71$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $hWxDy.isHTMLElement)(element) || !(0, $dVOZH.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $70366328af9caf71$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $70366328af9caf71$var$applyStyles,
    effect: $70366328af9caf71$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("6CPUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d2e8ee6595487e5$export$2e2bcd8739ae039);

var $gz8EB = parcelRequire("gz8EB");

var $97wfz = parcelRequire("97wfz");
function $4d2e8ee6595487e5$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $gz8EB.default)(placement);
    var invertDistance = [
        (0, $97wfz.left),
        (0, $97wfz.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $97wfz.left),
        (0, $97wfz.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $4d2e8ee6595487e5$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $97wfz.placements).reduce(function(acc, placement) {
        acc[placement] = $4d2e8ee6595487e5$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4d2e8ee6595487e5$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $4d2e8ee6595487e5$var$offset
};

});

parcelRegister("7qnBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $567d46069a6ea9cd$export$2e2bcd8739ae039);

var $j6AOs = parcelRequire("j6AOs");

var $gz8EB = parcelRequire("gz8EB");

var $bW4Vz = parcelRequire("bW4Vz");

var $3F1jn = parcelRequire("3F1jn");

var $7ZFPX = parcelRequire("7ZFPX");

var $97wfz = parcelRequire("97wfz");

var $7Xvdx = parcelRequire("7Xvdx");
function $567d46069a6ea9cd$var$getExpandedFallbackPlacements(placement) {
    if ((0, $gz8EB.default)(placement) === (0, $97wfz.auto)) return [];
    var oppositePlacement = (0, $j6AOs.default)(placement);
    return [
        (0, $bW4Vz.default)(placement),
        oppositePlacement,
        (0, $bW4Vz.default)(oppositePlacement)
    ];
}
function $567d46069a6ea9cd$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $gz8EB.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $j6AOs.default)(preferredPlacement)
    ] : $567d46069a6ea9cd$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $gz8EB.default)(placement) === (0, $97wfz.auto) ? (0, $7ZFPX.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $gz8EB.default)(placement);
        var isStartVariation = (0, $7Xvdx.default)(placement) === (0, $97wfz.start);
        var isVertical = [
            (0, $97wfz.top),
            (0, $97wfz.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $3F1jn.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $97wfz.right) : (0, $97wfz.left) : isStartVariation ? (0, $97wfz.bottom) : (0, $97wfz.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $j6AOs.default)(mainVariationSide);
        var altVariationSide = (0, $j6AOs.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $567d46069a6ea9cd$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $567d46069a6ea9cd$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("j6AOs", function(module, exports) {

$parcel$export(module.exports, "default", () => $de8b2220512a084d$export$2e2bcd8739ae039);
var $de8b2220512a084d$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $de8b2220512a084d$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $de8b2220512a084d$var$hash[matched];
    });
}

});

parcelRegister("bW4Vz", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b08ef0398607472$export$2e2bcd8739ae039);
var $8b08ef0398607472$var$hash = {
    start: 'end',
    end: 'start'
};
function $8b08ef0398607472$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $8b08ef0398607472$var$hash[matched];
    });
}

});

parcelRegister("3F1jn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa637df16e4da40$export$2e2bcd8739ae039);

var $eQgDJ = parcelRequire("eQgDJ");

var $kPwvt = parcelRequire("kPwvt");

var $gbunM = parcelRequire("gbunM");

var $8KFuB = parcelRequire("8KFuB");

var $g5PeT = parcelRequire("g5PeT");

var $97wfz = parcelRequire("97wfz");

var $hWxDy = parcelRequire("hWxDy");

var $d6XIm = parcelRequire("d6XIm");

var $fUx9z = parcelRequire("fUx9z");
function $2aa637df16e4da40$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $97wfz.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $97wfz.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $97wfz.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $d6XIm.default)(typeof padding !== 'number' ? padding : (0, $fUx9z.default)(padding, (0, $97wfz.basePlacements)));
    var altContext = elementContext === (0, $97wfz.popper) ? (0, $97wfz.reference) : (0, $97wfz.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $eQgDJ.default)((0, $hWxDy.isElement)(element) ? element : element.contextElement || (0, $kPwvt.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gbunM.default)(state.elements.reference);
    var popperOffsets = (0, $8KFuB.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $g5PeT.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $97wfz.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $97wfz.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $97wfz.right),
                (0, $97wfz.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $97wfz.top),
                (0, $97wfz.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("eQgDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace2d45b766d4a99$export$2e2bcd8739ae039);

var $97wfz = parcelRequire("97wfz");

var $4W5F7 = parcelRequire("4W5F7");

var $55elb = parcelRequire("55elb");

var $fH1k9 = parcelRequire("fH1k9");

var $17t4z = parcelRequire("17t4z");

var $kPwvt = parcelRequire("kPwvt");

var $e6U9j = parcelRequire("e6U9j");

var $hWxDy = parcelRequire("hWxDy");

var $gbunM = parcelRequire("gbunM");

var $2CmGY = parcelRequire("2CmGY");

var $a71Jw = parcelRequire("a71Jw");

var $dVOZH = parcelRequire("dVOZH");

var $g5PeT = parcelRequire("g5PeT");

var $p9QXG = parcelRequire("p9QXG");
function $ace2d45b766d4a99$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gbunM.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $ace2d45b766d4a99$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $97wfz.viewport) ? (0, $g5PeT.default)((0, $4W5F7.default)(element, strategy)) : (0, $hWxDy.isElement)(clippingParent) ? $ace2d45b766d4a99$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $g5PeT.default)((0, $55elb.default)((0, $kPwvt.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $ace2d45b766d4a99$var$getClippingParents(element) {
    var clippingParents = (0, $fH1k9.default)((0, $2CmGY.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $e6U9j.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $hWxDy.isHTMLElement)(element) ? (0, $17t4z.default)(element) : element;
    if (!(0, $hWxDy.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $hWxDy.isElement)(clippingParent) && (0, $a71Jw.default)(clippingParent, clipperElement) && (0, $dVOZH.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $ace2d45b766d4a99$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $ace2d45b766d4a99$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $ace2d45b766d4a99$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $p9QXG.max)(rect.top, accRect.top);
        accRect.right = (0, $p9QXG.min)(rect.right, accRect.right);
        accRect.bottom = (0, $p9QXG.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $p9QXG.max)(rect.left, accRect.left);
        return accRect;
    }, $ace2d45b766d4a99$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("4W5F7", function(module, exports) {

$parcel$export(module.exports, "default", () => $3980f89fe1379c0c$export$2e2bcd8739ae039);

var $dhdx1 = parcelRequire("dhdx1");

var $kPwvt = parcelRequire("kPwvt");

var $7oNWS = parcelRequire("7oNWS");

var $2N65T = parcelRequire("2N65T");
function $3980f89fe1379c0c$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $dhdx1.default)(element);
    var html = (0, $kPwvt.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2N65T.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $7oNWS.default)(element),
        y: y
    };
}

});

parcelRegister("55elb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b388b200f67be50$export$2e2bcd8739ae039);

var $kPwvt = parcelRequire("kPwvt");

var $e6U9j = parcelRequire("e6U9j");

var $7oNWS = parcelRequire("7oNWS");

var $8vnMG = parcelRequire("8vnMG");

var $p9QXG = parcelRequire("p9QXG");
function $3b388b200f67be50$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $kPwvt.default)(element);
    var winScroll = (0, $8vnMG.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $p9QXG.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $p9QXG.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $7oNWS.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $e6U9j.default)(body || html).direction === 'rtl') x += (0, $p9QXG.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("a71Jw", function(module, exports) {

$parcel$export(module.exports, "default", () => $75cbe706e110a665$export$2e2bcd8739ae039);

var $hWxDy = parcelRequire("hWxDy");
function $75cbe706e110a665$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $hWxDy.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("g5PeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb74dc03fb0388cb$export$2e2bcd8739ae039);
function $bb74dc03fb0388cb$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("d6XIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $98ba27f1f261d6c9$export$2e2bcd8739ae039);

var $bFzN9 = parcelRequire("bFzN9");
function $98ba27f1f261d6c9$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bFzN9.default)(), paddingObject);
}

});
parcelRegister("bFzN9", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ef4989e7a25091$export$2e2bcd8739ae039);
function $87ef4989e7a25091$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("fUx9z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b955cd8a0ed03342$export$2e2bcd8739ae039);
function $b955cd8a0ed03342$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("7ZFPX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d1eaee2d95cae4d$export$2e2bcd8739ae039);

var $7Xvdx = parcelRequire("7Xvdx");

var $97wfz = parcelRequire("97wfz");

var $3F1jn = parcelRequire("3F1jn");

var $gz8EB = parcelRequire("gz8EB");
function $5d1eaee2d95cae4d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $97wfz.placements) : _options$allowedAutoP;
    var variation = (0, $7Xvdx.default)(placement);
    var placements = variation ? flipVariations ? (0, $97wfz.variationPlacements) : (0, $97wfz.variationPlacements).filter(function(placement) {
        return (0, $7Xvdx.default)(placement) === variation;
    }) : (0, $97wfz.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $3F1jn.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $gz8EB.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("i1We5", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2057c7c5d072608$export$2e2bcd8739ae039);

var $97wfz = parcelRequire("97wfz");

var $gz8EB = parcelRequire("gz8EB");

var $lrbuJ = parcelRequire("lrbuJ");

var $8tNyh = parcelRequire("8tNyh");

var $h7923 = parcelRequire("h7923");

var $3TzO0 = parcelRequire("3TzO0");

var $17t4z = parcelRequire("17t4z");

var $3F1jn = parcelRequire("3F1jn");

var $7Xvdx = parcelRequire("7Xvdx");

var $bFzN9 = parcelRequire("bFzN9");

var $p9QXG = parcelRequire("p9QXG");
function $d2057c7c5d072608$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $3F1jn.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $gz8EB.default)(state.placement);
    var variation = (0, $7Xvdx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lrbuJ.default)(basePlacement);
    var altAxis = (0, $8tNyh.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $97wfz.top) : (0, $97wfz.left);
        var altSide = mainAxis === 'y' ? (0, $97wfz.bottom) : (0, $97wfz.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $97wfz.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $97wfz.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3TzO0.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bFzN9.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $h7923.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $17t4z.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $h7923.within)(tether ? (0, $p9QXG.min)(min, tetherMin) : min, offset, tether ? (0, $p9QXG.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $97wfz.top) : (0, $97wfz.left);
        var _altSide = mainAxis === 'x' ? (0, $97wfz.bottom) : (0, $97wfz.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $97wfz.top),
            (0, $97wfz.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $h7923.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $h7923.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $d2057c7c5d072608$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $d2057c7c5d072608$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("8tNyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c7782831a1a283$export$2e2bcd8739ae039);
function $62c7782831a1a283$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("h7923", function(module, exports) {

$parcel$export(module.exports, "within", () => $c75a18b8745c1b31$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $c75a18b8745c1b31$export$86c8af6d3ef0b4a);

var $p9QXG = parcelRequire("p9QXG");
function $c75a18b8745c1b31$export$f28d906d67a997f3(min, value, max) {
    return (0, $p9QXG.max)(min, (0, $p9QXG.min)(value, max));
}
function $c75a18b8745c1b31$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $c75a18b8745c1b31$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("i7KKQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d31d25f1d078a46d$export$2e2bcd8739ae039);

var $gz8EB = parcelRequire("gz8EB");

var $3TzO0 = parcelRequire("3TzO0");

var $a71Jw = parcelRequire("a71Jw");

var $17t4z = parcelRequire("17t4z");

var $lrbuJ = parcelRequire("lrbuJ");

var $h7923 = parcelRequire("h7923");

var $d6XIm = parcelRequire("d6XIm");

var $fUx9z = parcelRequire("fUx9z");

var $97wfz = parcelRequire("97wfz");
var $d31d25f1d078a46d$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $d6XIm.default)(typeof padding !== 'number' ? padding : (0, $fUx9z.default)(padding, (0, $97wfz.basePlacements)));
};
function $d31d25f1d078a46d$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $gz8EB.default)(state.placement);
    var axis = (0, $lrbuJ.default)(basePlacement);
    var isVertical = [
        (0, $97wfz.left),
        (0, $97wfz.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $d31d25f1d078a46d$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3TzO0.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $97wfz.top) : (0, $97wfz.left);
    var maxProp = axis === 'y' ? (0, $97wfz.bottom) : (0, $97wfz.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $17t4z.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $h7923.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $d31d25f1d078a46d$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $a71Jw.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $d31d25f1d078a46d$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $d31d25f1d078a46d$var$arrow,
    effect: $d31d25f1d078a46d$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("96zAb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a10468b1c3c4d1e$export$2e2bcd8739ae039);

var $97wfz = parcelRequire("97wfz");

var $3F1jn = parcelRequire("3F1jn");
function $6a10468b1c3c4d1e$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $6a10468b1c3c4d1e$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $97wfz.top),
        (0, $97wfz.right),
        (0, $97wfz.bottom),
        (0, $97wfz.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $6a10468b1c3c4d1e$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $3F1jn.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $3F1jn.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $6a10468b1c3c4d1e$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $6a10468b1c3c4d1e$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $6a10468b1c3c4d1e$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $6a10468b1c3c4d1e$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $6a10468b1c3c4d1e$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $6a10468b1c3c4d1e$var$hide
};

});




parcelRegister("2UrTs", function(module, exports) {

$parcel$export(module.exports, "getMaxSizeModifiers", () => $6d3c05df716a15ac$export$6d8c2b45c99d6e3f);
function $6d3c05df716a15ac$export$6d8c2b45c99d6e3f({ viewportPadding: viewportPadding }) {
    return [
        {
            /**
			 * Performing DOM measurements in the 'read' phase,
			 * which is the convention for popper modifiers
			 */ name: 'maxSizeData',
            enabled: true,
            phase: 'read',
            fn ({ state: state, name: name }) {
                if (!window.visualViewport) return;
                state.modifiersData[name] = {
                    viewport: {
                        width: window.visualViewport.width,
                        height: window.visualViewport.height
                    }
                };
            }
        },
        {
            /**
			 * Applying max size CSS
			 */ name: 'maxSize',
            enabled: true,
            phase: 'beforeWrite',
            requiresIfExists: [
                'offset',
                'preventOverflow',
                'flip'
            ],
            fn ({ state: state }) {
                const data = state.modifiersData.maxSizeData;
                if (typeof data?.viewport?.width !== 'number' || typeof data?.viewport?.height !== 'number') // This shouldn't occur in a real browser but might in non-browser test environments
                return;
                const { viewport: viewport } = data;
                const { popperOffsets: popperOffsets = {
                    x: 0,
                    y: 0
                } } = state.modifiersData;
                const [basePlacement] = state.placement.split('-');
                const placementOffset = state.modifiersData?.offset?.[state.placement] ?? {
                    x: 0,
                    y: 0
                };
                // By default we set these to the entire viewport (minus padding)
                // Each placement direction will overwrite one of these
                let maxWidth = viewport.width - 2 * viewportPadding;
                let maxHeight = viewport.height - 2 * viewportPadding;
                if (basePlacement === 'top') maxHeight = state.rects.reference.y + // Viewport-relative position of reference element
                placementOffset.y - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'bottom') maxHeight = viewport.height - popperOffsets.y - // Viewport-relative position of popper
                viewportPadding;
                if (basePlacement === 'left') maxWidth = state.rects.reference.x + // Viewport-relative position of reference element
                placementOffset.x - // Space between popper and reference
                viewportPadding;
                if (basePlacement === 'right') maxWidth = viewport.width - popperOffsets.x - // Viewport-relative position of popper
                viewportPadding;
                state.styles.popper.maxWidth = `${maxWidth}px`;
                state.styles.popper.maxHeight = `${maxHeight}px`;
            }
        }
    ];
}

});


parcelRegister("1V7PR", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $1661314902be058d$export$e0be378c32fb70a7);

var $5uXOq = parcelRequire("5uXOq");

var $hBYjV = parcelRequire("hBYjV");

var $gkD4s = parcelRequire("gkD4s");

var $wofBo = parcelRequire("wofBo");
function $1661314902be058d$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5uXOq.useContext((0, $gkD4s.ManagerReferenceNodeSetterContext));
    var refHandler = $5uXOq.useCallback(function(node) {
        (0, $wofBo.setRef)(innerRef, node);
        (0, $wofBo.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5uXOq.useEffect(function() {
        return function() {
            return (0, $wofBo.setRef)(innerRef, null);
        };
    }, []);
    $5uXOq.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $wofBo.unwrapArray)(children)({
        ref: refHandler
    });
}

});


parcelRegister("cb25w", function(module, exports) {

$parcel$export(module.exports, "default", () => $93241812d65154b9$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $lx3fW = parcelRequire("lx3fW");
const $93241812d65154b9$var$withAnalyticsEvents = (createEventMap = {})=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
            const { patchedEventProps: patchedEventProps } = (0, $lx3fW.usePatchedProps)(createEventMap, props);
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
            return /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                ...props,
                ...patchedEventProps,
                createAnalyticsEvent: createAnalyticsEvent,
                ref: ref
            });
        });
        WithAnalyticsEvents.displayName = `WithAnalyticsEvents(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsEvents;
    };
var $93241812d65154b9$export$2e2bcd8739ae039 = $93241812d65154b9$var$withAnalyticsEvents;

});
parcelRegister("lx3fW", function(module, exports) {

$parcel$export(module.exports, "usePatchedProps", () => $af59609096db92b0$export$9ebb5a84d17e5d18);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");
function $af59609096db92b0$export$9ebb5a84d17e5d18(createEventMap = {}, wrappedComponentProps) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handlerCache = (0, $5uXOq.useRef)({});
    const patchedProps = (0, $5uXOq.useMemo)(()=>{
        const cache = handlerCache.current;
        // Clean up no longer used handlers in cache
        Object.keys(cache).filter((key)=>!(key in createEventMap)).forEach((key)=>delete cache[key]);
        return Object.keys(createEventMap).reduce((p, k)=>{
            const eventCreator = createEventMap[k];
            if (![
                'object',
                'function'
            ].includes(typeof eventCreator)) return p;
            const propValue = wrappedComponentProps[k];
            if (k in cache && cache[k].eventCreator === eventCreator && cache[k].propValue === propValue) return {
                ...p,
                [k]: cache[k].wrappedCallback
            };
            const wrappedCallback = (...args)=>{
                const analyticsEvent = typeof eventCreator === 'function' ? eventCreator(createAnalyticsEvent, wrappedComponentProps) : createAnalyticsEvent(eventCreator);
                if (propValue && typeof propValue === 'function') propValue(...args, analyticsEvent);
            };
            cache[k] = {
                eventCreator: eventCreator,
                wrappedCallback: wrappedCallback,
                propValue: propValue
            };
            return {
                ...p,
                [k]: wrappedCallback
            };
        }, {});
    }, [
        createEventMap,
        wrappedComponentProps,
        createAnalyticsEvent,
        handlerCache
    ]);
    return {
        patchedEventProps: patchedProps
    };
}

});


parcelRegister("cVP8B", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafSyntheticEventHandler", () => $3eb7d2a0087c7f04$export$1a04351537078b55);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $lwCsy = parcelRequire("lwCsy");
function $3eb7d2a0087c7f04$export$1a04351537078b55({ fn: fn, action: action, componentName: componentName, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $lwCsy.useTrackedRef)(analyticsData);
    const fnRef = (0, $lwCsy.useTrackedRef)(fn);
    const handler = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});

parcelRegister("2zyAl", function(module, exports) {
$parcel$export(module.exports, "getGlobalObject", () => (parcelRequire("eUO5L")).getGlobalObject);
$parcel$export(module.exports, "getGlobalSingleton", () => (parcelRequire("eUO5L")).getGlobalSingleton);
$parcel$export(module.exports, "isPlainObject", () => (parcelRequire("okkfE")).isPlainObject);
$parcel$export(module.exports, "isThenable", () => (parcelRequire("okkfE")).isThenable);
$parcel$export(module.exports, "consoleSandbox", () => (parcelRequire("aHQIJ")).consoleSandbox);
$parcel$export(module.exports, "logger", () => (parcelRequire("aHQIJ")).logger);
$parcel$export(module.exports, "uuid4", () => (parcelRequire("1vYJz")).uuid4);
$parcel$export(module.exports, "dropUndefinedKeys", () => (parcelRequire("59M0S")).dropUndefinedKeys);
$parcel$export(module.exports, "SyncPromise", () => (parcelRequire("4mVTs")).SyncPromise);





parcelRequire("eUO5L");

parcelRequire("okkfE");
parcelRequire("aHQIJ");

parcelRequire("1vYJz");

var $3kiq9 = parcelRequire("3kiq9");

parcelRequire("59M0S");







parcelRequire("4mVTs");

var $gI8Be = parcelRequire("gI8Be");





$parcel$exportWildcard(module.exports, $3kiq9);
$parcel$exportWildcard(module.exports, $gI8Be);

});

parcelRegister("dS3PR", function(module, exports) {

$parcel$export(module.exports, "default", () => $146059eba2d812e5$export$2e2bcd8739ae039);
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3joPi = parcelRequire("3joPi");

var $d1fMa = parcelRequire("d1fMa");

var $aCkBt = parcelRequire("aCkBt");
const $146059eba2d812e5$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $146059eba2d812e5$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $aCkBt.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($146059eba2d812e5$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $146059eba2d812e5$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
const $146059eba2d812e5$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pmoej",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $146059eba2d812e5$var$fontSizeMap = {
    medium: "_11c82smr",
    UNSAFE_small: "_11c8dcr7",
    large: "_11c81ixg",
    small: "_11c81o8v"
};
const $146059eba2d812e5$var$fontWeightMap = {
    bold: "_k48pmoej",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $146059eba2d812e5$var$textColorMap = {
    'color.text': "_syaz1fxt",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syaz1q28",
    'color.text.accent.orange.bolder': "_syaz1vps",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syazpnps",
    'color.text.accent.blue.bolder': "_syazsc1o",
    'color.text.accent.purple': "_syaz10m5",
    'color.text.accent.purple.bolder': "_syaz2ibx",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1dyx",
    'color.text.accent.gray.bolder': "_syaz1x9z",
    'color.text.disabled': "_syaz1lh4",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syazaqb7",
    'color.text.brand': "_syaz1e6v",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syazwx40",
    'color.text.warning.inverse': "_syazal3n",
    'color.text.success': "_syazy73q",
    'color.text.discovery': "_syazzjem",
    'color.text.information': "_syaze0os",
    'color.text.subtlest': "_syaz131l",
    'color.text.subtle': "_syaz1gjq",
    'color.link': "_syaz14q2",
    'color.link.pressed': "_syaz16c2",
    'color.link.visited': "_syazw7te",
    'color.link.visited.pressed': "_syazg3x0"
};
const $146059eba2d812e5$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $146059eba2d812e5$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $3joPi.default)($146059eba2d812e5$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $d1fMa.useHasTextAncestor)();
    const color = $146059eba2d812e5$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        className: (0, $bwpsq.default)([
            $146059eba2d812e5$var$styles.root,
            size && $146059eba2d812e5$var$fontSizeMap[size],
            color && $146059eba2d812e5$var$textColorMap[color],
            maxLines && $146059eba2d812e5$var$styles.truncation,
            maxLines === 1 && $146059eba2d812e5$var$styles.breakAll,
            align && $146059eba2d812e5$var$styles[`textAlign.${align}`],
            weight && $146059eba2d812e5$var$fontWeightMap[weight],
            Component === 'em' && $146059eba2d812e5$var$styles['as.em'],
            Component === 'strong' && $146059eba2d812e5$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $d1fMa.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
var $146059eba2d812e5$export$2e2bcd8739ae039 = $146059eba2d812e5$var$Text;

});
parcelRegister("d1fMa", function(module, exports) {

$parcel$export(module.exports, "useHasTextAncestor", () => $e387a05b670c124a$export$9322276ec105d055);
$parcel$export(module.exports, "HasTextAncestorProvider", () => $e387a05b670c124a$export$ae933c6cbe5643ad);

var $5uXOq = parcelRequire("5uXOq");
const $e387a05b670c124a$var$HasTextAncestorContext = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const $e387a05b670c124a$export$9322276ec105d055 = ()=>(0, $5uXOq.useContext)($e387a05b670c124a$var$HasTextAncestorContext);
const $e387a05b670c124a$export$ae933c6cbe5643ad = $e387a05b670c124a$var$HasTextAncestorContext.Provider;

});


parcelRegister("994MI", function(module, exports) {

$parcel$export(module.exports, "default", () => $93786d4ed2b94d9c$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");
const $93786d4ed2b94d9c$var$withAnalyticsContext = (defaultData)=>(WrappedComponent)=>{
        const WithAnalyticsContext = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ analyticsContext: analyticsContext, ...rest }, ref)=>{
            const analyticsData = (0, $5uXOq.useMemo)(()=>({
                    ...defaultData,
                    ...analyticsContext
                }), [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $daJ0i.default), {
                data: analyticsData,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(WrappedComponent, {
                    ...rest,
                    ref: ref
                })
            });
        });
        WithAnalyticsContext.displayName = `WithAnalyticsContext(${WrappedComponent.displayName || WrappedComponent.name})`;
        return WithAnalyticsContext;
    };
var $93786d4ed2b94d9c$export$2e2bcd8739ae039 = $93786d4ed2b94d9c$var$withAnalyticsContext;

});

parcelRegister("hTEpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a454c0db54bdc1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $ldJSL = parcelRequire("ldJSL");

var $l1N8i = parcelRequire("l1N8i");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $eZJjh = parcelRequire("eZJjh");

var $eboXC = parcelRequire("eboXC");
var $iHZ3d = parcelRequire("iHZ3d");
var $k3Y68 = parcelRequire("k3Y68");
var $bhzfi = parcelRequire("bhzfi");
/**
 * __Empty state__
 *
 * A component used for presenting various empty states.
 * e.g. (no items, empty search, broken link, welcome screen etc.)
 *
 * @example
 * ```tsx
 * import EmptyState from '@atlaskit/empty-state';
 *
 * // An example of a 404 state
 * export default () => {
 *  <EmptyState
 *   header="Page not found"
 *   imageUrl="https://cdn.io/images/404"
 *   description="Looks like you've stumbled off track. Sorry about that! This page either doesn't exist or has been removed."
 *   primaryAction={<Button appearance="primary">Home Page</Button>}
 *   secondaryAction={<Button>Report a problem</Button>}
 *  />;
 * };
 * ```
 */ const $42a454c0db54bdc1$var$EmptyState = ({ buttonGroupLabel: buttonGroupLabel, description: description, header: header, headingLevel: headingLevel = 4, imageHeight: imageHeight, imageUrl: imageUrl, imageWidth: imageWidth, isLoading: isLoading, maxImageHeight: maxImageHeight = 160, maxImageWidth: maxImageWidth = 160, primaryAction: primaryAction, renderImage: renderImage, secondaryAction: secondaryAction, width: width, size: size, tertiaryAction: tertiaryAction, testId: testId })=>{
    const actionsContainer = primaryAction || secondaryAction || isLoading ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eboXC.default), {
        children: [
            primaryAction && secondaryAction ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ldJSL.default), {
                label: buttonGroupLabel || 'Button group',
                testId: testId && `${testId}-button-group`,
                children: [
                    secondaryAction,
                    primaryAction
                ]
            }) : primaryAction || secondaryAction,
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bhzfi.default), {
                children: isLoading && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZJjh.default), {
                    testId: "empty-state-spinner"
                })
            })
        ]
    }) : null;
    const tag = `h${headingLevel > 0 && headingLevel < 7 ? headingLevel : headingLevel > 6 ? 6 : 4}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $iHZ3d.default), {
        testId: testId,
        width: width || size || 'wide',
        children: [
            imageUrl ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k3Y68.default), {
                src: imageUrl,
                maxWidth: maxImageWidth,
                maxHeight: maxImageHeight,
                width: imageWidth,
                height: imageHeight
            }) : renderImage && renderImage({
                maxImageWidth: maxImageWidth,
                maxImageHeight: maxImageHeight,
                imageWidth: imageWidth,
                imageHeight: imageHeight
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                paddingBlockEnd: "space.200",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                    size: "medium",
                    as: tag,
                    children: header
                })
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                paddingBlockEnd: "space.300",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    as: "p",
                    children: description
                })
            }),
            actionsContainer,
            tertiaryAction
        ]
    });
};
var $42a454c0db54bdc1$export$2e2bcd8739ae039 = $42a454c0db54bdc1$var$EmptyState;

});
parcelRegister("eboXC", function(module, exports) {

$parcel$export(module.exports, "default", () => $98005597d42c3128$export$2e2bcd8739ae039);
/* actions-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $98005597d42c3128$var$actionsStyles = null;
/**
 * __Actions container__
 *
 * A container for actions: primary action, secondary action, and tertiary action.
 *
 * @internal
 */ const $98005597d42c3128$var$ActionsContainer = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _6rthu2gc _bozg1jfw"
        ]),
        children: children
    });
var $98005597d42c3128$export$2e2bcd8739ae039 = $98005597d42c3128$var$ActionsContainer;

});

parcelRegister("iHZ3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $6104374da99ebaf9$export$2e2bcd8739ae039);
/* container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $6104374da99ebaf9$var$containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */ const $6104374da99ebaf9$var$wideContainerStyles = null;
const $6104374da99ebaf9$var$narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */ const $6104374da99ebaf9$var$Container = ({ children: children, width: width, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_6rthoahv _1pfhoahv _12l21wug _ahbq1wug _y3gn1h6o",
            width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"
        ]),
        children: children
    });
var $6104374da99ebaf9$export$2e2bcd8739ae039 = $6104374da99ebaf9$var$Container;

});

parcelRegister("k3Y68", function(module, exports) {

$parcel$export(module.exports, "default", () => $e48bf8f746beecd2$export$2e2bcd8739ae039);
/* image.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $e48bf8f746beecd2$var$CSS_VAR_MAX_WIDTH = '--max-width';
const $e48bf8f746beecd2$var$CSS_VAR_MAX_HEIGHT = '--max-height';
const $e48bf8f746beecd2$var$imageStyles = null;
/**
 * __Image__
 *
 * Image in Empty State.
 *
 * @internal
 */ const $e48bf8f746beecd2$var$Image = ({ maxHeight: maxHeight, maxWidth: maxWidth, height: height = 'auto', width: width = 'auto', src: src })=>/*#__PURE__*/ (0, $2OMIu.jsx)("img", {
        style: {
            [$e48bf8f746beecd2$var$CSS_VAR_MAX_WIDTH]: `${maxWidth}px`,
            [$e48bf8f746beecd2$var$CSS_VAR_MAX_HEIGHT]: `${maxHeight}px`
        },
        width: width,
        height: height,
        alt: "",
        role: "presentation",
        src: src,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _p12fnzqo _c71l8wry _6rth1ejb _1pfhidpf _12l21wug _ahbq1wug"
        ])
    });
var $e48bf8f746beecd2$export$2e2bcd8739ae039 = $e48bf8f746beecd2$var$Image;

});

parcelRegister("bhzfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $014f73dca8fea7c1$export$2e2bcd8739ae039);
/* spinner-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $014f73dca8fea7c1$var$spinnerContainerStyles = null;
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */ const $014f73dca8fea7c1$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1bsb1ejb _ahbqpxbi"
        ]),
        children: children
    });
var $014f73dca8fea7c1$export$2e2bcd8739ae039 = $014f73dca8fea7c1$var$SpinnerContainer;

});


parcelRegister("c543i", function(module, exports) {

$parcel$export(module.exports, "useCallbackWithAnalytics", () => $9894737c1354069d$export$53c2b9c37c40e0d8);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $lwCsy = parcelRequire("lwCsy");
const $9894737c1354069d$export$53c2b9c37c40e0d8 = (method, payload, channel)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const methodRef = (0, $lwCsy.useTrackedRef)(method);
    const payloadRef = (0, $lwCsy.useTrackedRef)(payload);
    return (0, $5uXOq.useCallback)((...args)=>{
        const pload = typeof payloadRef.current === 'function' ? payloadRef.current(...args) : payloadRef.current;
        createAnalyticsEvent(pload).fire(channel);
        methodRef.current(...args);
    }, [
        createAnalyticsEvent,
        methodRef,
        payloadRef,
        channel
    ]);
};

});

parcelRegister("gB4mS", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcab6d58b6ba0e28$export$2e2bcd8739ae039);
var $bcab6d58b6ba0e28$export$2e2bcd8739ae039 = (channel)=>(payload)=>(createAnalyticsEvent)=>{
            const consumerEvent = createAnalyticsEvent(payload);
            const clonedEvent = consumerEvent.clone();
            if (clonedEvent) clonedEvent.fire(channel);
            return consumerEvent;
        };

});

parcelRegister("3RZIb", function(module, exports) {

$parcel$export(module.exports, "fontFallback", () => $c837d93629398b7c$export$2a99220fb32ec798);
/**
 * Font token fallbacks are verbose.
 * This object exists purely to make using fallbacks less cumbersome while we still need to use them.
 * Will be removed once fallbacks are no longer needed.
 *
 * This is referenced by the use-tokens-typography ESLint rule.
 */ const $c837d93629398b7c$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif'
    }
};

});

parcelRegister("lj3s5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf1f5d10e546f25$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $3yqGI = parcelRequire("3yqGI");

var $kwHHJ = parcelRequire("kwHHJ");

var $5Vn4e = parcelRequire("5Vn4e");
class $5cf1f5d10e546f25$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { data: data, children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        const isModernContext = (0, $3yqGI.default) || (0, $VSDnB.fg)('analytics-next-use-modern-context_jira');
        if (hasError) {
            if (ErrorComponent) {
                if (isModernContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Vn4e.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorComponent, {})
                });
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kwHHJ.default), {
                    data: data,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(ErrorComponent, {})
                });
            }
            return null;
        }
        if (isModernContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5Vn4e.default), {
            data: data,
            children: children
        });
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kwHHJ.default), {
            data: data,
            children: children
        });
    }
}

});


$parcel$global.rlb("hPzOn")
//# sourceMappingURL=shared~vendor~atlaskit~ar.b42932fd.js.map
